

import * as THREE from "./engines/three/three.module.js";
import { TransformationLerp, TransformationLerpRaw, QuaternionLerp, BoneLerp, ShotLerp } from './engines/transform.js';
export const meshsInfos = {
    'car2': { suspensionRestLength: 0.6,  wheelOffset : -0.3,chassisOffset: 0.3,rollInfluence: 0.5, wheelRadius: 0.3, wheelWidth: 0.2, extents: { size: { x: 1.5025140047073364, y: 1.2076700329780579, z: 3.6953179836273193 }, center: { x: 0, y: 0.18090900778770447, "z": -0.19572603702545166 } } },
    'car3': { suspensionRestLength: 0.4, wheelOffset : -0.4, chassisOffset: 0.3,rollInfluence: 0.1, wheelRadius: 0.3, wheelWidth: 0.2, extents: { "size": { "x": 1.7839179635047913, "y": 1.4801300466060638, "z": 4.243614077568054 }, "center": { "x": 0.0356920063495636, "y": 0.4461500197649002, "z": -0.18802005052566528 } } },
    'cocc': { suspensionRestLength: 0.38, wheelOffset : -0.4, chassisOffset: 0.35,rollInfluence: 0.1, wheelRadius: 0.3, wheelWidth: 0.2, extents: { "size": { "x": 1.7839179635047913, "y": 1.4801300466060638, "z": 4.243614077568054 }, "center": { "x": 0.0356920063495636, "y": 0.4461500197649002, "z": -0.18802005052566528 } } },
    'davinci': { suspensionRestLength: 0.35,  wheelOffset : -0.6, chassisOffset: 0.45,rollInfluence: 0.1, wheelRadius: 0.3, wheelWidth: 0.2, extents: {"size":{"x":2.208293914794922,"y":1.390595018863678,"z":4.746110916137695},"center":{"x":0.010540008544921875,"y":0.43492050766944885,"z":0.011483430862426758}}  },
    'car4': { suspensionRestLength: 0.2, wheelOffset : -0.37,chassisOffset: 0.2, rollInfluence: 0.1, wheelRadius: 0.3, wheelWidth: 0.2, extents: {"size":{"x":1.6293750405311584,"y":2.82656010389328,"z":4.924730062484741},"center":{"x":0.00014850497245788574,"y":0.17746801674365997,"z":0.08306896686553955} } },
    'viper': { suspensionRestLength: 0.22, wheelOffset : -0.37,chassisOffset: 0.23, rollInfluence: 0.1, wheelRadius: 0.3, wheelWidth: 0.2, extents: {"size":{"x":1.6293750405311584,"y":2.82656010389328,"z":4.924730062484741},"center":{"x":0.00014850497245788574,"y":0.17746801674365997,"z":0.08306896686553955} } },
    'wuf':       { suspensionRestLength: 0.55,  wheelOffset : -0.95, chassisOffset: 0.80, rollInfluence: 0.10, wheelRadius: 0.3, wheelWidth: 0.2, extents: {"size":{"x":2.208293914794922,"y":1.80595018863678,"z":4.746110916137695},"center":{"x":0.010540008544921875,"y":0.2,"z":0.011483430862426758}}  },
    'buggy': { suspensionRestLength: 0.6,  wheelOffset : -0.54, chassisOffset: 0.4, rollInfluence: 0.1, wheelRadius: 0.3, wheelWidth: 0.2, extents: {"size":{"x":1.8637139797210693,"y":1.4713420271873474,"z":3.3001660108566284},"center":{"x":0.02195298671722412,"y":0.2144699990749359,"z":0.14179998636245728}} },
    'car5': { suspensionRestLength: 0.2, wheelOffset : -0.2,rollInfluence: 0.1, wheelRadius: 0.3, wheelWidth: 0.2, extents: { "size": { "x": 1.7839179635047913, "y": 1.4801300466060638, "z": 4.243614077568054 }, "center": { "x": 0.0356920063495636, "y": 0.4461500197649002, "z": -0.18802005052566528 } } },
    'buggyB': { suspensionRestLength: 0.7, wheelOffset : -0.2,chassisOffset: 0.3, rollInfluence: 0.4, wheelRadius: 0.4, wheelWidth: 0.4, "extents":{"size":{"x":2.062350034713745,"y":1.6933359801769257,"z":3.5725300312042236},"center":{"x":0.03965401649475098,"y":0.4374619871377945,"z":-0.12764596939086914}} },
    'lambo': { suspensionRestLength: 0.4, wheelOffset : -0.2,chassisOffset: 0.3,rollInfluence: 0.5, wheelRadius: 0.5, wheelWidth: 0.4, extents: { "size": { "x": 2.007147967815399, "y": 1.115267038345337, "z": 4.371685147285461 }, "center": { "x": 0.0113619863986969, "y": 0.08561050891876221, "z": 0.3787035346031189 } } },
    'toradyne': { suspensionRestLength: 0.5, wheelOffset : -0.2,chassisOffset: 0.3,rollInfluence: 0.5, wheelRadius: 0.5, wheelWidth: 0.4, "extents":{"size":{"x":1.761555016040802,"y":1.4558629989624023,"z":3.878015160560608},"center":{"x":0.0038565099239349365,"y":0.20069849491119385,"z":-0.07079952955245972}} }
};


const PLANE_EPSILON = 0.1;
const SplitArray = 
[   [[[0, 1 , 2]], []],                                 //0
    [[[0, 1 , 2]], []],                                 //1  
    [[[0, 4, 5], [0, 1, 4]], [[2, 5 , 4]]],             //2  
    [[], []],                                       //3  
    [[[0, 1 , 2]], []],                                 //4  
    [[[0, 1 , 2]], []],                                 //5  
    [[[0, 1 , 5]], [[1, 2, 5]]],                        //6  
    [[], []],                                        //7  
    [[[2, 3, 4],[2, 0, 3]], [[1, 4 , 3]]],              //8  
    [[[2, 0, 3]], [[1, 2 , 3]]],                        //9 
    [[[0, 3, 5]], [[1, 5 , 3], [1, 2 , 5]]],            //10 
    [[], []],                                       //11  
    [[], []],                                       //12
    [[], []],                                       //13
    [[], []],                                       //14
    [[], []],                                       //15
    [[[0, 1 , 2]], []],                                 //16
    [[[0, 1 , 2]], []],                                 //17
    [[[0, 1 , 4]], [[2, 0, 4]]],                          //18
    [[], []],                                       //19
    [[[0, 1 , 2]], []],                                 //20
    [[[0, 1 , 2]], [[0, 1 , 2]]],                       //21 on triangle
    [[], [[0, 1 , 2]]],                                 //22
    [[], []],                                       //23  
    [[[2, 0, 4]], [[0, 1, 4]]],                         //24  
    [[], [[0, 1 , 2]]],                                 //25
    [[], [[0, 1 , 2]]],                                 //26
    [[], []],                                       //27
    [[], []],                                       //28
    [[], []],                                       //29
    [[], []],                                       //30
    [[], []],                                       //31
    [[[1, 5, 3], [1, 2, 5]], [[0, 3, 5]]],              //32
    [[[1, 2, 3]], [[2, 0, 3]]],                         //33  
    [[[1, 4, 3]], [[0, 3, 4], [2, 0, 4]]],              //34
    [[], []],                                       //35
    [[[1, 2, 5]], [[0, 1, 5]]],                         //36
    [[], [[0, 1 , 2]]],                                 //37
    [[], [[0, 1 , 2]]],                                 //38
    [[], []],                                       //39
    [[[2, 5, 4]], [[0, 4, 5], [0, 1, 4]]],              //40
    [[], [[0, 1 , 2]]],                                 //41
    [[], [[0, 1 , 2]]]                                   //42
];
const freecars = [0, 1];
const keysActions = {
    "KeyW": 'acceleration',
    "KeyS": 'braking',
    "KeyA": 'left',
    "KeyD": 'right',
    "KeyC": 'camera',
    "KeyE": 'activate',
    "KeyX": 'exit',
    "KeyL": "light",
    "KeyR": "next-target",
    "KeyF": "next-subsystem",
    "ArrowUp": 'acceleration',
    "ArrowDown": 'braking',
    "ArrowLeft": 'left',
    "ArrowRight": 'right',
    "ControlLeft": "nitro",
    "ControlRight": "nitro",
    "ShiftLeft": "shoot0",
    "ShiftRight": "shoot0",
    "btn0": 'acceleration',
    "btn1": 'braking',
    "btn2": "nitro",
    "btn3": "nitro",
    "btn4": "activate",
    "btn7": 'camera',
    "btn8": 'camera',
    "btn9": 'camera',
    "axis0-": 'left',
    "axis0+": 'right',
    "axis9-": 'left',
    "axis9+": 'right'
};


export const statKeysC = { "compression": { max: 5.0 }, 'damping': { max: 5.0 }, 'stiffness': { max: 120.0 }, 'friction': { max: 4.0 }, 'force': { max: 12000 } };
export const statKeysB = { "compression": { max: 8.0 }, 'damping': { max: 8.0 }, 'stiffness': { max: 240.0 }, 'friction': { max: 8.0 }, 'force': { max: 50000 } };
export const statKeysA = { "compression": { max: 12.0 }, 'damping': { max: 12.0 }, 'stiffness': { max: 240.0 }, 'friction': { max: 12.0 }, 'force': { max: 50000 } };

export const statKeysNULL = { "compression": { max: '-' }, 'damping': { max: '-' }, 'stiffness': { max: '-' }, 'friction': { max: '-' }, 'force': { max: '-' } };

export function getStatKeys(carDef){
    
    if ((carDef.chassis == "car3") || (carDef.chassis == "car4") || (carDef.chassis == "buggy")|| (carDef.chassis == "davinci")|| (carDef.chassis == "viper")) {
        return statKeysC;
    } else if ((carDef.chassis == "lambo") || (carDef.chassis == "buggyB") || (carDef.chassis == "terradyne")) {
        return statKeysB;
    } else if (carDef.chassis == "car5") {
        return statKeysA;
    }

    return statKeysNULL;
}

const CAR_DAMAGE_SCHEMA ={struct: {time: "u32", damage : "u32" }};
const CONFIG_SCHEMA ={struct: {repair_time: "u32", steel_per_up : "u32" , per : "f32", nitro_price: "f32" }};

const demo_cars = { testnet: ['ALHQTTUeXVaqYuGhs4RmD3fHYmCDs73uVwMe41eGb7r8', '9VK71am93GTvToWwwHLPVzAvfM5FsPKgvcVoS4xYF8F9', 'GcUiefqhTPy1cxG1hqsnihi8R1MmArAuHnHY42cfvv7V' , 'HbicjdBx82pfEGkvN9PQEwezyuryPiRq2crghDycouAJ'], 
                    mainnet : []};
const demo_cars_wax = { testnet: [100000000082127], 
                        mainnet : [100000020302794]};

const ai_cars_wax = { testnet: ["100000000082118", "100000000082119", "100000000082137" ], 
                      mainnet : ["100000020302794", "100000020302795"]};
    const METADATA_CREATOR_SCHEMA = {   struct : 
        {   
            address: "pubkey", 
            verified: "bool", 
            share: "u8"
        }
    }
    const METADATA_COLLECTION_SCHEMA ={ struct : 
        {
        'verified' : 'bool',
        'key' : 'pubkey'
        }
    };

    const METADATA_MAIN_SCHEMA = { 
        struct : 
        {    
            key: "u8", 
            updateAuthority : "pubkey",
            mint:"pubkey",
            name: "string", 
            symbol: "string", 
            uri: "string", 
            sellerFeeBasisPoints : "u16",
            toto : "u8",
            creators: { array : {type : METADATA_CREATOR_SCHEMA} },
            primarySaleHappened  : "u8",
            isMutable  : "u8",
            editionNonce  : "u8",
            tokenStandard  : "u32",
            collection  : METADATA_COLLECTION_SCHEMA,

        }
    }

    const METADATA_MOTOR_SCHEMA = {
        struct : {
          /// tire mint
          mint: 'pubkey',
          /// class
          class: 'u8',
          ///  motor name
          name: { array: { type: 'i8', len: 16 }},
          ///  motor object
          motor: { array: { type: 'i8' , len: 16}},
          /// motor power
          power: 'f32',
          /// motor braking
          braking: 'f32' , 
          /// nitro factor
          nitro: 'f32' , 
          /// engine factor a
          a: 'f32' , 
          /// engine factor a
          b: 'f32' , 
          /// engine factor a
          c: 'f32' 

        }
      }
      
      const METADATA_TIRE_SCHEMA = {
        struct : {
          /// tire mint
          mint: 'pubkey',
          /// class
          class: 'u8',
          /// name of the tire
          name: { array: { type: 'i8' , len: 16}},
          /// mesh object
          tire:  { array: { type: 'i8' , len: 16}},
          /// compression force
          force: 'f32',
          /// shock absorbder stiffness
          stiffness: 'f32',
          /// shock absorbder compression speed
          compression: 'f32',
          /// shock absorbder damping speed
          damping: 'f32',
          /// shock absorbder friction
          friction: 'f32',
          /// tire width
          width: 'f32',
          /// tire radius
          radius: 'f32'

        }
      }
      
      const METADATA_CAR_SCHEMA = {
          struct : {
            /// car mint
            mint: 'pubkey',
            /// class
            class: 'u8',
            /// car name
            name: { array: { type: 'i8' , len: 16}},
            /// car object
            chassis: { array: { type: 'i8' , len: 16}},
            /// mass
            massvehicle: 'u32',
            /// max steering
            steeringclamp: 'f32',
            /// steering speed
            steeringincrement: 'f32',
            /// max damage
            maxdmg: 'u32',
            /// suspension length
            suspensionLength: 'f32',
            /// shock absorber
            suspension: METADATA_TIRE_SCHEMA,
            /// motor
            motor: METADATA_MOTOR_SCHEMA
          }
      }
      
      const METADATA_GARAGE_SCHEMA = {
        struct : {
          cars: { array: { type: METADATA_CAR_SCHEMA , len: 1}},
          tires: { array: { type: METADATA_TIRE_SCHEMA , len: 2}},
          motors: { array: { type: METADATA_MOTOR_SCHEMA , len: 2}},
        }
      }


    export function getMotor(id) {
        for (let n = 0; n < motors.length; n++) {
            if (motors[n].id == id) {
                return motors[n];
            }
        }

        return motors[0];

    }

    export function getTire(id) {
        for (let n = 0; n < tires.length; n++) {
            if (tires[n].id == id) {
                return tires[n];
            }
        }

        return tires[0];
    }
const sleep = m => new Promise(r => setTimeout(r, m));


function hexToBytes(hex) {
    for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
}

function getTimeTxt(t) {
    var hours = 0;
    var mins = 0;

    if(t <= 0)
        return 'full';

    if (t >= 3600)
        hours = parseInt(t / 3600);

    if (t >= 60)
        mins = parseInt((t % 3600) / 60);

    var secs = parseInt(t % 60);

    var txt = '';

    if (hours > 0) {

        if (hours > 1)
            txt += hours + ' hrs ';
        else
            txt += hours + ' hr ';
    }

    if (mins > 1)
        txt += mins + ' mins ';
    else
        txt += mins + ' min ';

    if (secs > 1)
        txt += secs + ' secs ';
     

    return txt;
}

class KeyFrame {
    quat;
    time;

    constructor(quat, time){
        this.quat = new THREE.Quaternion(quat.x, quat.y, quat.z, quat.w);
        this.time = time;
    }
}

class BoneAnim {

    name;
    keyframes;
    endTime;

    constructor(name, quat = null) {

        this.name = name;
        this.keyframes = [];
        if (quat) {
            const newKey = new KeyFrame(quat, 0);
            this.keyframes.push(newKey);
            this.endTime = this.keyframes[0].time;
        }

        this.cq = new THREE.Quaternion();
        
    }

    addKey(quat, time){

        if(time === null)
            time = this.endTime + 1.0;
        
        const newKey = new KeyFrame(quat, time);
        this.keyframes.push(newKey);

        this.keyframes.sort(function(a,b){

            if(a.time < b.time)
                return -1;

            if(a.time > b.time)
                return 1;

            return 0;
        });

        this.endTime = this.keyframes[this.keyframes.length - 1].time;
    }

    getValue(it){

        const t = it % this.endTime;

        if(t <= this.keyframes[0].time){
            return this.keyframes[0].quat;
        }

        for(let n = 0; n < this.keyframes.length; n++) {

            if(this.keyframes[n].time > t){
                const tt = this.keyframes[n].time - this.keyframes[n-1].time;
                const dt = t - this.keyframes[n-1].time;
                this.cq.slerpQuaternions(this.keyframes[n-1].quat, this.keyframes[n].quat, dt / tt);
                return this.cq;
            }
        }

        return this.keyframes[0].quat;
    }

}

class SkelAnimation {
    bones;

    constructor(bone_names = []){

        this.bone_names = bone_names;
        this.bones = [];
    }


    getEndTime(){

        this.endTime = 0;
        for(let b of this.bones){

            this.endTime = Math.max(this.endTime, b.endTime)

        }
    }

    toPhys() {

        const anim = [];

        for(let b of this.bones){

            const a = {name : b.name, keyframes: []}

            for(let k of b.keyframes){
                a.keyframes.push({quat : {x: k.quat.x, y: k.quat.y, z: k.quat.z, w: k.quat.w}, time: k.time});
            }
            anim.push(a);
        }
        return {bones : anim};
    }
    serialize() {

        const anim = [];

        for(let b of this.bones){

            const a = {name : b.name, keyframes: []}

            for(let k of b.keyframes){
                a.keyframes.push({q : {x: k.quat.x, y: k.quat.y, z: k.quat.z, w: k.quat.w}, t: k.time});
            }
            anim.push(a);
        }
        return JSON.stringify(anim);
    }

    scaleTime(scale){
        for(let b of this.bones){
            for(let k of b.keyframes){
                k.time *= scale;
            }
            b.endTime*= scale;
        }
    }

    load(data){

        this.bone_names = [];

        this.bones = [];

        for(let dbone of data){
            this.bone_names.push(dbone.name);
            const a = new BoneAnim(dbone.name);
            for(let k of dbone.keyframes) {
                a.addKey(k.q, k.t);
            }
            this.bones.push(a);
        }
    }

    fromSkeleton(skeleton) {
        
        for(let c of skeleton.root.children) {
            this.addBone(c);
        }
    }

    hasBone(bone_name){

        for(let b of this.bones){
            if(b.name == bone_name){
                return true;
            }
        }

        return false;
    }

    addBone(bone){

        if((this.bone_names.length == 0) || (this.bone_names.indexOf(bone.name) >= 0 )){

            const banim = new BoneAnim(bone.name, bone.quat);
            this.bones.push(banim);
        }

        for(let c of bone.children){
            this.addBone(c);
        }
    }

    addSingleBone(bone_name, skeleton){

        const bone = skeleton.findBone(bone_name);
        const quat = bone ? bone.quat : new THREE.Quaternion();

        const banim = new BoneAnim(bone_name, quat);
        this.bones.push(banim);

    }

    addBoneKey(bone_name, quat, t = null){

        for(let b of this.bones){
            if(b.name == bone_name){
                b.addKey(quat, t);

            }
        }
    }

    getKey(bone_name, t){
        for(let b of this.bones){
            if(b.name == bone_name){
                for(let k of b.keyframes){
                    if(k.time == t)
                        return k.quat;
                }
            }
        }

        return null;
    }

    setKey(bone_name, q , t){

        for(let b of this.bones){
            if(b.name == bone_name){
                for(let k of b.keyframes){
                    if(k.time == t)
                        k.quat.set(q.x, q.y, q.z, q.w);
                }
            }
        }
    }


}

class Character {

    constructor(id, avatarDef, car = null) {

        this.netID = id;
        this.id = id;
        this.avatarDef = avatarDef;
        this.actions = { "forward" : {state : false}, "backward" : {state : false}, "left" : {state : false}, "right" : {state : false}, "use" : {state : false}, "goto" : {state : false}, "dialog" : {state : false}, "turnleft": {state : false}, "turnright": {state : false}, "activate": {state : false} };
        this.active = false;
        this.avatarMesh = null;
        this.activeAnims = [];
        this.scriptInstance = null;
        this.originalMesh = null;
        this.charScale = 1.0;
        this.splitMesh = [];

        this.prot = new THREE.Quaternion();
        this.worldOffset = new THREE.Vector3(0, 0, 0 );

        if(car !== null){
            this.quat = new THREE.Quaternion(car.quat.x, car.quat.y, car.quat.z, car.quat.w);
            this.rot = new THREE.Quaternion(car.quat.x, car.quat.y, car.quat.z, car.quat.w);
            this.pos = new THREE.Vector3(-2.0, 1.0, 0).add(car.center);
            this.angles = new THREE.Euler().setFromQuaternion(this.quat);
        }else{
            this.angles = new THREE.Euler(0, 0, 0);
            this.quat = new THREE.Quaternion(0, 0, 0, 1);
            this.rot = new THREE.Quaternion(0, 0, 0, 1);
            this.pos = new THREE.Vector3(0.0, 0.0, 0.0);
        }
    }

    initPhy(){
        this.p = new Ammo.btVector3();
        this.q = new Ammo.btQuaternion();
    }
}


class Car {

    constructor(id, carDef, carPos = null, carQuat = null, mode = 0) {
        this.wheels = [];
        this.skidPlanes = [];
        this.shots = [];
        this.nLaps = -1;
        this.ChassisMesh = null;
        this.massVehicle = 0;
        this.speed = 0;
        this.contacts = new Array(100);
        this.ncontacts = 0;
        this.EngineForceFactor = 1;
        this.nBonus = 0;
        this.nTechs = 0;
        this.multiplier = 1.0;
        this.nextNitro = 0;
        this.nitros = 0;
        this.pathMesh = null;

        this.color = new THREE.Color(1,0,0);

        this.mapCurve = null;
        this.mapGeometry1 = null;
        this.mapCurveMesh = null;

        this.projParts = null;
        this.nitroSpheres = [];
        this.pos = carPos ? carPos.clone() :  new THREE.Vector3(0, meshsInfos[carDef.chassis].chassisOffset, 0);
        this.quat = carQuat ? carQuat.clone() : new THREE.Quaternion();
        this.scale = new THREE.Vector3(1, 1, 1);
        this.center = new THREE.Vector3(1, 1, 1);
        this.remainingTime = -1;
        this.curLapTime = 0;
        this.carDef = carDef;
        this.id = id;
        this.maxdmg = carDef.maxdmg ? carDef.maxdmg : 0;
        this.lastContact = 0;
        this.projSize = 0.3;
        this.power = 0.0;
        this.trigger = null;
        this.CarLight = {};
        this.blueprints = 0;

        this.exhaustPos = new THREE.Vector3(-0.5 , 0, -2.0);
        this.tmpVec = new THREE.Vector3();

        this.actions = { "acceleration" : false, "next-target" : false, "next-subsystem" : false, "acceleration" : false, "braking" : false, "left" : false, "right" : false, "nitro" : false, "shooting" : [false]};
        this.tdown = new THREE.Vector3();
        this.cameraOffset= new THREE.Vector3();
        this.lightState = 2;

        
        this.wheelRadius =carDef.suspension ? carDef.suspension.radius : 0.3;
        this.wheelWidth = carDef.suspension ? carDef.suspension.width : 0.2;
        /*
        this.wheelRadius = carDef.suspension ? carDef.suspension.radius : 0.3;
        this.wheelWidth = carDef.suspension ? carDef.suspension.width : 0.2;
        */

        this.isAI = false;

        this.chassisWidth = meshsInfos[carDef.chassis].extents.size.x;
        this.chassisHeight = meshsInfos[carDef.chassis].extents.size.y;
        this.chassisLength = meshsInfos[carDef.chassis].extents.size.z;
        this.wheelOffset = meshsInfos[carDef.chassis].wheelOffset;

        this.wheelAxisPositionBack = -this.chassisLength * 0.4 + this.wheelRadius;
        this.wheelRadiusBack = this.wheelRadius;
        this.wheelWidthBack = this.wheelWidth;
        this.wheelHalfTrackBack = (this.chassisWidth + this.wheelWidth * 2)/ 2 - this.wheelWidth / 2;
        this.wheelAxisHeightBack = this.wheelOffset;

        this.wheelAxisFrontPosition = this.chassisLength * 0.4 - this.wheelRadius;
        this.wheelRadiusFront = this.wheelRadius;
        this.wheelWidthFront = this.wheelWidth;
        this.wheelHalfTrackFront = (this.chassisWidth+ this.wheelWidth * 2) / 2 - this.wheelWidth / 2;
        this.wheelAxisHeightFront =  this.wheelOffset;

        const pos1 = new THREE.Vector3( -this.wheelHalfTrackFront, this.wheelAxisHeightFront, this.wheelAxisFrontPosition);//.applyQuaternion(this.quat).add(this.pos);
        const pos2 = new THREE.Vector3(  this.wheelHalfTrackFront, this.wheelAxisHeightFront, this.wheelAxisFrontPosition);//.applyQuaternion(this.quat).add(this.pos);

        const pos3 = new THREE.Vector3(  this.wheelHalfTrackBack, this.wheelAxisHeightBack, this.wheelAxisPositionBack);//.applyQuaternion(this.quat).add(this.pos);
        const pos4 = new THREE.Vector3( -this.wheelHalfTrackBack, this.wheelAxisHeightBack, this.wheelAxisPositionBack);//.applyQuaternion(this.quat).add(this.pos);

        this.wheels[0] = { isFront: true , inContact: false, contactUv : new THREE.Vector2(),  contactPoint: new THREE.Vector3(), pos: { x: pos1.x, y: pos1.y, z: pos1.z }, quat: { x: this.quat.x, y: this.quat.y, z: this.quat.z, w: this.quat.w }, radius: this.wheelRadiusFront, width: this.wheelWidthFront, scale: { x: mode ? 1 : -1, y: 1, z: 1 } };
        this.wheels[1] = { isFront: true , inContact: false, contactUv : new THREE.Vector2(),contactPoint: new THREE.Vector3(), pos: { x: pos2.x, y: pos2.y, z: pos2.z }, quat: { x: this.quat.x, y: this.quat.y, z: this.quat.z, w: this.quat.w }, radius: this.wheelRadiusFront, width: this.wheelWidthFront, scale:  { x: mode == 2 ? -1 : 1, y: 1, z: 1 }};
        this.wheels[2] = { isFront: false, inContact: false, contactUv : new THREE.Vector2(),contactPoint: new THREE.Vector3(), pos: { x: pos3.x, y: pos3.y, z: pos3.z }, quat: { x: this.quat.x, y: this.quat.y, z: this.quat.z, w: this.quat.w }, radius: this.wheelRadiusBack, width: this.wheelWidthBack, scale: { x: mode == 2 ? -1 : 1, y: 1, z: 1 } };
        this.wheels[3] = { isFront: false, inContact: false, contactUv : new THREE.Vector2(),contactPoint: new THREE.Vector3(), pos: { x: pos4.x, y: pos4.y, z: pos4.z }, quat: { x: this.quat.x, y: this.quat.y, z: this.quat.z, w: this.quat.w }, radius: this.wheelRadiusBack, width: this.wheelWidthBack, scale: { x: mode ? 1 : -1, y: 1, z: 1 } };

        this.updateWheels();
        this.RPM = 0;
    }

    initPhy(Ammo){
        this.down = new Ammo.btVector3(0,0,0);
        this.t = new Ammo.btTransform();
        this.p = new Ammo.btVector3(0,0,0);
        this.q = new Ammo.btQuaternion(0,0,0,0);
    }

    getMeshInfos(){
        return meshsInfos[this.carDef.chassis];
    }

    initPhys(){
        this.down = new Ammo.btVector3(0,0,0);
        this.t = new Ammo.btTransform();
        this.p = new Ammo.btVector3(0,0,0);
        this.q = new Ammo.btQuaternion(0,0,0,0);
    }

    getExhaustPos(vec)
    {
        this.tmpVec.set(this.exhaustPos.x,this.exhaustPos.y, this.exhaustPos.z).applyQuaternion(this.ChassisMesh.quaternion);
        return vec.addVectors(this.ChassisMesh.position, this.tmpVec);
    }
    

    getEngineForce(rpm, gear) {

            
        const x = rpm;
        //const Torque = Math.max(0, -0.0000043*x*x+.033*x+125);
        /*
        this.carDef.motor.a = -0.0000048;
        this.carDef.motor.b = 0.04;
        this.carDef.motor.c = 125;
        */

        const Torque = Math.max(0, this.carDef.motor.a*x*x+this.carDef.motor.b*x+this.carDef.motor.c);
        const Force = this.carDef.motor.maxEngineForce * this.EngineForceFactor * Torque / (45 );
        return Force;
    }

    addContact(p, dmg, now) {

        if(this.ncontacts>=100)
            return;

        this.contacts[this.ncontacts++] = { meshGPU: null, pos: p, dmg: dmg, time: now, object: null };

        //this.contacts.push({ meshGPU: null, 'pos': p, 'dmg': dmg, 'time': now, 'object': null });
    }

    addSkidding(p, uv, norm, skid, wheel, now) {

        this.skidPlanes.push({ object: null, pos: p, uv: {x:uv.x, y:uv.y}, normal: norm, skid: skid, wheel : wheel, time: now });
    }

    toPhys(){

        const wheels = []

        for (let n = 0; n < 4; n++) {
            wheels[n] = {
                         opos : {x:this.wheels[n].opos.x, y:this.wheels[n].opos.y, z:this.wheels[n].opos.z},
                         radius : this.wheels[n].radius,
                         width : this.wheels[n].width,
                         isFront : this.wheels[n].isFront
                        };
      }

        return {
            massVehicle:this.massVehicle,
            center:{x: this.center.x, y: this.center.y, z: this.center.z},
            quat:{x:this.quat.x, y:this.quat.y, z: this.quat.z, w:this.quat.w},
            chassisWidth: this.chassisWidth,
            chassisHeight: this.chassisHeight,
            chassisLength: this.chassisLength,
            nitros:this.nitros,
            EngineForceFactor: this.EngineForceFactor,
            isAI:this.isAI,
            dmg:this.dmg,
            target :  
            {
                type: this.target.type,    
                id : this.target.id,
                name :  this.target.name,
                pos :  {x:this.target.pos.x, y:this.target.pos.y, z: this.target.pos.z},
                subsystems: []
            },
            wheels: wheels,
            color: {r: this.color.r, g: this.color.g, b: this.color.b },
            actions:this.actions,
            carDef: this.carDef
        }
          
    }

    updateWheels(mode = 0) {

        /*
        if(this.tireMesh){
            this.tireMesh.geometry.computeBoundingBox();
            this.wheelRadius = (this.tireMesh.geometry.boundingBox.max.y-this.tireMesh.geometry.boundingBox.min.y)/2.0;
         }
         else
         */
         this.wheelAxisPositionBack = -this.chassisLength * 0.35 + this.wheelRadius;
         this.wheelRadiusBack = this.wheelRadius;
         this.wheelWidthBack = this.wheelWidth;
         this.wheelHalfTrackBack = (this.chassisWidth )/ 2+ this.wheelWidth/2;
         this.wheelAxisHeightBack = meshsInfos[this.carDef.chassis].wheelOffset; // 0.4
 
         this.wheelAxisFrontPosition = this.chassisLength * 0.45 - this.wheelRadius;
         this.wheelRadiusFront = this.wheelRadius;
         this.wheelWidthFront = this.wheelWidth;
         this.wheelHalfTrackFront = (this.chassisWidth) / 2 + this.wheelWidth/2;
         this.wheelAxisHeightFront =  meshsInfos[this.carDef.chassis].wheelOffset;
  

        this.exhaustPos.set(-this.chassisWidth / 4.0 , 0, -this.chassisLength / 2.0 + meshsInfos[this.carDef.chassis].extents.center.z);

        const pos1 = new THREE.Vector3( this.wheelHalfTrackFront, this.wheelAxisHeightFront, this.wheelAxisFrontPosition);//.applyQuaternion(this.quat).add(this.pos);
        const pos2 = new THREE.Vector3( -this.wheelHalfTrackFront, this.wheelAxisHeightFront, this.wheelAxisFrontPosition);//.applyQuaternion(this.quat).add(this.pos);

        const pos3 = new THREE.Vector3( -this.wheelHalfTrackBack, this.wheelAxisHeightBack, this.wheelAxisPositionBack);//.applyQuaternion(this.quat).add(this.pos);
        const pos4 = new THREE.Vector3( this.wheelHalfTrackBack, this.wheelAxisHeightBack, this.wheelAxisPositionBack);//.applyQuaternion(this.quat).add(this.pos);

        this.wheels[0].opos=  pos1.clone();
        this.wheels[0].oquat= this.quat.clone();
        this.wheels[0].scale = { x: mode == 2 ? 1 : -1, y: 1, z: 1 };

        this.wheels[1].opos=  pos2.clone();
        this.wheels[1].oquat= this.quat.clone();
        this.wheels[1].scale = { x: mode == 2 ? -1 : 1, y: 1, z: 1 };

        this.wheels[2].opos=  pos3.clone();
        this.wheels[2].oquat= this.quat.clone();
        this.wheels[2].scale = { x: mode == 2 ? -1 : 1, y: 1, z: 1 };
        
        this.wheels[3].opos=   pos4.clone();
        this.wheels[3].oquat= this.quat.clone();
        this.wheels[3].scale = { x: mode == 2 ? 1 : -1, y: 1, z: 1 };


        this.wheels[0].pos = new THREE.Vector3().addVectors( this.wheels[0].opos.clone().applyQuaternion(this.quat), this.pos);
        this.wheels[1].pos = new THREE.Vector3().addVectors( this.wheels[1].opos.clone().applyQuaternion(this.quat), this.pos);
        this.wheels[2].pos = new THREE.Vector3().addVectors( this.wheels[2].opos.clone().applyQuaternion(this.quat), this.pos);
        this.wheels[3].pos = new THREE.Vector3().addVectors( this.wheels[3].opos.clone().applyQuaternion(this.quat), this.pos);

        //this.wheels[1] = { isFront: true , pos: { x: pos2.x, y: pos2.y, z: pos2.z }, quat: { x: this.quat.x, y: this.quat.y, z: this.quat.z, w: this.quat.w }, radius: this.wheelRadiusFront, width: this.wheelWidthFront, scale:  { x: mode == 2 ? -1 : 1, y: 1, z: 1 }};
        //this.wheels[2] = { isFront: false, pos: { x: pos3.x, y: pos3.y, z: pos3.z }, quat: { x: this.quat.x, y: this.quat.y, z: this.quat.z, w: this.quat.w }, radius: this.wheelRadiusBack, width: this.wheelWidthBack, scale: { x: mode == 2 ? -1 : 1, y: 1, z: 1 } };
        //this.wheels[3] = { isFront: false, pos: { x: pos4.x, y: pos4.y, z: pos4.z }, quat: { x: this.quat.x, y: this.quat.y, z: this.quat.z, w: this.quat.w }, radius: this.wheelRadiusBack, width: this.wheelWidthBack, scale: { x: mode ? 1 : -1, y: 1, z: 1 } };
    }

    setPos(p,q){

    }

    id;
    carDef;
    maxdmg;
    massVehicle;
    speed;
    pos;
    quat;

    ChassisMesh;
    wheels;

    skidPlanes;
    contacts;
    nitroSpheres;
    remainingTime;
}

class Track {

    constructor(npts, assetBase = '') {
        
        this.trackPoints = new Array();
        this.trackSegments = new Array();
        this.roadParams = {reflectivity: 0.1,metalness: 0.1,roughness: 0.4,envMapIntensity: 0.45}
        this.roadGrasses = [];
        this.walls = [];
        this.woods = [];
        this.xmeshes = [];
        this.bonuses = [];
        this.jumpers = [];
        this.interestPoints = [];
        this.turrets = [];
        this.springs = [];
        this.ropes = [];
        this.loopings = [];
        this.worms = [];
        this.tubes = [];
        this.wires = [];
        this.waves = [];
        this.drones = [];
        this.spiders = [];
        this.plateform = null;
        this.movingObjects = [];
        this.newBonuses = [];
        this.grids = [];
        this.lastId = 1;
        this.cyls = [];
        this.cubes = [];
        this.colcyls= [];
        this.colcubes = [];
        this.characters = [];
        this.pathes = [];
        this.triggers = [];
        this.lights = [];
        this.npcs = [];
        this.navmeshs = [];
        this.splits = []
        this.NPoints = npts;
        this.lapTime = 60;
        this.tensionL = 0.5;
        this.tensionR = 0.5;
        this.tensionC = 0.5;
        this.gscale = 1.0;
        this.assetBase = assetBase;
        
        
        this.roadObj = null;
        this.roadObjGPU = null;;
        this.meshInstances =[];
        this.prize = "";
        this.wallSpace = 1.0;
        this.Zv = new THREE.Vector3(1, 0, 0);
        this.Uv = new THREE.Vector3(0, 1, 0);
        this.gravity = 9;
        this.roadObjPhy = null;
        this.roadWall= null;
        this.roadTexScale = { x: 1, y: 1 };
        this.HM = null;
        this.carStartPos = null;

        this.trackHeight = 1.0;

        this.tubecolor = new THREE.Color();
    }

    findSpiderBone(bone , name){

        if(bone.name === name)
            return bone;

        for(let child of bone.children){
            let ret = this.findSpiderBone(child, name);
            if(ret != null)
                return ret;
        }

        return null;
    }

    getNPCTarget(npc, targetSubsystemId){

        const retTarget = { 
            id   : npc.target.id, 
            name : npc.target.name, 
            type : npc.target.type, 
            eid  : npc.target.eid, 
            pos: {  
                x : npc.avatarMesh.position.x, 
                y : npc.avatarMesh.position.y +npc.worldOffset.y + npc.avatarDef.height / 2 * npc.skelScale, 
                z : npc.avatarMesh.position.z
            }, 
            subsystem : null
        };

        if(targetSubsystemId === 0)
            return retTarget;

        for(let ss of npc.target.subsystems){

            if(ss.id !== targetSubsystemId)
                continue;

            const bone = this.findSpiderBone(npc.skeleton.root, ss.name);
            if(bone === null)
                continue;

            let pos = null;
            
            if(npc.tskel){
                const tbone= npc.tskel.getBoneByName(bone.name);
                pos = {x : tbone.matrixWorld[12], y : tbone.matrixWorld[13], z : tbone.matrixWorld[14]};
            }else{
                const tbone = npc.avatarMesh.meshGPU.rootBone.findBone(bone.name);
                pos = {x : tbone.bonePos.x, y : tbone.bonePos.y, z: tbone.bonePos.z};
            }
            retTarget.subsystem = { id :ss.id, name : ss.name, pos: pos};
            break;
        }
        return retTarget;
    }

    findNPCTarget(targetID, targetSubsystemId){
        
        for(let n=0;n<this.npcs.length;n++){

            if(!this.npcs[n].target)
                continue;
  
            if(targetID !== this.npcs[n].target.id)
                continue;

            return this.getNPCTarget(this.npcs[n], targetSubsystemId);
        }
    }
    toPhys(){

        const jumpers = [];
        const woods = [];
        const springs = [];
        const turrets = [];
        const bonuses = [];
        const trackPoints = [];
        const trackSegments = [];
        const interestPoints = [];
        const drones  = [];
        const ropes = [];
        const characters = [];
        const npcs = [];
        const triggers = [];
        const xmeshs = [];
        const spiders = [];
        const moks = [];

        for(let n in this.movingObjects){
            moks[n]={
                axis:{x:this.movingObjects[n].axis.x, y:this.movingObjects[n].axis.y, z:this.movingObjects[n].axis.z},
                angle:{x:this.movingObjects[n].angle.x, y:this.movingObjects[n].angle.y, z:this.movingObjects[n].angle.z},
                rot:{x:this.movingObjects[n].rot.x, y:this.movingObjects[n].rot.y, z:this.movingObjects[n].rot.z, w:this.movingObjects[n].rot.w},
            };

            if(this.movingObjects[n].deltaAnchor)
                moks[n].deltaAnchor={x:this.movingObjects[n].deltaAnchor.x, y:this.movingObjects[n].deltaAnchor.y, z:this.movingObjects[n].deltaAnchor.z};

            if(this.movingObjects[n].oPos)
                moks[n].oPos={x:this.movingObjects[n].oPos.x, y:this.movingObjects[n].oPos.y, z:this.movingObjects[n].oPos.z};

        }
  
        for(let n =0;n<this.trackSegments.length;n++){

            trackSegments[n] = {
                looping: this.trackSegments[n].looping,
                tube: this.trackSegments[n].tube,
                worm: this.trackSegments[n].worm,
                min: this.trackSegments[n].min,
                max: this.trackSegments[n].max,
            }
        }

        for(let n =0;n<this.trackPoints.length;n++){

            trackPoints[n] = {
                pos: {x:this.trackPoints[n].pos.x, y:this.trackPoints[n].pos.y, z:this.trackPoints[n].pos.z},
                rot: {x:this.trackPoints[n].rot.x, y:this.trackPoints[n].rot.y, z:this.trackPoints[n].rot.z, w:this.trackPoints[n].rot.w},
                width: this.trackPoints[n].width,
                noWalls:this.trackPoints[n].noWalls,
            }
        }

        for(let n =0;n<this.jumpers.length;n++){

            jumpers[n] = {
                id: this.jumpers[n].id,
                offset: { x: this.jumpers[n].offset.x, y: this.jumpers[n].offset.y, z: this.jumpers[n].offset.z },
                size: { x: this.jumpers[n].size.x, y: this.jumpers[n].size.y, z: this.jumpers[n].size.z },
                pos: { x:this.jumpers[n].pos.x, y: this.jumpers[n].pos.y, z: this.jumpers[n].pos.z },
                angles: { x: 0.0, y: 0.0, z: 0.0 },
                angle : this.jumpers[n].angle,
                rot : {x: this.jumpers[n].rot.x, y: this.jumpers[n].rot.y, z: this.jumpers[n].rot.z, w: this.jumpers[n].rot.w},
                ptIdx: this.jumpers[n].ptsIdx,
                object: null
            };
        }

        for(let n =0;n<this.xmeshes.length;n++){

            xmeshs[n] = {
                id: this.xmeshes[n].id,
                boxOffset: { x: this.xmeshes[n].boxOffset.x, y: this.xmeshes[n].boxOffset.y, z: this.xmeshes[n].boxOffset.z },
                size: { x: this.xmeshes[n].size.x, y: this.xmeshes[n].size.y, z: this.xmeshes[n].size.z },
                pos: { x:this.xmeshes[n].pos.x, y: this.xmeshes[n].pos.y, z: this.xmeshes[n].pos.z },
                rot : {x: this.xmeshes[n].rot.x, y: this.xmeshes[n].rot.y, z: this.xmeshes[n].rot.z, w: this.xmeshes[n].rot.w}, 
                meshArray : this.xmeshes[n].meshArray,
                mass : this.xmeshes[n].mass
            };
        }

        for(let n =0;n<this.interestPoints.length;n++){

            interestPoints[n] = {
                id: this.interestPoints[n].id,
                offset: { x: this.interestPoints[n].offset.x, y: this.interestPoints[n].offset.y, z: this.interestPoints[n].offset.z },
                size: { x: this.interestPoints[n].size.x, y: this.interestPoints[n].size.y, z: this.interestPoints[n].size.z },
                lsize:  this.interestPoints[n].lsize,
                pos: { x:this.interestPoints[n].pos.x, y: this.interestPoints[n].pos.y, z: this.interestPoints[n].pos.z },
                rot : {x: this.interestPoints[n].rot.x, y: this.interestPoints[n].rot.y, z: this.interestPoints[n].rot.z, w: this.interestPoints[n].rot.w},   
                lpos: { x:this.interestPoints[n].lpos.x, y: this.interestPoints[n].lpos.y, z: this.interestPoints[n].lpos.z },
                lweight : this.interestPoints[n].lweight,
                rot2 : {x: this.interestPoints[n].rot2.x, y: this.interestPoints[n].rot2.y, z: this.interestPoints[n].rot2.z, w: this.interestPoints[n].rot2.w},
                ptIdx: this.interestPoints[n].ptsIdx,
                targetNode: this.interestPoints[n].targetNode,
                nBonuses: this.interestPoints[n].nBonuses,
            };
        }

        for(let n =0;n<this.ropes.length;n++){

            ropes[n] = {
                id: this.ropes[n].id,
                obj :   {
                            pos : {x:this.ropes[n].obj.pos.x, y:this.ropes[n].obj.pos.y, z:this.ropes[n].obj.pos.z},
                            rot : {x:this.ropes[n].obj.rot.x, y:this.ropes[n].obj.rot.y, z:this.ropes[n].obj.rot.z, w:this.ropes[n].obj.rot.w},
                            size: { x: this.ropes[n].obj.size.x, y: this.ropes[n].obj.size.y, z: this.ropes[n].obj.size.z },
                            meshData :this.ropes[n].obj.meshData,
                            shape:this.ropes[n].obj.shape,
                            mass: this.ropes[n].obj.mass,
                        },
                        
                 anchor :   {
                            pos : {x:this.ropes[n].obj.pos.x, y:this.ropes[n].obj.pos.y, z:this.ropes[n].obj.pos.z},
                            rot : {x:this.ropes[n].obj.rot.x, y:this.ropes[n].obj.rot.y, z:this.ropes[n].obj.rot.z, w:this.ropes[n].obj.rot.w}
                        },
                    
                anchorObj: this.ropes[n].anchorObj,
                offset: { x: this.ropes[n].offset.x, y: this.ropes[n].offset.y, z: this.ropes[n].offset.z },
                eqPts: { x: this.ropes[n].eqPts.x, y: this.ropes[n].eqPts.y, z: this.ropes[n].eqPts.z },
                limit: { x: this.ropes[n].limit.x, y: this.ropes[n].limit.y, z: this.ropes[n].limit.z },
                eqA: { x: this.ropes[n].eqA.x, y: this.ropes[n].eqA.y, z: this.ropes[n].eqA.z },
                limitA: { x: this.ropes[n].limitA.x, y: this.ropes[n].limitA.y, z: this.ropes[n].limitA.z },
                stiffness : this.ropes[n].stiffness,
                damping : this.ropes[n].damping,
            };
        }
        for(let n =0;n<this.springs.length;n++){

            springs[n] = {
                id: this.springs[n].id,
                obj :   {
                            pos : {x:this.springs[n].obj.pos.x, y:this.springs[n].obj.pos.y, z:this.springs[n].obj.pos.z},
                            rot : {x:this.springs[n].obj.rot.x, y:this.springs[n].obj.rot.y, z:this.springs[n].obj.rot.z, w:this.springs[n].obj.rot.w},
                            shape:this.springs[n].obj.shape,
                            mass: this.springs[n].obj.mass,
                        },
                        
                 anchor :   {
                            pos : {x:this.springs[n].obj.pos.x, y:this.springs[n].obj.pos.y, z:this.springs[n].obj.pos.z},
                            rot : {x:this.springs[n].obj.rot.x, y:this.springs[n].obj.rot.y, z:this.springs[n].obj.rot.z, w:this.springs[n].obj.rot.w}
                        },
                    

                size: { x: this.springs[n].size.x, y: this.springs[n].size.y, z: this.springs[n].size.z },
                eqPts: { x: this.springs[n].eqPts.x, y: this.springs[n].eqPts.y, z: this.springs[n].eqPts.z },
                limit: { x: this.springs[n].limit.x, y: this.springs[n].limit.y, z: this.springs[n].limit.z },
                eqA: { x: this.springs[n].eqA.x, y: this.springs[n].eqA.y, z: this.springs[n].eqA.z },
                limitA: { x: this.springs[n].limitA.x, y: this.springs[n].limitA.y, z: this.springs[n].limitA.z },
                stiffness : this.springs[n].stiffness,
                damping : this.springs[n].damping,
            };
        }

        for(let n =0;n<this.turrets.length;n++){

            turrets[n] = {
                id: this.turrets[n].id,
             
                pos : {x:this.turrets[n].pos.x, y:this.turrets[n].pos.y, z:this.turrets[n].pos.z},
                rot : {x:this.turrets[n].rot.x, y:this.turrets[n].rot.y, z:this.turrets[n].rot.z, w:this.turrets[n].rot.w},
                size: this.turrets[n].size,
                projPts :  {x:this.turrets[n].projPts.x, y:this.turrets[n].projPts.y, z:this.turrets[n].projPts.z},
                oHeadAngle : this.turrets[n].oHeadAngle, 
                headAngle: this.turrets[n].oHeadAngle, 
                canonAngle: this.turrets[n].canonAngle, 
                activation: this.turrets[n].activation, 
                projSize: this.turrets[n].projSize, 
                projMass : this.turrets[n].projMass, 
                projSpeed : this.turrets[n].projSpeed,  
                projDelay : this.turrets[n].projDelay,  
                projTTL : this.turrets[n].projTTL, 
                moveAngle : this.turrets[n].moveAngle, 
                bodyPos: {x : this.turrets[n].bodyPos.x, y : this.turrets[n].bodyPos.y, z : this.turrets[n].bodyPos.z},
                bodyCenter: {x : this.turrets[n].bodyCenter.x, y : this.turrets[n].bodyCenter.y, z : this.turrets[n].bodyCenter.z},
                headPos: {x : this.turrets[n].headPos.x, y : this.turrets[n].headPos.y, z : this.turrets[n].headPos.z},
                headCenter: {x : this.turrets[n].headCenter.x, y : this.turrets[n].headCenter.y, z : this.turrets[n].headCenter.z},
                cannonPos : {x : this.turrets[n].cannonPos.x, y : this.turrets[n].cannonPos.y, z : this.turrets[n].cannonPos.z},
                canonCenter: {x : this.turrets[n].canonCenter.x, y : this.turrets[n].canonCenter.y, z : this.turrets[n].canonCenter.z},
                bodyRadius:this.turrets[n].bodyRadius,
                bodyHeight:this.turrets[n].bodyHeight,
                headRadius:this.turrets[n].headRadius,
                headHeight :this.turrets[n].headHeight,
                cannonRadius :this.turrets[n].cannonRadius,
                cannonHeight :this.turrets[n].cannonHeight,
                life : this.turrets[n].life,
                projLL : this.turrets[n].projLL,
                target : {
                    type: this.turrets[n].target.type,    
                    id : this.turrets[n].target.id,
                    name :  this.turrets[n].target.name,
                    pos :  {x:this.turrets[n].target.pos.x, y:this.turrets[n].target.pos.y, z:this.turrets[n].target.pos.z},
                    subsystems: []
                },
            };
        }

        for(let n =0;n<this.spiders.length;n++){
            spiders[n] = {
                id: this.spiders[n].id,
                pos: {x:this.spiders[n].pos.x, y:this.spiders[n].pos.y, z:this.spiders[n].pos.z},
                rot: {x:this.spiders[n].rot.x, y:this.spiders[n].rot.y, z:this.spiders[n].rot.z, w:this.spiders[n].rot.w},
                projDelay : this.spiders[n].projDelay,
                projSize : this.spiders[n].projSize,
                projMass : this.spiders[n].projMass,
                projSpeed: this.spiders[n].projSpeed,
                shotModel: this.spiders[n].shotModel,
                activation: this.spiders[n].activation,
                target : {
                    type: this.spiders[n].target.type,    
                    id : this.spiders[n].target.id,
                    name :  this.spiders[n].target.name,
                    pos :  {x:this.spiders[n].target.pos.x, y:this.spiders[n].target.pos.y, z:this.spiders[n].target.pos.z},
                    subsystems: []
                },
                proj : this.spiders[n].proj,
                lastDist:0,
                stuckTime:0,
                stuckMode:false,
                backMode :false,
                backTime :0,
                dir : 1,
                lastShotId : 0,
                torqueValue: 0,
                skel : this.spiders[n].skel.toPhys()
            };

            for(let s =0;s<this.spiders[n].target.subsystems.length;s++){

                spiders[n].target.subsystems.push({
                    id : this.spiders[n].target.subsystems[s].id,
                    name : this.spiders[n].target.subsystems[s].name,
                    pos :  {x:this.spiders[n].target.subsystems[s].pos.x, y:this.spiders[n].target.subsystems[s].pos.y, z:this.spiders[n].target.subsystems[s].pos.z}
                })
            }
        }

        for(let n =0;n<this.triggers.length;n++){

            triggers[n] = { 
                pos : {x:this.triggers[n].pos.x, y:this.triggers[n].pos.y, z:this.triggers[n].pos.z},
                rot : {x:this.triggers[n].rot.x, y:this.triggers[n].rot.y, z:this.triggers[n].rot.z, w:this.triggers[n].rot.w},
                size:  {x:this.triggers[n].size.x, y:this.triggers[n].size.y, z:this.triggers[n].size.z},
                type: this.triggers[n].type,
                data: this.triggers[n].data,
                action: this.triggers[n].action
            }
        }
                
        
        for(let n =0;n<this.npcs.length;n++){

            npcs[n] = {
                id: this.npcs[n].id,
                pos : {x:this.npcs[n].pos.x, y:this.npcs[n].pos.y, z:this.npcs[n].pos.z},
                rot : {x:this.npcs[n].rot.x, y:this.npcs[n].rot.y, z:this.npcs[n].rot.z, w:this.npcs[n].rot.w},
                prot : {x:this.npcs[n].prot.x, y:this.npcs[n].prot.y, z:this.npcs[n].prot.z, w:this.npcs[n].prot.w},
                quat : {x:this.npcs[n].quat.x, y:this.npcs[n].quat.y, z:this.npcs[n].quat.z, w:this.npcs[n].quat.w},
                offset : {x:this.npcs[n].offset.x, y:this.npcs[n].offset.y, z:this.npcs[n].offset.z},
                angle : this.npcs[n].angle,
                angles : {x:this.npcs[n].angles.x, y:this.npcs[n].angles.y, z:this.npcs[n].angles.z},
                ptIdx : this.npcs[n].ptsIdx,
                actions:this.npcs[n].actions,
                anims:[],
                staticroot:this.npcs[n].staticroot,
                mass:this.npcs[n].mass,
                attackOffset : this.npcs[n].avatarDef.attackOffset ? {x : this.npcs[n].avatarDef.attackOffset.x, y : this.npcs[n].avatarDef.attackOffset.y, z : this.npcs[n].avatarDef.attackOffset.z} : null,
                avatarDef : this.npcs[n].avatarDef,
                skeleton : this.npcs[n].skeleton ? this.npcs[n].skeleton.toPhys() : null,
                skelScale: this.npcs[n].skelScale,
                script : this.npcs[n].script,
                script_o : this.npcs[n].script_o,
                dialog : null,
                nodeType : this.npcs[n].nodeType,
                attackForce : this.npcs[n].attackForce,
                charScale: this.npcs[n].charScale,
                pathStartPts: this.npcs[n].pathStartPts,
                scriptInstance : this.npcs[n].scriptInstance,
                selectedAnswer : this.npcs[n].selectedAnswer,
                currentDialogLine : this.npcs[n].currentDialogLine,
                dialogInstance : this.npcs[n].dialogInstance,
                
                target : {
                    type: "npc",    
                    id : this.npcs[n].target.id,
                    eid : this.npcs[n].target.eid,
                    name :  'npc-' + this.npcs[n].id,
                    pos :  {x:this.npcs[n].target.pos.x, y:this.npcs[n].target.pos.y, z:this.npcs[n].target.pos.z},
                    subsystems: []
                },
            }

            for(let a in this.npcs[n].anims){
                npcs[n].anims[a] = this.npcs[n].anims[a].toPhys();
            }

            if(this.npcs[n].dialog){
                npcs[n].dialog = {lines : []};
                for(let l=0;l<this.npcs[n].dialog.lines.length;l++){

                    npcs[n].dialog.lines[l] = 
                    {
                        id: this.npcs[n].dialog.lines[l].id, 
                        txt: this.npcs[n].dialog.lines[l].txt, 
                        action:  this.npcs[n].dialog.lines[l].action,
                        txtSize: {x : this.npcs[n].dialog.lines[l].txtSize.x, y : this.npcs[n].dialog.lines[l].txtSize.y, z : this.npcs[n].dialog.lines[l].txtSize.z},
                        answers: []
                    }

                     for(let a=0;a<this.npcs[n].dialog.lines[l].answers.length;a++){

                        npcs[n].dialog.lines[l].answers[a] = {
                            dialogID :  this.npcs[n].dialog.lines[l].answers[a].dialogID,
                            txt :  this.npcs[n].dialog.lines[l].answers[a].txt,
                            action:  this.npcs[n].dialog.lines[l].answers[a].action,
                            txtSize: {x : this.npcs[n].dialog.lines[l].answers[a].txtSize.x, y : this.npcs[n].dialog.lines[l].answers[a].txtSize.y, z : this.npcs[n].dialog.lines[l].answers[a].txtSize.z},
                        }
                     }
                }
            }



            for(let s =0;s<this.npcs[n].target.subsystems.length;s++){

                npcs[n].target.subsystems.push({
                    id : this.npcs[n].target.subsystems[s].id,
                    eid : this.npcs[n].target.subsystems[s].eid,
                    name : this.npcs[n].target.subsystems[s].name,
                    pos :  {x:this.npcs[n].target.subsystems[s].pos.x, y:this.npcs[n].target.subsystems[s].pos.y, z:this.npcs[n].target.subsystems[s].pos.z}
                })
            }
        }

        for(let n =0;n<this.drones.length;n++){

            drones[n] = {
                id: this.drones[n].id,
                pos : {x:this.drones[n].pos.x, y:this.drones[n].pos.y, z:this.drones[n].pos.z},
             
                rot : {x:this.drones[n].rot.x, y:this.drones[n].rot.y, z:this.drones[n].rot.z, w:this.drones[n].rot.w},
                weight : this.drones[n].weight,
                upLift: this.drones[n].upLift,
                ptIdx:this.drones[n].ptIdx,
                speed: this.drones[n].speed,

                target : {
                    type: "drone",    
                    id : this.drones[n].target.id,
                    name : this.drones[n].target.name,
                    pos :  {x:this.drones[n].target.pos.x, y:this.drones[n].target.pos.y, z:this.drones[n].target.pos.z},
                    subsystems: []
                },
              
                speedPale2: this.drones[n].speedPale2,
                speedPale1: this.drones[n].speedPale1,
                size:  {x:this.drones[n].size.x, y:this.drones[n].size.y, z:this.drones[n].size.z},
                offset : {x:this.drones[n].offset.x, y:this.drones[n].offset.y, z:this.drones[n].offset.z},
                caroffset: {x:this.drones[n].caroffset.x, y:this.drones[n].caroffset.y, z:this.drones[n].caroffset.z},
                activation : this.drones[n].activation,
                deactivation: this.drones[n].deactivation,
                weapons : [],
                pales : []
            };


            for(let s =0;s<this.drones[n].target.subsystems.length;s++){

                drones[n].target.subsystems.push({
                    id : this.drones[n].target.subsystems[s].id,
                    name : this.drones[n].target.subsystems[s].name,
                    pos :  {x:this.drones[n].target.subsystems[s].pos.x, y:this.drones[n].target.subsystems[s].pos.y, z:this.drones[n].target.subsystems[s].pos.z}

                })
            }
                


            for(let w of this.drones[n].weapons){

                 drones[n].weapons.push({   id:w.id, 
                                            projBlastForce:w.projBlastForce,
                                            projBlastImpact:w.projBlastImpact,
                                            projBlastRadius:w.projBlastRadius,
                                            projDelay:w.projDelay,
                                            projMass:w.projMass,
                                            projLL:w.projLL,
                                            projHoming:w.projHoming,
                                            projPts:{x:w.projPts.x,y:w.projPts.y,z:w.projPts.z},
                                            projSize:w.projSize,
                                            projSpeed:w.projSpeed,
                                            projTTL:w.projTTL,
                                        });
            }



            for(let p of this.drones[n].pales){

                 drones[n].pales.push({id:p.id, name:p.name, radiusX:p.radiusX, radiusZ:p.radiusZ, life:p.life, 
                                        rot: {x : p.rot.x, y : p.rot.y, z : p.rot.z, w : p.rot.w}, 
                                        rpos: {x : p.rpos.x, y : p.rpos.y, z : p.rpos.z}, 
                                        pos: {x : p.pos.x, y : p.pos.y, z : p.pos.z}, 
                                        target : p.target,
                                        height:p.height
                                        });
            }
        }


        for(let n =0;n<this.bonuses.length;n++){

            bonuses[n] = {
                id: this.bonuses[n].id,
                pos : {x:this.bonuses[n].pos.x, y:this.bonuses[n].pos.y, z:this.bonuses[n].pos.z},
                rot : {x:0, y:0, z:0,w:1},
                size: this.bonuses[n].size,
                scale: this.bonuses[n].scale,
                type: this.bonuses[n].type,
                amount: this.bonuses[n].amount
            };
        }

        for(let n =0;n<this.woods.length;n++){

            const woodObj = { id: this.woods[n].id, offset: { x: this.woods[n].offset.x , y: this.woods[n].offset.y* this.trackHeight, z: this.woods[n].offset.z }, ptIdx: this.woods[n].ptsIdx, "num": this.woods[n].num, "mass": this.woods[n].mass, "width": this.woods[n].width, "radius": this.woods[n].radius, objects: [], woods : [], spacing:this.woods[n].spacing }

            for (let i = 0; i < woodObj.num; i++) {
                woodObj.woods.push({
                    id : this.woods[n].objects[i].id,
                    pos: { x: this.woods[n].objects[i].pos.x, y: this.woods[n].objects[i].pos.y, z: this.woods[n].objects[i].pos.z },
                    angles: { x: this.woods[n].objects[i].angles.x, y: this.woods[n].objects[i].angles.y, z: this.woods[n].objects[i].angles.z },
                    rot: { x: this.woods[n].objects[i].quat.x, y: this.woods[n].objects[i].quat.y, z: this.woods[n].objects[i].quat.z, w: this.woods[n].objects[i].quat.w },
                    width: woodObj.width,
                    mass: woodObj.mass,
                    radius: woodObj.radius
                });
            }

            woods.push(woodObj)
        }


        return {
            trackPoints: trackPoints,
            trackSegments: trackSegments,
            gravity: this.gravity,
            terrain: this.terrain ? {offset: {x : this.terrain.offset.x, y : this.terrain.offset.y, z : this.terrain.offset.z}}: {offset: {x : 0, y : 0, z : 0}},
            friction: this.friction,
            restitution: this.restitution,
            curvePointsLU : this.curvePointsLU, 
            curvePointsRU : this.curvePointsRU, 
            curvePointsL : this.curvePointsL, 
            curvePointsR : this.curvePointsR, 
            curvePointsC : this.curvePointsC,
            curveType: this.curveType,
            groundMesh: this.groundMesh,
            woods: woods,
            jumpers: jumpers,
            NPoints: this.NPoints,
            interestPoints: interestPoints,
            xmeshes: xmeshs,
            bonuses: bonuses,
            turrets: turrets, //this.turrets,
            springs: springs, //this.springs,
            ropes: ropes, //this.ropes,
            loopings: this.loopings,
            worms: this.worms,
            tubes: this.tubes,
            waves: this.waves,
            drones: drones, //this.drones,
            spiders: spiders, //this.spiders,
            movingObjects: moks,
            grids: [], //this.grids,
            cyls: this.cyls,
            cubes: this.cubes,
            colcyls: this.colcyls,
            colcubes: this.colcubes,
            characters: characters,
            pathes: this.pathes, 
            triggers: triggers,
            npcs: npcs, //this.npcs,
            navmeshs: this.navmeshs,
            splits: [], //this.splits,
            NPoints: this.NPoints,
            lapTime: this.lapTime,
            tensionL: this.tensionL,
            tensionR: this.tensionR,
            tensionC: this.tensionC,
            gscale: this.gscale,
            AITable: this.AITable
        };

    }

    getTotalBonus(){
        let nBonus = this.bonuses.length;

        for(let n=0;n<this.interestPoints.length;n++){
            nBonus+=this.interestPoints[n].nBonuses;
        }

        
        for(let n=0;n<this.loopings.length;n++){
            nBonus+=this.loopings[n].nBonuses;
        }

        return nBonus;
    }
    
    getNodeSubSystem(targetNode){
        
        const tagetType = (targetNode & 0x00FF0000) >> 16;
        if(tagetType == 1){
            const npcId = (targetNode & 0x0000FF00) >> 8;
            const targetId = (targetNode & 0x000000FF);

            for(let n=0;n<this.npcs.length;n++){
                const npc =this.npcs[n];

                if((npc.target)&&(npc.target.id == npcId)){
                    for(let ss=0;ss<npc.target.subsystems.length;ss++){
                        if(npc.target.subsystems[ss].id === targetId){
                            return npc.target.subsystems[ss];
                        }
                    }
                }
            }
        }
    }

    
    findPath(pathFinder, startPos, forwardVec, targetNode, nodeType = 1){

        pathFinder.reset();

        if(targetNode<0)
            return null;

        let minDist = Infinity;
        let startNode = NaN;
        let found = false;
        let myTargetNode = NaN;

        if((targetNode & 0x00FF0000) != 0){
          
            const myss = this.getNodeSubSystem(targetNode);

            if(!myss)
              return null;

            for(let i=0;i<this.navmeshs.length;i++){
              const dist = this.navmeshs[i].pos.distanceTo(myss.pos);

              if(dist<minDist){
                  minDist = dist;
                  myTargetNode = i;
              }
            }
        }else
             myTargetNode = targetNode;

        for(let i =0;i<this.navmeshs.length;i++){

            if(!(this.navmeshs[i].type  & nodeType))
              continue;

            const delta = new THREE.Vector3().subVectors(this.navmeshs[i].pos, startPos);
            const d = delta.length();
            delta.normalize();
            const dot = (Math.max(0, forwardVec.dot(delta)));
            const weight = d * dot;
            if((d < minDist)&&(dot > 0)){
                minDist = d;
                startNode = i;
            }
        }

        pathFinder.distance[startNode] = 0;

        for(let i =0;i<this.navmeshs.length;i++){

            if(!(this.navmeshs[i].type  & nodeType))
              continue;

            let minDist = Infinity;
            let closest = -1;

            for(let l =0;l<this.navmeshs.length;l++){

                if(!(this.navmeshs[l].type  & nodeType))
                    continue;

                if((!pathFinder.visited[l])&&((pathFinder.distance[l]<minDist))){
                    minDist = pathFinder.distance[l];
                    closest = l;
                }
            }

            if(closest == myTargetNode){
                found = true;
                break;
            }

            if(closest<0){
                break;
            }
                

            pathFinder.visited[closest] = 1;


            for(let ll =0;ll<this.navmeshs[closest].links.length;ll++){

                const l = this.navmeshs[closest].links[ll];

                if(!(this.navmeshs[l].type  & nodeType))
                    continue;

                if(pathFinder.visited[l])
                    continue;

                const alt = pathFinder.distance[closest] + this.navmeshs[closest].pos.distanceTo(this.navmeshs[l].pos);
 
                if(alt < pathFinder.distance[l]){
                    pathFinder.distance[l] = alt;
                    pathFinder.predecessors[l] = closest;
                }
            }
        }

        if(!found)
            return null;

        let path = [];
        let current = myTargetNode;
        while(pathFinder.predecessors[current] != undefined){

            const node = pathFinder.predecessors[current];
            path.unshift(node);
            current = node;
        }

        path.unshift(startNode);
        path.push(myTargetNode);

        return path;

    }



    findInstance(lname){

        if(!lname)
            return null;

        for(let it =0; it <this.meshInstances.length; it ++){

            if(lname.startsWith(this.meshInstances[it].key))
                return this.meshInstances[it];
        }

        return null;

    }
    getCenter() {
        let min = null;
        let max = null;

        for (let n = 0; n < this.trackPoints.length; n++) {
            if (min == null)
                min = [this.trackPoints[n].pos.x, this.trackPoints[n].pos.y, this.trackPoints[n].pos.z];
            else
                min = [Math.min(this.trackPoints[n].pos.x, min[0]), Math.min(this.trackPoints[n].pos.y, min[1]), Math.min(this.trackPoints[n].pos.z, min[2])];

            if (max == null)
                max = [this.trackPoints[n].pos.x, this.trackPoints[n].pos.y, this.trackPoints[n].pos.z];
            else
                max = [Math.max(this.trackPoints[n].pos.x, max[0]), Math.max(this.trackPoints[n].pos.y, max[1]), Math.max(this.trackPoints[n].pos.z, max[2])];
        }

        const sz = [max[0] - min[0], max[1] - min[1], max[2] - min[2]];
        const hsz = [sz[0] / 2, sz[1] / 2, sz[2] / 2];

        this.totalSize = {x: sz[0], y: sz[1], z: sz[2]};

        this.ptsMin = min;
        this.ptsMax = max;

        return { x: min[0] + hsz[0], y: min[1] + hsz[1], z: min[2] + hsz[2] };
    }

    doCenter() {
        if(this.trackPoints.length<2){
            this.terrain.offset = { x: 0, y: 0, z: 0 };    
            return;
        }

        const c = this.getCenter();

        this.terrain.offset = { x: -c.x, y: -c.y, z: -c.z };
        for (let n = 0; n < this.trackPoints.length; n++) {
            this.trackPoints[n].pos.x -= c.x;
            this.trackPoints[n].pos.y -= c.y;
            this.trackPoints[n].pos.z -= c.z;
        }
    }

    findNPC(id){

        for(let n=0;n<this.npcs.length;n++){
            if(this.npcs[n].id === id)
                return this.npcs[n];
        }

        return null;

    }

    findClosestSeg(carPos, ocp){

        let cp = new THREE.Vector3();
        let dist = 1000000000000;
        let cur = -1;
    
        for(let n=0;n< this.trackPoints.length; n++){
          this.trackPoints[n].line.closestPointToPoint (carPos, true, cp);
          const d = cp.distanceTo(carPos);
    
          if(d<dist){
    
            ocp.set(cp.x, cp.y, cp.z);
            dist = d;
            cur=n;
          }
        }
        return cur;
      }


    
    getAdvancePos(car, time) {
        let carPos = new THREE.Vector3(car.pos.x, car.pos.y, car.pos.z);
        let cp = new THREE.Vector3();
        let cs = this.findClosestSeg(carPos, cp);
  
        if(cs < 0)
          return null;
  
        const vel = car.physicsBody.getLinearVelocity();
        let dv = new THREE.Vector3(vel.x(), vel.y(), vel.z()).multiplyScalar(time/ 1000.0).length();  
  
        let dcp = new THREE.Vector3().subVectors(cp , this.trackPoints[cs].pos) . length();
        
        let cd = this.trackPoints[cs].line.distance() - dcp;
  
        while(dv > cd) {
            dv -= cd;
            cs++;
            if(cs>=this.trackPoints.length)
              cs=0;
  
            cd = this.trackPoints[cs].line.distance();
            cp = this.trackPoints[cs].pos;
        }
  
        let ld = new THREE.Vector3();
  
        this.trackPoints[cs].line.delta(ld);
        ld.multiplyScalar( dv / cd);
  
        return new THREE.Vector3(cp.x + ld.x, cp.y + ld.y, cp.z + ld.z);
    }
    getCarDistance(car){
        const ccp = new THREE.Vector3();
        let cp = null;
        let dist = 1000000;
        let cs = -1;

        var searchArray = [];   // Array for second curve
        
        for(let n=0;n< this.AILines.length; n++) {
            
            this.AILines[n].closestPointToPoint (car.ChassisMesh.position, true, ccp);
            const d = ccp.distanceTo(car.ChassisMesh.position);

            if((cs<0)||(d<dist)) {
                cs = n * this.curveC.points.length / this.AILines.length;
                cp   = ccp.clone();
                dist = d;
            }
        }
        if((cs<0)||(cp === null))
            return 0.0;
        
        for(let n=0;n<=cs; n++) {
            searchArray.push(this.curveC.points[n]);
        }
        searchArray.push(cp);

        var curve2 = new THREE.CatmullRomCurve3(searchArray);
        return curve2.getLength() /  this.curveC.getLength();

        /*
        const pts = this.curveC.getSpacedPoints(this.NPoints);
        const lens = this.curveC.getLengths(this.NPoints);

        const line = new THREE.Line3();
        const ccp = new THREE.Vector3();
        let cp = null;
        let distToPoint;
        let dist = 1000000;
        let cs = -1;
        let dt = new THREE.Vector3();

        for(let n=0;n< this.NPoints; n++) {
            
            line.set(pts[n], pts[n+1]);
            line.delta(dt);
            dt.normalize();

            const pv = car.ChassisMesh.position.clone().projectOnVector(dt);

            //line.closestPointToPoint (car.ChassisMesh.position, true, ccp);
            //const d = ccp.distanceTo(car.ChassisMesh.position);

            if((cs<0)||(d<dist)) {
                cs = n;
                cp   = ccp.clone();
                dist = d;
            }
        }

        if((cs<0)||(cp === null))
            return;

        distToPoint = cp.distanceTo(pts[cs]);

        if(cs>0)
            distToPoint += lens[cs - 1] ;
        
        return distToPoint / lens[this.NPoints];
        */
    }

    getBackwardPos(car, length)
    {
        let dv = length 
        let cs = car.curSeg;
        let ics = cs;
  
        if(!(cs >= 0))
          return null;
  
        let cp = new THREE.Vector3();
        this.trackPoints[cs].line.closestPointToPoint (new THREE.Vector3(car.ChassisMesh.position.x, car.ChassisMesh.position.y, car.ChassisMesh.position.z), false, cp);
        let dcp = new THREE.Vector3().subVectors(cp , this.trackPoints[cs].pos) . length();
        
        //let cd = this.trackPoints[cs].line.distance() - dcp;
        let cd = dcp;
  
        while(dv > cd) {
            dv -= cd;

            cp = this.trackPoints[cs].pos;
            ics = cs;

            cs--;
            if(cs<0)
              cs = this.trackPoints.length - 1; 
  
            cd = this.trackPoints[cs].line.distance();
        }
  
        let ld = new THREE.Vector3();
  
        this.trackPoints[cs].line.delta(ld);
        ld.multiplyScalar( dv / this.trackPoints[ics].line.distance());
       
  
        return { x: cp.x - ld.x, y: cp.y - ld.y, z: cp.z - ld.z};
  
  
    }

    addWave(ptId, amplitude, frequency, phase, npts) {
        this.waves.push({ id: this.lastId++, idx: ptId, amplitude: amplitude, frequency: frequency, phase: phase, npts: npts })
    }

    addLooping(ptId, height, dir, npts, hide) {
        this.loopings.push({ id: this.lastId++, idx: ptId, height: height, dir: dir, npts: npts, hide: hide })
    }
    addWorm(ptId, height, dir, npts) {
        this.worms.push({ id: this.lastId++, idx: ptId, height: height, dir: dir, npts: npts })
    }
    addTube(ptId, height, width, dir, npts) {
        this.tubes.push({ id: this.lastId++, idx: ptId, height: height, width: width, dir: dir, npts: npts })
    }

    getWave(ptId) {
        for (let n = 0; n < this.waves.length; n++) {
            if (this.waves[n].idx == ptId)
                return this.waves[n];
        }
        return null;
    }

    getLooping(ptId) {
        for (let n = 0; n < this.loopings.length; n++) {
            if (this.loopings[n].idx == ptId)
                return this.loopings[n];
        }
        return null;
    }

    getWorm(ptId) {
        for (let n = 0; n < this.worms.length; n++) {
            if (this.worms[n].idx == ptId)
                return this.worms[n];
        }
        return null;
    }

    getTube(ptId) {
        for (let n = 0; n < this.tubes.length; n++) {
            if (this.tubes[n].idx == ptId)
                return this.tubes[n];
        }
        return null;
    }




    getSidePoint(p1, p2) {
        var rotat = new THREE.Quaternion().setFromAxisAngle(this.Uv, 3.14 / 2);

        var diff = new THREE.Vector3().subVectors(p2, p1);
        var ndiff = diff.clone().normalize();

        var qrot = new THREE.Quaternion();
        qrot.setFromUnitVectors(this.Zv, ndiff); // (unit vectors)
        qrot.multiply(rotat);

        var np = this.Zv.clone().applyQuaternion(qrot);
        np.y = 0;
        return np;
    }

    /*    
        getMidPts(p1, p2) {
            var diffL = p2.clone().sub(p1);
            var nDiff = diffL.clone().normalize();
    
            var eul = new THREE.Euler(0, Math.atan2(nDiff.x, nDiff.z), 0, "XYZ");
            var wallRot = new THREE.Quaternion().setFromEuler(eul);
            var wallPos = diffL.clone().divideScalar(2).add(p1)
    
            return { pos: wallPos, rot: wallRot, eul: eul, len: diffL.length() };
        }
      */


    getMidPts(p1, p2, dir) {
        var diffL = new THREE.Vector3().subVectors(p2,p1);
        var len = diffL.length();
        var nDiff = diffL.normalize();

        var eul = new THREE.Euler(0, Math.atan2(nDiff.x, nDiff.z), 0, "XYZ");
        if (dir == -1)
            eul.y += Math.PI;

        var wallRot = new THREE.Quaternion().setFromEuler(eul);
        const rot = new THREE.Quaternion().setFromUnitVectors( new THREE.Vector3(0,0,1), nDiff );

        return { pos: p1, quat: wallRot, rot:rot, eul: eul, len: len };

    }

    createTrackWalls() {
        this.walls = [];

        if (this.trackPoints.length < 2)
            return;

        const upVector = new THREE.Vector3(0, 1, 0);

        const nwalls = 15;

        const pl = this.curveL.getSpacedPoints(nwalls);
        const pr = this.curveR.getSpacedPoints(nwalls);
        
        

        for (let n = 0; n < nwalls; n++) {

            const pos1L = this.curveWL.getPointAt(n / nwalls);
            const pos1R = this.curveWR.getPointAt(n / nwalls);
            let pos2L;
            let pos2R;

            if (n < nwalls) {
                pos2L = this.curveWL.getPointAt((n + 1) / nwalls);
                pos2R = this.curveWR.getPointAt((n + 1) / nwalls);
            }
            else {
                pos2L = this.curveWL.getPointAt(0);
                pos2R = this.curveWR.getPointAt(0);
            }


            /*
            const pos1L = pl[n];
            const pos1R = pr[n];
            let pos2L;
            let pos2R;

            if ((n+1) < nwalls) {
                pos2L = pl[n+1];
                pos2R = pr[n+1];
            }
            else {
                pos2L = pl[0];
                pos2R = pr[0];
            }
            */

            const ptsL = this.getMidPts(pos1L, pos2L, 1);
            const ptsR = this.getMidPts(pos1R, pos2R, -1);

            ptsL.boxSize = new THREE.Vector3(0.25, 0.25, ptsL.len);
            ptsR.boxSize = new THREE.Vector3(0.25, 0.25, ptsR.len);

            this.walls.push(ptsL);
            this.walls.push(ptsR);
        }
    }


    getWallPt(pos1, binormal, normal, wallLen, height) {
        const lat = binormal.clone().normalize().multiplyScalar(wallLen);
        const up = normal.clone().normalize().multiplyScalar(height);
        lat.add(up);
        /*
        lat.y += height;
        lat.setLength(height);
        */
        lat.add(pos1);
        return lat;
    }


    findLooping(pos){

        for(let l=0;l<this.loopings.length;l++){
            if(this.loopings[l].bbox.containsPoint(pos)){
                //console.log('inside looping')
                return this.loopings[l];
            }
        }

        return null;
    }

    createTrackMesh(uvPos, uvScale) {


        if (this.trackPoints.length < 2){

            const forwardVec = new THREE.Vector3(0,0,1);

            const p1 = new THREE.Vector3(this.trackPoints[0].pos.x,this.trackPoints[0].pos.y, this.trackPoints[0].pos.z);
            const p2 = new THREE.Vector3(this.trackPoints[0].pos.x + 1.0,this.trackPoints[0].pos.y, this.trackPoints[0].pos.z);

            this.trackPoints[0].line = new THREE.Line3(p1, p2);

            const diffL = p2.clone().sub(p1);
            const nDiff = diffL.clone().normalize();

            this.trackPoints[0].rot = new THREE.Quaternion();
            this.trackPoints[0].rot.setFromUnitVectors(this.Zv, nDiff); // (unit vecto                
            this.trackPoints[0].length = p1.distanceTo(p2);

            const np = this.getSidePoint(p1, p2);
            const np1 = np.clone().multiplyScalar(this.trackPoints[0].width);

            const pos1 = new THREE.Vector3().addVectors(p1, np1);
            const pos2 = new THREE.Vector3().subVectors(p1, np1);

            this.trackPoints[0].l = pos1.clone();
            this.trackPoints[0].r = pos2.clone();
            this.trackPoints[0].side = np1.clone().normalize();
            return null;
        }
        
            
        var yOfset = 0.5;
        this.curvePointsL = [];
        this.curvePointsR = [];
        this.curvePointsWL = [];
        this.curvePointsWR = [];
        this.curvePointsC = [];

        var np1;
        let npos = null;

        const last = this.trackPoints.length - 1;

        for (let n = 0; n < this.trackPoints.length; n++) {
            
            if(this.trackPoints[n].opos)
                this.trackPoints[n].pos = this.trackPoints[n].opos.clone();
        }

        for (let n = 0; n < this.trackPoints.length; n++) {
            var p1, p2, w;


            if (npos === null)
                p1 = this.trackPoints[n].pos.clone();
            else {
                p1 = npos;
                npos = null;
            }

            if (n < this.trackPoints.length - 1) {
                p2 = this.trackPoints[n + 1].pos.clone();
            }
            else {
                p2 = this.trackPoints[0].pos.clone();
            }

            this.trackPoints[n].line = new THREE.Line3(p1, p2);

            var diffL = p2.clone().sub(p1);
            var nDiff = diffL.clone().normalize();

            this.trackPoints[n].rot = new THREE.Quaternion();
            this.trackPoints[n].rot.setFromUnitVectors(this.Zv, nDiff); // (unit vecto                
            this.trackPoints[n].length = p1.distanceTo(p2);

            const np = this.getSidePoint(p1, p2);
            np1 = np.clone().multiplyScalar(this.trackPoints[n].width);

            var pos1 = new THREE.Vector3().addVectors(p1, np1);
            var pos2 = new THREE.Vector3().subVectors(p1, np1);

            var posW1 = new THREE.Vector3().addVectors(p1, np1.clone().multiplyScalar(this.wallSpace));
            var posW2 = new THREE.Vector3().subVectors(p1, np1.clone().multiplyScalar(this.wallSpace));


            this.trackPoints[n].l = pos1.clone();
            this.trackPoints[n].r = pos2.clone();
            this.trackPoints[n].side = np1.clone().normalize();

            this.curvePointsC.push(p1);
            this.curvePointsL.push(pos1);
            this.curvePointsR.push(pos2);
            this.curvePointsWL.push(posW1);
            this.curvePointsWR.push(posW2);


            const looping = this.getLooping(n);
            const worm = this.getWorm(n);
            const tube = this.getTube(n);
            const wave = this.getWave(n);

            if (looping) {

                const nextId = ((n + 2) < this.trackPoints.length) ? n + 1 : 0;
                const sz = this.trackPoints[n].width;
                const sz2 = this.trackPoints[nextId].width;

                const p1 = new THREE.Vector3(this.trackPoints[n].pos.x, this.trackPoints[n].pos.y, this.trackPoints[n].pos.z);
                const p2 = new THREE.Vector3(this.trackPoints[nextId].pos.x, this.trackPoints[nextId].pos.y, this.trackPoints[nextId].pos.z);

                const size = new THREE.Vector3().subVectors(p2, p1);

                const halfSz = size.clone().divideScalar(2);
                const l = Math.sqrt(halfSz.x * halfSz.x + halfSz.z * halfSz.z);
                const delta = new THREE.Vector3().subVectors(p2, p1).divideScalar(looping.npts);
                const rot = this.trackPoints[n].rot.clone();
                const dz = (sz2 - sz);
                const nBonus = 5;
                const scale = 4;

                looping.min = [10000, 10000, 10000];
                looping.max = [-10000, -10000, -10000];

                looping.bonuses = [];

                let lpos1, lpos2;

                for (let i = 0; i <= looping.npts; i++) {
                    const a = (i * Math.PI * 2.0) / looping.npts + Math.PI / 2;
                    const pt = new THREE.Vector3((l - (Math.cos(a) * l)) * looping.dir, (-Math.sin(a)) * looping.height / 2 + looping.height / 2, (sz * 3 * (1.0 - i / looping.npts) - sz * 3) * looping.dir);
                    const norm = new THREE.Vector3(Math.cos(a) * 2, Math.sin(a) * 2, 0);
                    const dd = new THREE.Vector3().addVectors(pt, norm);

                    pt.applyQuaternion(rot);
                    dd.applyQuaternion(rot);

                    pt.add(p1);

                    if (i % nBonus == 0)
                        looping.bonuses.push({ ptIdx: n, offset: dd, type: 0, time: 0, amount : 0.5, size : 5, scale: scale });

                    lpos1 = new THREE.Vector3().addVectors(pt, np1);
                    lpos2 = new THREE.Vector3().subVectors(pt, np1);


                    this.curvePointsC.push(pt);

                    this.curvePointsL.push(lpos1);
                    this.curvePointsR.push(lpos2);

                    const min = [Math.min(lpos2.x, lpos1.x), Math.min(lpos2.y, lpos1.y), Math.min(lpos2.z, lpos1.z)];
                    const max = [Math.max(lpos2.x, lpos1.x), Math.max(lpos2.y, lpos1.y), Math.max(lpos2.z, lpos1.z)];

                    looping.min = [Math.min(looping.min[0], min[0]), Math.min(looping.min[1], min[1]), Math.min(looping.min[2], min[2])];
                    looping.max = [Math.max(looping.max[0], max[0]), Math.max(looping.max[1], max[1]), Math.max(looping.max[2], max[2])];
                }

                looping.bbox = new THREE.Box3(  new THREE.Vector3(looping.min[0], looping.min[1], looping.min[2]),
                                                new THREE.Vector3(looping.max[0], looping.max[1], looping.max[2]));

                npos = new THREE.Vector3().lerpVectors(lpos1, lpos2, 0.5);

                this.trackPoints[nextId].opos = this.trackPoints[nextId].pos.clone();
                this.trackPoints[nextId].pos.copy(npos);
                

                const halfSize = new THREE.Vector3((looping.max[0] - looping.min[0]) / 2.0, (looping.max[1] - looping.min[1]), (looping.max[2] - looping.min[2]) / 2.0);
                looping.center = new THREE.Vector3(looping.min[0] + halfSize.x, looping.min[1] + halfSize.y / 2.0, looping.min[2] + halfSize.z);

                this.trackSegments[n]= { id : n, looping:true,  tube:false, worm:false, min:looping.min, max:looping.max, halfSize: halfSize, center: looping.center };

            } else if (worm) {

                const nextId = ((n + 2) < this.trackPoints.length) ? n + 1 : 0;
                const sz = this.trackPoints[n].width;

                const p1 = new THREE.Vector3(this.trackPoints[n].pos.x, this.trackPoints[n].pos.y, this.trackPoints[n].pos.z);
                const p2 = new THREE.Vector3(this.trackPoints[nextId].pos.x, this.trackPoints[nextId].pos.y, this.trackPoints[nextId].pos.z);

                const size = new THREE.Vector3().subVectors(p2, p1);

                const l = size.length();
                const rot = this.trackPoints[n].rot.clone();
                const nBonus = 5;
                const scale = 4;

                worm.min = [10000, 10000, 10000];
                worm.max = [-10000, -10000, -10000];

                const c1 = 1.0;
                const c2 = 2.0;

                for (let i = 0; i <= worm.npts; i++) {
                    const a = (i * Math.PI * c1 + Math.PI * (2.0 - c1)) / worm.npts;
                    const a2 = (i * Math.PI * c2 + Math.PI * (2.0 - c2)) / worm.npts;

                    const eul1 = new THREE.Euler(-a, 0, 0, "ZYX");
                    const eul2 = new THREE.Euler(-a2, 0, 0, "ZYX");

                    const pos1 = new THREE.Vector3(i * l / worm.npts, 0, sz);
                    const pos2 = new THREE.Vector3(i * l / worm.npts, 0, sz + sz);

                    pos1.applyEuler(eul1);
                    pos2.applyEuler(eul2);

                    /*
                    pos1.y += ((Math.sin(a) + 1.0) / 2.0) * sz;
                    pos2.y += ((Math.sin(a) + 1.0) / 2.0) * sz;
                    */
                    

                    pos1.applyQuaternion(rot);
                    pos2.applyQuaternion(rot);

                    pos1.add(p1);
                    pos2.add(p1);

                    /*
                    const norm = new THREE.Vector3(0, Math.cos(a) * 2, Math.sin(a) * 2);
                    const dd = new THREE.Vector3().addVectors(pt, norm);
                    dd.applyQuaternion(rot);


                    if (i % nBonus == 0)
                        this.bonusDefs.push({ ptIdx: n, offset: dd, type: 0, time: 0, scale: scale });
                    */

                    this.curvePointsC.push(new THREE.Vector3().lerpVectors(pos1, pos2, 0.5));
                    this.curvePointsL.push(pos1);
                    this.curvePointsR.push(pos2);

                    const min = [Math.min(pos2.x, pos1.x), Math.min(pos2.y, pos1.y), Math.min(pos2.z, pos1.z)];
                    const max = [Math.max(pos2.x, pos1.x), Math.max(pos2.y, pos1.y), Math.max(pos2.z, pos1.z)];

                    worm.min = [Math.min(worm.min[0], min[0]), Math.min(worm.min[1], min[1]), Math.min(worm.min[2], min[2])];
                    worm.max = [Math.max(worm.max[0], max[0]), Math.max(worm.max[1], max[1]), Math.max(worm.max[2], max[2])];

                }

                const halfSize = new THREE.Vector3((worm.max[0] - worm.min[0]) / 2.0, (worm.max[1] - worm.min[1]), (worm.max[2] - worm.min[2]) / 2.0);
                worm.center = new THREE.Vector3(worm.min[0] + halfSize.x, worm.min[1] + halfSize.y / 2.0, worm.min[2] + halfSize.z);

                this.trackSegments[n]= { id : n, looping:false,  tube:false, worm:true, min:worm.min, max:worm.max, halfSize: halfSize, center: worm.center };

            } else if (tube) {

                const nextId = ((n + 2) < this.trackPoints.length) ? n + 1 : 0;
                const sz = this.trackPoints[n].width;

                const p1 = new THREE.Vector3(this.trackPoints[n].pos.x, this.trackPoints[n].pos.y, this.trackPoints[n].pos.z);
                const p2 = new THREE.Vector3(this.trackPoints[nextId].pos.x, this.trackPoints[nextId].pos.y, this.trackPoints[nextId].pos.z);

                const size = new THREE.Vector3().subVectors(p2, p1);

                const l = size.length() - sz * 4;
                const rot = this.trackPoints[n].rot.clone();
                const nBonus = 5;
                const scale = 4;

                tube.min = [10000, 10000, 10000];
                tube.max = [-10000, -10000, -10000];

                const c = 1.8
                const cs = -0.4;

                const ofset = -Math.sin(Math.PI * cs);
                const hpt = tube.npts / 2.0;

                for (let i = 0; i <= tube.npts; i++) {
                    const a = (i * Math.PI * c) / tube.npts + Math.PI * cs;
                    let z = Math.cos(a) * tube.width;

                    let zofs1 = 0;
                    let zofs2 = 0;

                    const coef = i < hpt ? (hpt - i) / hpt : 0;

                    const pos1 = new THREE.Vector3(i * l / tube.npts + sz * 2, (Math.sin(a) + ofset) * tube.height, z + zofs1);
                    const pos2 = new THREE.Vector3(i * l / tube.npts + sz * coef, (Math.sin(a) + ofset) * tube.height, z + zofs2 + sz * coef);

                    pos1.applyQuaternion(rot);
                    pos2.applyQuaternion(rot);
               
                    pos1.add(p1);
                    pos2.add(p1);

                    /*
                    const norm = new THREE.Vector3(0, Math.cos(a) * 2, Math.sin(a) * 2);
                    const dd = new THREE.Vector3().addVectors(pt, norm);
                    dd.applyQuaternion(rot);


                    if (i % nBonus == 0)
                        this.bonusDefs.push({ ptIdx: n, offset: dd, type: 0, time: 0, scale: scale });
                    */

                    this.curvePointsC.push(new THREE.Vector3().lerpVectors(pos1, pos2, 0.5));
                    this.curvePointsL.push(pos1);
                    this.curvePointsR.push(pos2);

                    const min = [Math.min(pos2.x, pos1.x), Math.min(pos2.y, pos1.y), Math.min(pos2.z, pos1.z)];
                    const max = [Math.max(pos2.x, pos1.x), Math.max(pos2.y, pos1.y), Math.max(pos2.z, pos1.z)];

                    tube.min = [Math.min(tube.min[0], min[0]), Math.min(tube.min[1], min[1]), Math.min(tube.min[2], min[2])];
                    tube.max = [Math.max(tube.max[0], max[0]), Math.max(tube.max[1], max[1]), Math.max(tube.max[2], max[2])];
                }

                const halfSize = new THREE.Vector3((tube.max[0] - tube.min[0]) / 2.0, (tube.max[1] - tube.min[1]), (tube.max[2] - tube.min[2]) / 2.0);
                tube.center = new THREE.Vector3(tube.min[0] + halfSize.x, tube.min[1] + halfSize.y / 2.0, tube.min[2] + halfSize.z);

                this.trackSegments[n]= { id : n, looping:false,  worm:false,tube:true, min:tube.min, max:tube.max, halfSize: halfSize, center: tube.center };

            } else if (wave) {

                const nextId = ((n + 2) < this.trackPoints.length) ? n + 1 : 0;
                const sz = this.trackPoints[n].width;

                const p1 = new THREE.Vector3(this.trackPoints[n].pos.x, this.trackPoints[n].pos.y, this.trackPoints[n].pos.z);
                const p2 = new THREE.Vector3(this.trackPoints[nextId].pos.x, this.trackPoints[nextId].pos.y, this.trackPoints[nextId].pos.z);

                const size = new THREE.Vector3().subVectors(p2, p1);

                const l = size.length();
                const rot = this.trackPoints[n].rot.clone();

                wave.min = [10000, 10000, 10000];
                wave.max = [-10000, -10000, -10000];

                const shift = 1.4;

                for (let i = 2; i < wave.npts; i++) {

                    const yofs  = (Math.sin(i * wave.frequency * Math.PI * 2 / wave.npts + wave.phase) + 1.0) * wave.amplitude;
                    const yofs2 = (Math.sin(i * wave.frequency * Math.PI * 2 / wave.npts + wave.phase + shift) + 1.0) * wave.amplitude;
                    const p = new THREE.Vector3().lerpVectors(p1, p2, i / wave.npts);

                    const pos1 = new THREE.Vector3().addVectors(p, np1);
                    const pos2 = new THREE.Vector3().subVectors(p, np1);

                    pos1.y += yofs;
                    pos2.y += yofs2;

                    this.curvePointsC.push(new THREE.Vector3().lerpVectors(pos1, pos2, 0.5));
                    this.curvePointsL.push(pos1);
                    this.curvePointsR.push(pos2);

                    const min = [Math.min(pos2.x, pos1.x), Math.min(pos2.y, pos1.y), Math.min(pos2.z, pos1.z)];
                    const max = [Math.max(pos2.x, pos1.x), Math.max(pos2.y, pos1.y), Math.max(pos2.z, pos1.z)];

                    wave.min = [Math.min(wave.min[0], min[0]), Math.min(wave.min[1], min[1]), Math.min(wave.min[2], min[2])];
                    wave.max = [Math.max(wave.max[0], max[0]), Math.max(wave.max[1], max[1]), Math.max(wave.max[2], max[2])];

                }

                const halfSize = new THREE.Vector3((wave.max[0] - wave.min[0]) / 2.0, (wave.max[1] - wave.min[1]), (wave.max[2] - wave.min[2]) / 2.0);
                wave.center = new THREE.Vector3(wave.min[0] + halfSize.x, wave.min[1] + halfSize.y / 2.0, wave.min[2] + halfSize.z);

                this.trackSegments[n]= { id : n, looping:false,  worm:false, tube:false, wave : true, min:wave.min, max:wave.max, halfSize: halfSize, center: wave.center };

            }else{

                if(!this.trackSegments[n])
                  this.trackSegments[n]= { id : n, min:[10000,10000,10000], max:[-10000,-10000,-10000],  looping:false,  worm:false, tube:false, halfSize: null, center: null };
        
                const min = [Math.min( pos2.x, pos1.x), Math.min( pos2.y, pos1.y), Math.min( pos2.z, pos1.z)];
                const max = [Math.max( pos2.x, pos1.x), Math.max( pos2.y, pos1.y), Math.max( pos2.z, pos1.z)];
        
                this.trackSegments[n].min = [Math.min( this.trackSegments[n].min[0], min[0]), Math.min( this.trackSegments[n].min[1], min[1]), Math.min( this.trackSegments[n].min[2], min[2])];
                this.trackSegments[n].max = [Math.max( this.trackSegments[n].max[0], max[0]), Math.max( this.trackSegments[n].max[1], max[1]), Math.max( this.trackSegments[n].max[2], max[2])];
        
                if(n>=1)
                {
                  this.trackSegments[n-1].min = [Math.min( this.trackSegments[n].min[0], this.trackSegments[n-1].min[0]), Math.min( this.trackSegments[n].min[1], this.trackSegments[n-1].min[1]), Math.min( this.trackSegments[n].min[2], this.trackSegments[n-1].min[2])];
                  this.trackSegments[n-1].max = [Math.max( this.trackSegments[n].max[0], this.trackSegments[n-1].max[0]), Math.max( this.trackSegments[n].max[1], this.trackSegments[n-1].max[1]), Math.max( this.trackSegments[n].max[2], this.trackSegments[n-1].max[2])];
                }else{
                  this.trackSegments[last] = { id : last, min:[this.trackSegments[n].min[0], this.trackSegments[n].min[1],  this.trackSegments[n].min[2]], max:[this.trackSegments[n].max[0], this.trackSegments[n].max[1],  this.trackSegments[n].max[2]],  worm:false,  tube:false,  looping:false, halfSize: null, center: null };
                }
              }
        }


        //this.CalculateTangentArray(track.roadObj.geometry.index.count, track.roadObj.geometry.index.count / 3, track.roadObj.geometry.index.array, track.roadObj.geometry.attributes.position.array, track.roadObj.geometry.attributes.normal.array, track.roadObj.geometry.attributes.uv.array);


        const upVector = new THREE.Vector3(0,1,0);

        
        this.curveL = new THREE.CatmullRomCurve3(this.curvePointsL, true, this.curveType, this.tensionL);
        this.curveR = new THREE.CatmullRomCurve3(this.curvePointsR, true, this.curveType, this.tensionR);
        this.curveWL = new THREE.CatmullRomCurve3(this.curvePointsWL, true, this.curveType, this.tensionL);
        this.curveWR = new THREE.CatmullRomCurve3(this.curvePointsWR, true, this.curveType, this.tensionR);
        this.curveC = new THREE.CatmullRomCurve3(this.curvePointsC, true, this.curveType, this.tensionC);

        this.AILines = [];

        for(let ipt =0; ipt<this.NPoints; ipt++){

            const n1 = ipt / this.NPoints;
            const n2 = (ipt+1) / this.NPoints;

            const p1 = this.curveC.getPoint(n1);
            const p2 = this.curveC.getPoint(n2);

            this.AILines[ipt] = new THREE.Line3(p1, p2);
        }
        

        this.curveL.arcLengthDivisions = this.NPoints;
        this.curveR.arcLengthDivisions = this.NPoints;
        this.curveC.arcLengthDivisions = this.NPoints;
          
        this.curveL.updateArcLengths();
        this.curveR.updateArcLengths();
        this.curveC.updateArcLengths();

        this.curveCLen = this.curveC.getLength();
        this.curveLLen = this.curveL.getLength();
        this.curveRLen = this.curveR.getLength();

        this.curveCFrames = this.curveC.computeFrenetFrames(this.NPoints, true);

        this.curvePointsLU = [];
        this.curvePointsRU = [];

        const lFrames = this.curveC.computeFrenetFrames(  this.NPoints, true);
        //const rFrames = this.curveR.computeFrenetFrames(  this.NPoints, true);

        for (let n = 0; n < this.curvePointsL.length; n++) {

            const u = n / this.curvePointsL.length;
            const uu = Math.floor(u *  this.NPoints);

            const pos1L = this.curveL.getPoint(u);
            const pos1R = this.curveR.getPoint(u);
            const deltaC = new THREE.Vector3().subVectors(pos1L, pos1R).normalize();

            const t1=this.curveL.getTangent(u);
            const t2=this.curveR.getTangent(u);

            const bn1 = t1.clone().cross(deltaC);
            const bn2 = t2.clone().cross(deltaC);

            this.curvePointsLU.push(this.getWallPt(pos1L, deltaC, bn1,  this.borderWidth , this.borderHeight));
            this.curvePointsRU.push(this.getWallPt(pos1R, deltaC, bn2, -this.borderWidth , this.borderHeight));
        }
    
        this.curveLU = new THREE.CatmullRomCurve3(this.curvePointsLU, true, this.curveType, this.tensionL);
        this.curveRU = new THREE.CatmullRomCurve3(this.curvePointsRU, true, this.curveType, this.tensionR);
             
        this.curveLU.arcLengthDivisions = this.NPoints;
        this.curveRU.arcLengthDivisions = this.NPoints;
      
        this.curveLU.updateArcLengths();
        this.curveRU.updateArcLengths();
        

        //this.curveL.closed= true;
        //this.curveR.closed= true;

        this.positions = [];
        this.indices = [];
        this.indices2 = [];
        this.texcoords = [];
        this.texcoords2 = [];

       
        let uvfac = 0 ;

        const cL = this.curveC.getLength();
        const bumpUvScale = { x:  0.5, y: 1.0};
        const nMSidePts = 4;
        const midCoord = new THREE.Vector3();

        for (let n = 0; n <= this.NPoints; n++) {

            const u = n / this.NPoints;
            const u1 = (n+1) / this.NPoints;

            const posL = this.curveL.getPoint(u);
            const posR = this.curveR.getPoint(u);

            for(let m=0;m<nMSidePts;m++){

                const r = m / (nMSidePts -1);

                midCoord.lerpVectors(posL, posR, r);

                this.positions.push (midCoord.x , midCoord.y, midCoord.z);
                this.texcoords.push ( r *  uvScale.x , uvfac * uvScale.y);
                this.texcoords2.push( r              , uvfac);
            }
            
            const latL = this.curveLU.getPoint(u);
            this.positions.push (latL.x, latL.y, latL.z);
            this.texcoords.push (1                 , uvfac * uvScale.y);
            this.texcoords2.push(0                 , uvfac);

            const latR = this.curveRU.getPoint(u);
            this.positions.push (latR.x, latR.y, latR.z);
            this.texcoords.push (2                  , uvfac * uvScale.y);
            this.texcoords2.push(1                 , uvfac);


            const pts1 = this.curveC.getPoint(u);
            const pts2 = this.curveC.getPoint(u1);
            const dddd = pts1.distanceTo(pts2) / cL;

            uvfac += dddd;
        }

        const vStride = 2 + nMSidePts;


        for (let n = 0; n < this.NPoints; n++) {

            for(let m= 0;m<(nMSidePts-1);m++){
                let i1 = n * vStride + 0 + m;
                let i2 = n * vStride + 1 + m;

                let i3 = (n + 1) * vStride + 0 + m;
                let i4 = (n + 1) * vStride + 1 + m;

                this.indices.push(i1, i2, i3);
                this.indices.push(i4, i3, i2);
            }
        }

        for (let n = 0; n < this.NPoints; n++) {
            let i1 = n * vStride + 0;
            let i2 = n * vStride + nMSidePts;

            let i3 = (n + 1) * vStride + 0;
            let i4 = (n + 1) * vStride + nMSidePts;

            this.indices2.push(i3, i2, i1);
            this.indices2.push(i2, i3, i4);

            i1 = n * vStride + (nMSidePts -1);
            i2 = n * vStride + (nMSidePts -1) + 2;

            i3 = (n + 1) * vStride + (nMSidePts -1);
            i4 = (n + 1) * vStride + (nMSidePts -1) + 2;

            this.indices2.push(i1, i2, i3);
            this.indices2.push(i4, i3, i2);
        }

        this.trackPoints[0].pos=this.curveC.getPoint(0);
    }

    computeWoods(woodObj)
    {
        const tpts = this.trackPoints[woodObj.ptIdx];


        const tpts2 = woodObj.ptIdx + 1 < this.trackPoints.length ? this.trackPoints[woodObj.ptIdx + 1] : {pos : new THREE.Vector3(tpts.pos.x, tpts.pos.y, tpts.pos.z + 5)};
        const diff = tpts2.pos.clone().sub(tpts.pos);
        const lPt = woodObj.spacing ? woodObj.spacing : woodObj.radius * 2.2;
        const ndiff = diff.clone().normalize();

        const eul1 = new THREE.Euler(0,  Math.PI/2, 0, "XYZ");
        const rot1 = new THREE.Quaternion().setFromEuler(eul1);

        woodObj.rot = tpts.rot.clone();
        woodObj.rot.multiply(rot1);

        const q = new THREE.Quaternion(woodObj.rot.x, woodObj.rot.y, woodObj.rot.z, woodObj.rot.w);

        const eul = new THREE.Euler().setFromQuaternion(woodObj.rot);
  

        for (let n = 0; n < woodObj.num; n++) {
            const posDelta = ndiff.clone().multiplyScalar(n * lPt);
            woodObj.objects[n].pos.x = tpts.pos.x + woodObj.offset.x + posDelta.x;
            woodObj.objects[n].pos.y = tpts.pos.y + woodObj.offset.y + posDelta.y + woodObj.radius;
            woodObj.objects[n].pos.z = tpts.pos.z + woodObj.offset.z + posDelta.z;

            woodObj.objects[n].angles.x = eul.x;
            woodObj.objects[n].angles.y = eul.y;
            woodObj.objects[n].angles.z = eul.z;

            woodObj.objects[n].quat.x = woodObj.rot.x;
            woodObj.objects[n].quat.y = woodObj.rot.y;
            woodObj.objects[n].quat.z = woodObj.rot.z;
            woodObj.objects[n].quat.w = woodObj.rot.w;

            woodObj.objects[n].rot = woodObj.objects[n].quat;

            woodObj.woods[n].id = woodObj.objects[n].id;
            woodObj.woods[n].rot=q;
            woodObj.woods[n].pos=woodObj.objects[n].pos;
            woodObj.woods[n].mass=woodObj.mass;
            woodObj.woods[n].width=woodObj.width;
            woodObj.woods[n].radius=woodObj.radius;

        }
    }

    computeXMesh(xmesh){
        const center = new THREE.Vector3();
        const size = new THREE.Vector3();

        const o = xmesh.mesh;
        
        o.geometry.computeBoundingBox();
        o.geometry.boundingBox.getCenter(center);
        o.geometry.boundingBox.getSize(size);

        
        /*
        o.geometry.translate(-center.x, -center.y, -center.z);
        o.position.add(center);
        o.geometry.computeBoundingBox();
        */                

        const boxGeo = new THREE.BoxGeometry(size.x, size.y, size.z).toNonIndexed();
        //boxGeo.translate(center.x, center.y, center.z);

        boxGeo.computeBoundingBox();

        boxGeo.groups = [];

        /*
        o.geometry = boxGeo.clone();
        o.material = [new THREE.MeshBasicMaterial({color:0xFF0000}), new THREE.MeshBasicMaterial({color:0x0000FF})];
        o.geometry.groups.push({start :0, count:  boxGeo.attributes.position.count});
        o.geometry.groups.push({start :boxGeo.attributes.position.count, count : 0});
        */

        xmesh.size = size.clone();
        xmesh.boxGeo = boxGeo;
        xmesh.boxOffset = new THREE.Vector3(); //center.clone();
        xmesh.nVtx = boxGeo.attributes.position.array.length;
        xmesh.meshArray = boxGeo.attributes.position.array;
    }

    encodeSplitCase(a, b, c) {
        return ((a << 4) |(b << 2) | (c));
    }

    fraction(a, b) {
        return Math.abs(a) / (Math.abs(a) + Math.abs(b));
    }

    dist(a, b, c, d, x, y, z) {
        return (a * x + b * y + c * z + d);
    }

    signd(a, b, c, d, x,y, z) {
        return Math.sign(a * x + b * y + c * z + d);
    }

    splitt(vertices , index, v0, v1, v2){

        vertices[index++] = v0.x;
        vertices[index++] = v0.y;
        vertices[index++] = v0.z;

        vertices[index++] = v1.x;
        vertices[index++] = v1.y;
        vertices[index++] = v1.z;

        vertices[index++] = v2.x;
        vertices[index++] = v2.y;
        vertices[index++] = v2.z;

        return index;
    }

    splittn(normals , index, n0, n1, n2){

      
        normals[index++] = n0.x;
        normals[index++] = n0.y;
        normals[index++] = n0.z;
    
        normals[index++] = n1.x;
        normals[index++] = n1.y;
        normals[index++] = n1.z;
    
        normals[index++] = n2.x;
        normals[index++] = n2.y;
        normals[index++] = n2.z;
      
        return index;
    }

    splittuv(uvs , index, uv0, uv1, uv2){


        uvs[index++] = uv0.x;
        uvs[index++] = uv0.y;

        uvs[index++] = uv1.x;
        uvs[index++] = uv1.y;

        uvs[index++] = uv2.x;
        uvs[index++] = uv2.y;

        return index;
    }

    doSplit(a,b,c,d, xmesh){
        const v = [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()];
        const n = [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()];
        const uv = [new THREE.Vector2(), new THREE.Vector2(), new THREE.Vector2(), new THREE.Vector2(), new THREE.Vector2(), new THREE.Vector2()];
        
        const newXmesh = {name : xmesh.name, splitted: true,nVtx : 0, nNorms :0, nUvs : 0, nVtxAlloc :xmesh.nVtxAlloc, meshData : null, meshArray : null, size : null, mass: 100, pos: xmesh.pos.clone(), mesh: null, rot: xmesh.rot.clone()};
        newXmesh.vertices = new Float32Array(newXmesh.nVtxAlloc*3);
        newXmesh.normals = new Float32Array(newXmesh.nVtxAlloc*3);
        newXmesh.uvs = new Float32Array(newXmesh.nVtxAlloc*2);

        xmesh.vertices = new Float32Array(xmesh.nVtxAlloc*3);
        xmesh.normals = new Float32Array(xmesh.nVtxAlloc*3);
        xmesh.uvs = new Float32Array(xmesh.nVtxAlloc*2);

        const onPlane1 = new Float32Array(xmesh.mesh.geometry.attributes.position.count * 3 * 2);
        const onPlane2 = new Float32Array(xmesh.mesh.geometry.attributes.position.count * 3 * 2);

        const minPlane1 = new THREE.Vector3( 1000000, 1000000, 1000000);
        const minPlane2 = new THREE.Vector3( 1000000, 1000000, 1000000);
    
        const maxPlane1 = new THREE.Vector3(-1000000,-1000000,-1000000);
        const maxPlane2 = new THREE.Vector3(-1000000,-1000000,-1000000);
        
        const sarr = new Int8Array(4);
        const uarr = new Uint8Array(4);

        let nVtx1 = 0;
        let nNorms1 = 0;
        let nUvs1 = 0;

        let nOnPlane1 = 0;
        let nOnPlane2 = 0;

        let grpCnt1 =[];
        let grpCnt2 =[];

        let grpStart1 =[];
        let grpStart2 =[];

        const geo = xmesh.mesh.geometry;

        for (let g = 0; g< geo.groups.length; g++) {

            grpStart1[g] = nVtx1 / 3;
            grpStart2[g] = newXmesh.nVtx / 3;

            for (let vi = geo.groups[g].start ; vi< (geo.groups[g].start + geo.groups[g].count); vi+=3) {

                const i1 = geo.index ? geo.index.array[vi + 0] * 3 : (vi + 0) * 3;
                const j1 = geo.index ? geo.index.array[vi + 0] * 2 : (vi + 0) * 2;
                const i2 = geo.index ? geo.index.array[vi + 1] * 3 : (vi + 1) * 3;
                const j2 = geo.index ? geo.index.array[vi + 1] * 2 : (vi + 1) * 2;
                const i3 = geo.index ? geo.index.array[vi + 2] * 3 : (vi + 2) * 3;
                const j3 = geo.index ? geo.index.array[vi + 2] * 2 : (vi + 2) * 2;

                v[0].set(geo.attributes.position.array[i1 + 0], geo.attributes.position.array[i1 + 1], geo.attributes.position.array[i1 + 2]);
                v[1].set(geo.attributes.position.array[i2 + 0], geo.attributes.position.array[i2 + 1], geo.attributes.position.array[i2 + 2]);
                v[2].set(geo.attributes.position.array[i3 + 0], geo.attributes.position.array[i3 + 1], geo.attributes.position.array[i3 + 2]);

                n[0].set(geo.attributes.normal.array[i1 + 0], geo.attributes.normal.array[i1 + 1], geo.attributes.normal.array[i1 + 2]);
                n[1].set(geo.attributes.normal.array[i2 + 0], geo.attributes.normal.array[i2 + 1], geo.attributes.normal.array[i2 + 2]);
                n[2].set(geo.attributes.normal.array[i3 + 0], geo.attributes.normal.array[i3 + 1], geo.attributes.normal.array[i3 + 2]);

                if(geo.attributes.uv){
                    uv[0].set(geo.attributes.uv.array[j1 + 0], geo.attributes.uv.array[j1 + 1]);
                    uv[1].set(geo.attributes.uv.array[j2 + 0], geo.attributes.uv.array[j2 + 1]);
                    uv[2].set(geo.attributes.uv.array[j3 + 0], geo.attributes.uv.array[j3 + 1]);
                }

                const dA = this.dist(a, b, c, d, v[0].x, v[0].y, v[0].z);
                const dB = this.dist(a, b, c, d, v[1].x, v[1].y, v[1].z);
                const dC = this.dist(a, b, c, d, v[2].x, v[2].y, v[2].z);
                sarr[0] = Math.sign(dA);
                sarr[1] = Math.sign(dB);
                sarr[2] = Math.sign(dC);

                if (sarr[0] * sarr[1] == -1){
                    const frac = this.fraction(dA, dB);
                    v[3].lerpVectors(v[0],v[1], frac);
                    n[3].lerpVectors(n[0],n[1], frac);

                    if(geo.attributes.uv)
                        uv[3].lerpVectors(uv[0],uv[1], frac);
                }
                if (sarr[1] * sarr[2] == -1){
                    const frac = this.fraction(dB, dC);
                    v[4].lerpVectors(v[1], v[2], frac);
                    n[4].lerpVectors(n[1], n[2], frac);
                    if(geo.attributes.uv)
                        uv[4].lerpVectors(uv[1], uv[2], frac);
                }
                    
                if (sarr[2] * sarr[0] == -1){
                    const frac = this.fraction(dC, dA);
                    v[5].lerpVectors(v[2], v[0], frac);
                    n[5].lerpVectors(n[2], n[0], frac);
                    if(geo.attributes.uv)
                        uv[5].lerpVectors(uv[2], uv[0], frac);
                }

                uarr[0] = sarr[0] +1;
                uarr[1] = sarr[1] +1;
                uarr[2] = sarr[2] +1;

                const code = this.encodeSplitCase(uarr[0], uarr[1], uarr[2]);
                const triCase = SplitArray[code];
                const behinds = triCase[0];
                const fronts = triCase[1];

                if(!xmesh.mesh.material[g].name.startsWith('splitmaterial')){
                            
                    for(let behind = 0;behind<behinds.length;behind++){

                        const b0 = behinds[behind][0];
                        const b1 = behinds[behind][1];
                        const b2 = behinds[behind][2];

                        const v0 = v[b0];
                        const v1 = v[b1];
                        const v2 = v[b2];

                        const dA = Math.abs(this.dist(a, b, c, d, v0.x, v0.y, v0.z));
                        const dB = Math.abs(this.dist(a, b, c, d, v1.x, v1.y, v1.z));
                        const dC = Math.abs(this.dist(a, b, c, d, v2.x, v2.y, v2.z));

                        if(dA< PLANE_EPSILON){
                            onPlane1[nOnPlane1++] = v0.x;
                            onPlane1[nOnPlane1++] = v0.y;
                            onPlane1[nOnPlane1++] = v0.z;
                            
                            minPlane1.min(v0);
                            maxPlane1.max(v0);
                        }
            
                        if(dB< PLANE_EPSILON){
                            onPlane1[nOnPlane1++] = v1.x;
                            onPlane1[nOnPlane1++] = v1.y;
                            onPlane1[nOnPlane1++] = v1.z;

                            minPlane1.min(v1);
                            maxPlane1.max(v1);

                        }

                        if(dC< PLANE_EPSILON){
                            onPlane1[nOnPlane1++] = v2.x;
                            onPlane1[nOnPlane1++] = v2.y;
                            onPlane1[nOnPlane1++] = v2.z;

                            minPlane1.min(v2);
                            maxPlane1.max(v2);
                        }

                        if((nVtx1 +nOnPlane1 + 9)>=xmesh.nVtxAlloc * 3){
                            xmesh.nVtxAlloc *= 2;
                            let newArray = new Float32Array(xmesh.nVtxAlloc * 3);
                            newArray.set(xmesh.vertices);
                            xmesh.vertices = newArray;

                            newArray = new Float32Array(xmesh.nVtxAlloc * 3);
                            newArray.set(xmesh.normals);
                            xmesh.normals = newArray;

                            if(geo.attributes.uv){
                                newArray = new Float32Array(xmesh.nVtxAlloc * 2);
                                newArray.set(xmesh.uvs);
                                xmesh.uvs = newArray;
                            }
                        }

                         const isBad = isNaN(v0.x) || isNaN(v0.y) ||  isNaN(v1.x) || isNaN(v1.y) ||  isNaN(v2.x) || isNaN(v2.y) ;

                        if(!isBad){
                            nVtx1 = this.splitt(xmesh.vertices, nVtx1, v0, v1, v2);
                            nNorms1 = this.splittn(xmesh.normals, nNorms1, n[b0], n[b1], n[b2]);
                            
                            if(geo.attributes.uv){
                                nUvs1 = this.splittuv(xmesh.uvs, nUvs1, uv[b0], uv[b1], uv[b2]);
                            }
                        }
                    }   
                }

                for(let front = 0;front<fronts.length;front++){

                    const f0 = fronts[front][0];
                    const f1 = fronts[front][1];
                    const f2 = fronts[front][2];

                    const v0 = v[f0];
                    const v1 = v[f1];
                    const v2 = v[f2];

                    const dA = Math.abs(this.dist(a, b, c, d, v0.x, v0.y, v0.z));
                    const dB = Math.abs(this.dist(a, b, c, d, v1.x, v1.y, v1.z));
                    const dC = Math.abs(this.dist(a, b, c, d, v2.x, v2.y, v2.z));

                    if(dA< PLANE_EPSILON){
                        onPlane2[nOnPlane2++] = v0.x;
                        onPlane2[nOnPlane2++] = v0.y;
                        onPlane2[nOnPlane2++] = v0.z;

                        minPlane2.min(v0);
                        maxPlane2.max(v0);
                    }
        
                    if(dB< PLANE_EPSILON){
                        onPlane2[nOnPlane2++] = v1.x;
                        onPlane2[nOnPlane2++] = v1.y;
                        onPlane2[nOnPlane2++] = v1.z;

                        minPlane2.min(v1);
                        maxPlane2.max(v1);
                    }

                    if(dC< PLANE_EPSILON){
                        onPlane2[nOnPlane2++] = v2.x;
                        onPlane2[nOnPlane2++] = v2.y;
                        onPlane2[nOnPlane2++] = v2.z;

                        minPlane2.min(v2);
                        maxPlane2.max(v2);
                    }
                    if((newXmesh.nVtx + nOnPlane2 + 9)>=newXmesh.nVtxAlloc * 3){

                        newXmesh.nVtxAlloc *= 2;
                        
                        let newArray = new Float32Array(newXmesh.nVtxAlloc * 3);
                        newArray.set(newXmesh.vertices);
                        newXmesh.vertices = newArray;

                        newArray = new Float32Array(newXmesh.nVtxAlloc * 3);
                        newArray.set(newXmesh.normals);
                        newXmesh.normals = newArray;

                        if(geo.attributes.uv){
                            newArray = new Float32Array(newXmesh.nVtxAlloc * 2);
                            newArray.set(newXmesh.uvs);
                            newXmesh.uvs = newArray;
                        }
                    }

                    const isBad = isNaN(v0.x) || isNaN(v0.y) ||  isNaN(v1.x) || isNaN(v1.y) ||  isNaN(v2.x) || isNaN(v2.y) ;

                    if(!isBad){
                        newXmesh.nVtx = this.splitt(newXmesh.vertices, newXmesh.nVtx,  v0,  v1, v2);
                        newXmesh.nNorms = this.splittn(newXmesh.normals, newXmesh.nNorms, n[f0], n[f1], n[f2]);

                        if(xmesh.mesh.geometry.attributes.uv){
                            newXmesh.nUvs = this.splittuv(newXmesh.uvs, newXmesh.nUvs,   uv[f0],  uv[f1],  uv[f2]);
                        }
                    }
                }
            }

            grpCnt1[g] = (nVtx1 /3 ) - grpStart1[g];
            grpCnt2[g] = (newXmesh.nVtx / 3) - grpStart2[g];
        }

        if(newXmesh.nVtx<=0)
            return null;

        const centerPlane1 = new THREE.Vector3().subVectors(maxPlane1, minPlane1).multiplyScalar(0.5).add(minPlane1);
        const centerPlane2 = new THREE.Vector3().subVectors(maxPlane2, minPlane2).multiplyScalar(0.5).add(minPlane2);

        const indexes1 = new Uint32Array(nOnPlane1/3);
        for(let n =0;n<indexes1.length;n++){
            indexes1[n] = n * 3;
        }
        const indexes2 = new Uint32Array(nOnPlane2/3);
        for(let n =0;n<indexes2.length;n++){
            indexes2[n] = n * 3;
        }
        
        indexes1.sort(function(a, b){

            const a1 = Math.atan2(onPlane1[a +0] - centerPlane1.x, onPlane1[a +2] - centerPlane1.z);
            const a2 = Math.atan2(onPlane1[b +0] - centerPlane1.x, onPlane1[b +2] - centerPlane1.z);

            if(a1 < a2)
                return -1;

            if(a1 > a2)
                return 1;

            return 0;

        });

        indexes2.sort(function(a, b){

            const a1 = Math.atan2(onPlane2[a +0] - centerPlane2.x, onPlane2[a +2] - centerPlane2.z);
            const a2 = Math.atan2(onPlane2[b +0] - centerPlane2.x, onPlane2[b +2] - centerPlane2.z);

            if(a1 < a2)
                return -1;

            if(a1 > a2)
                return 1;

            return 0;

        });

        
        if(nOnPlane1>0){
            for(let n=0;n<(nOnPlane1/3)-1;n++){
            
                const i1 = indexes1[n + 0];
                const i2 = indexes1[n + 1];
    
                xmesh.vertices[nVtx1++] = onPlane1[i1 + 0];
                xmesh.vertices[nVtx1++] = onPlane1[i1 + 1];
                xmesh.vertices[nVtx1++] = onPlane1[i1 + 2];
    
                xmesh.vertices[nVtx1++] = onPlane1[i2 + 0];
                xmesh.vertices[nVtx1++] = onPlane1[i2 + 1];
                xmesh.vertices[nVtx1++] = onPlane1[i2 + 2];
                
                xmesh.vertices[nVtx1++] = centerPlane1.x;
                xmesh.vertices[nVtx1++] = centerPlane1.y;
                xmesh.vertices[nVtx1++] = centerPlane1.z;
    
                xmesh.normals[nNorms1++] = a;
                xmesh.normals[nNorms1++] = b;
                xmesh.normals[nNorms1++] = c;
    
                xmesh.normals[nNorms1++] = a;
                xmesh.normals[nNorms1++] = b;
                xmesh.normals[nNorms1++] = c;
                
                xmesh.normals[nNorms1++] = a;
                xmesh.normals[nNorms1++] = b;
                xmesh.normals[nNorms1++] = c;
            }
    
            
            let nn = nOnPlane1/3-1;
    
            xmesh.vertices[nVtx1++] = onPlane1[indexes1[nn] + 0];
            xmesh.vertices[nVtx1++] = onPlane1[indexes1[nn] + 1];
            xmesh.vertices[nVtx1++] = onPlane1[indexes1[nn] + 2];
    
            xmesh.vertices[nVtx1++] = onPlane1[indexes1[0] + 0];
            xmesh.vertices[nVtx1++] = onPlane1[indexes1[0] + 1];
            xmesh.vertices[nVtx1++] = onPlane1[indexes1[0] + 2];
            
            xmesh.vertices[nVtx1++] = centerPlane1.x;
            xmesh.vertices[nVtx1++] = centerPlane1.y;
            xmesh.vertices[nVtx1++] = centerPlane1.z;
    
            xmesh.normals[nNorms1++] = a;
            xmesh.normals[nNorms1++] = b;
            xmesh.normals[nNorms1++] = c;
    
            xmesh.normals[nNorms1++] = a;
            xmesh.normals[nNorms1++] = b;
            xmesh.normals[nNorms1++] = c;
            
            xmesh.normals[nNorms1++] = a;
            xmesh.normals[nNorms1++] = b;
            xmesh.normals[nNorms1++] = c;
        }
        
        /*
        for(let n=0;n<nVtx2;n++){
            fvertices2[n] = vertices2[n];
            fnormals2[n] = normals2[n];
        }
        for(let n=0;n<nUvs2;n++){
            fuvs2[n] = uvs2[n];
        }
        */

        
        if(nOnPlane2>0){

            for(let n=0;n<(nOnPlane2/3) - 1;n++){
            
                const i1 = indexes2[n + 0];
                const i2 = indexes2[n + 1];
    
                newXmesh.vertices[newXmesh.nVtx++] = onPlane2[i1 + 0];
                newXmesh.vertices[newXmesh.nVtx++] = onPlane2[i1 + 1];
                newXmesh.vertices[newXmesh.nVtx++] = onPlane2[i1 + 2];
    
                newXmesh.vertices[newXmesh.nVtx++] = onPlane2[i2 + 0];
                newXmesh.vertices[newXmesh.nVtx++] = onPlane2[i2 + 1];
                newXmesh.vertices[newXmesh.nVtx++] = onPlane2[i2 + 2];
                
                newXmesh.vertices[newXmesh.nVtx++] = centerPlane2.x;
                newXmesh.vertices[newXmesh.nVtx++] = centerPlane2.y;
                newXmesh.vertices[newXmesh.nVtx++] = centerPlane2.z;
    
                newXmesh.normals[newXmesh.nNorms++] = -a;
                newXmesh.normals[newXmesh.nNorms++] = -b;
                newXmesh.normals[newXmesh.nNorms++] = -c;
    
                newXmesh.normals[newXmesh.nNorms++] = -a;
                newXmesh.normals[newXmesh.nNorms++] = -b;
                newXmesh.normals[newXmesh.nNorms++] = -c;
                
                newXmesh.normals[newXmesh.nNorms++] = -a;
                newXmesh.normals[newXmesh.nNorms++] = -b;
                newXmesh.normals[newXmesh.nNorms++] = -c;
            }

            const nn = (nOnPlane2/3)-1;
        
            newXmesh.vertices[newXmesh.nVtx++] = onPlane2[indexes2[nn] + 0];
            newXmesh.vertices[newXmesh.nVtx++] = onPlane2[indexes2[nn] + 1];
            newXmesh.vertices[newXmesh.nVtx++] = onPlane2[indexes2[nn] + 2];
    
            newXmesh.vertices[newXmesh.nVtx++] = onPlane2[indexes2[0] + 0];
            newXmesh.vertices[newXmesh.nVtx++] = onPlane2[indexes2[0] + 1];
            newXmesh.vertices[newXmesh.nVtx++] = onPlane2[indexes2[0] + 2];
            
            newXmesh.vertices[newXmesh.nVtx++] = centerPlane2.x;
            newXmesh.vertices[newXmesh.nVtx++] = centerPlane2.y;
            newXmesh.vertices[newXmesh.nVtx++] = centerPlane2.z;
    
            newXmesh.normals[newXmesh.nNorms++] = -a;
            newXmesh.normals[newXmesh.nNorms++] = -b;
            newXmesh.normals[newXmesh.nNorms++] = -c;
    
            newXmesh.normals[newXmesh.nNorms++] = -a;
            newXmesh.normals[newXmesh.nNorms++] = -b;
            newXmesh.normals[newXmesh.nNorms++] = -c;
            
            newXmesh.normals[newXmesh.nNorms++] = -a;
            newXmesh.normals[newXmesh.nNorms++] = -b;
            newXmesh.normals[newXmesh.nNorms++] = -c;
        }
     
        const center = new THREE.Vector3();
        const size = new THREE.Vector3();

        newXmesh.mesh = xmesh.mesh.clone();

        if(!newXmesh.mesh.name.endsWith('-splitted'))
            newXmesh.mesh.name+=-'-splitted';

        newXmesh.mesh.geometry = new THREE.BufferGeometry();
        newXmesh.mesh.geometry.setAttribute('position', new THREE.Float32BufferAttribute(newXmesh.vertices.subarray(0, (newXmesh.nVtx / 3) * 3), 3));
        newXmesh.mesh.geometry.setAttribute('normal', new THREE.Float32BufferAttribute( newXmesh.normals.subarray(0, (newXmesh.nVtx / 3) * 3), 3));

        if(geo.attributes.uv)
            newXmesh.mesh.geometry.setAttribute('uv', new THREE.Float32BufferAttribute( newXmesh.uvs.subarray(0, (newXmesh.nVtx / 3) * 2), 2));

        for(let g =0;g<grpCnt2.length;g++){
            newXmesh.mesh.geometry.groups[g]= {start:grpStart2[g], count :grpCnt2[g], materialIndex :g};
        }
        newXmesh.mesh.geometry.groups[newXmesh.mesh.geometry.groups.length -1].count += nOnPlane2;

        newXmesh.mesh.geometry.computeBoundingSphere();
        newXmesh.mesh.geometry.translate(-newXmesh.mesh.geometry.boundingSphere.center.x , -newXmesh.mesh.geometry.boundingSphere.center.y, -newXmesh.mesh.geometry.boundingSphere.center.z);
        //newXmesh.mesh.geometry.boundingSphere.getCenter(center);
        //newXmesh.mesh.geometry = new THREE.SphereGeometry(newXmesh.mesh.geometry.boundingSphere.radius);
        //newXmesh.mesh.material = new THREE.MeshBasicMaterial({color: 0xFFFFFF});

        
        newXmesh.mesh.geometry.computeBoundingBox();
        /*
        newXmesh.mesh.geometry.boundingBox.getCenter(center);
        newXmesh.mesh.geometry.boundingBox.getSize(size);
        newXmesh.mesh.geometry.translate(-center.x , -center.y, -center.z);
        newXmesh.mesh.position.add(center);
        */
        
        newXmesh.mesh.geometry.attributes.position.needsUpdate = true;
        newXmesh.mesh.geometry.attributes.normal.needsUpdate = true;

        if(xmesh.mesh.geometry.attributes.uv)
            newXmesh.mesh.geometry.attributes.uv.needsUpdate = true;

        xmesh.nVtx = nVtx1;
        xmesh.nNorms = nNorms1;
        xmesh.nUvs = nUvs1;
        xmesh.mass = 100;
        /*
        mesh.geometry.dispose();
        mesh.geometry = new THREE.BufferGeometry();
        */
        xmesh.mesh.geometry.dispose();
        xmesh.mesh.geometry.setAttribute('position', new THREE.Float32BufferAttribute(xmesh.vertices.subarray(0, (xmesh.nVtx / 3) * 3), 3));
        xmesh.mesh.geometry.setAttribute('normal', new THREE.Float32BufferAttribute(xmesh.normals.subarray(0, (xmesh.nVtx / 3) * 3), 3));
        xmesh.mesh.geometry.index = null;

        if(xmesh.mesh.geometry.uv)
            xmesh.mesh.geometry.setAttribute('uv', new THREE.Float32BufferAttribute(xmesh.uvs.subarray(0, (xmesh.nVtx / 3) * 2), 2));

        for(let g =0;g<grpCnt1.length;g++){
            xmesh.mesh.geometry.groups[g] = {start: grpStart1[g], count : grpCnt1[g], materialIndex :g};
        }

        xmesh.mesh.geometry.groups[xmesh.mesh.geometry.groups.length -1].count += nOnPlane1;
    
        /*
        newXmesh.mesh.geometry.computeBoundingBox();
        newXmesh.mesh.geometry.boundingBox.getCenter(center);
        newXmesh.mesh.geometry.translate(-center.x, -center.y, -center.z);
        newXmesh.mesh.position.add(center);

        xmesh.mesh.geometry.computeBoundingBox();
        xmesh.mesh.geometry.boundingBox.getCenter(center);
        xmesh.mesh.geometry.translate(-center.x, -center.y, -center.z);
        xmesh.mesh.position.add(center);
        */
   

        newXmesh.mesh.geometry.computeBoundingBox();
        xmesh.mesh.geometry.computeBoundingBox();

        
        /*
        xmesh.mesh.geometry.boundingBox.getCenter(center);
        xmesh.mesh.geometry.boundingBox.getSize(size);
        xmesh.mesh.geometry.translate(-center.x , -center.y, -center.z);
        xmesh.mesh.position.add(center);
        xmesh.size = size.clone();
        */
        
        xmesh.mesh.geometry.attributes.position.needsUpdate = true;
        xmesh.mesh.geometry.attributes.normal.needsUpdate = true;

        if(xmesh.mesh.geometry.attributes.uv)
            xmesh.mesh.geometry.attributes.uv.needsUpdate = true;

        //console.log('new split '+' a:'+a.toFixed(1)+' b:'+b.toFixed(1)+' c:'+c.toFixed(1)+' d:'+d.toFixed(1)+ ' '+ xmesh.nVtx / 9 +'+'+newXmesh.nVtx / 9 + ' triangles');
        
        newXmesh.idx = this.xmeshes.length;
        newXmesh.id = this.lastId++;

        return newXmesh;
    }

    
    splitMesh(a, b, c, d, xmesh) {

        const newXmesh = this.doSplit(a, b, c, d, xmesh);
        this.xmeshes.push(newXmesh);
        return newXmesh;
    }
    

    addWoods(ptsIdx, num, width, radius, mass, offset, spacing) {
        const woodObj = { id: this.lastId++, offset: { x: offset.x , y: offset.y* this.trackHeight, z: offset.z }, ptIdx: ptsIdx, "num": num, "mass": mass, "width": width, "radius": radius, objects: [], woods : [], spacing:spacing }

        for (let n = 0; n < woodObj.num; n++) {

            woodObj.woods[n] = {};
            woodObj.objects.push({
                id: this.lastId++,
                pos: { x: 0, y: 0, z: 0 },
                angles: { x: 0, y: 0, z: 0 },
                quat: { x: 0, y: 0, z: 0, w: 1.0 }
            });

        }

        this.computeWoods(woodObj);
        this.woods.push(woodObj);

        return woodObj;

        //const newWoods = [];
        //newWoods.push({ 'object': woodMesh, "rot": wood.rot });
        //return newWoods;
    }
    

    computeJumper(jumper) {
        const tpts = this.trackPoints[jumper.ptIdx];

        /*
        const qa = new THREE.Quaternion().setFromEuler(new THREE.Euler(jumper.angle.x, jumper.angle.y, jumper.angle.z, "XYZ"));
        const myq = tpts.rot.clone().multiply(qa);
        */

        const nangles = new THREE.Euler(jumper.angle.x, jumper.angle.y, jumper.angle.z, "XYZ");
        const q2 = new THREE.Quaternion().setFromEuler(nangles);
        

        jumper.pos.x = tpts.pos.x + jumper.offset.x;
        jumper.pos.y = tpts.pos.y + jumper.offset.y;
        jumper.pos.z = tpts.pos.z + jumper.offset.z;

        jumper.rot= q2.clone();
        jumper.rot2 = q2;
        jumper.angles.x = nangles.x;
        jumper.angles.y = nangles.y;
        jumper.angles.z = nangles.z;
    }


    addNavMesh(pos, type, links = []){
        const node = {
            id: this.lastId++,
            pos: new THREE.Vector3(pos.x, pos.y, pos.z ),
            type : type,
            links : []
        };

        for(let l of links){
            node.links.push(l);
        }

        this.navmeshs.push(node);

        return node;
    }

    addJumper(ptsIdx, offset, angle, size) {

        const jumper = {
            id: this.lastId++,
            offset: { x: offset.x, y: offset.y, z: offset.z },
            size: { x: size.x, y: size.y, z: size.z },
            pos: { x: 0.0, y: 0.0, z: 0.0 },
            angles: { x: 0.0, y: 0.0, z: 0.0 },
            angle : angle,
            ptIdx: ptsIdx,
            object: null
        };

        this.computeJumper(jumper);

        this.jumpers.push(jumper);

        return jumper;
    }

    computeInterestPoint(ip) {
        const tpts = this.trackPoints[ip.ptIdx];

        const qa = new THREE.Quaternion().setFromEuler(new THREE.Euler(ip.angle.x, ip.angle.y, ip.angle.z, "XYZ"));
        const myq = tpts.rot.clone().multiply(qa);

        const eul = new THREE.Euler(0, 0, 0, "XYZ").setFromQuaternion(tpts.rot);
        const nangles = new THREE.Euler(eul.x + ip.angle.x, eul.y + ip.angle.y, eul.z + ip.angle.z, "XYZ");
        const q2 = new THREE.Quaternion().setFromEuler(nangles);

        ip.pos = { x: tpts.pos.x + ip.offset.x, y: tpts.pos.y + ip.offset.y, z: tpts.pos.z + ip.offset.z },
        ip.rot = myq;
        ip.rot2 = q2;
        ip.angles = { x: nangles.x, y: nangles.y, z: nangles.z };

        
        const mat = new THREE.Matrix4().compose(	new THREE.Vector3(ip.pos.x, ip.pos.y, ip.pos.z),
                                                    ip.rot2,
                                                    new THREE.Vector3(ip.size.x, ip.size.y, ip.size.z)
                                                );

        const lp = new THREE.Vector3(ip.loffset.x, ip.loffset.y, ip.loffset.z).applyMatrix4(mat);
        ip.lpos= {x:lp.x, y:lp.y, z:lp.z};
    }

    addInterestPoint(ptsIdx, offset, angle, size, lobject, loffset, lsize, lweight, nBonus, targetNode) {

        const ip = {
            id: this.lastId++,
            offset: { x: offset.x, y: offset.y, z: offset.z },
            loffset: { x: loffset.x, y: loffset.y, z: loffset.z },
            size: { x: size.x, y: size.y, z: size.z },
            angle : angle,
            nBonuses: nBonus,
            ptIdx: ptsIdx,
            lobject : lobject,
            lsize:lsize,
            lweight:lweight,
            targetNode:targetNode,
            object: null
        };

        this.computeInterestPoint(ip);

        this.interestPoints.push(ip);

        return ip;
    }

    computeGrid(grid){

        const tpts = this.trackPoints.length > grid.ptIdx ? this.trackPoints[grid.ptIdx] : {pos : new THREE.Vector3()};
        grid.pos = new THREE.Vector3(tpts.pos.x + grid.offset.x, tpts.pos.y + grid.offset.y,  tpts.pos.z + grid.offset.z);
        grid.rot =  new THREE.Quaternion().setFromEuler(new THREE.Euler(grid.angle.x, grid.angle.y, grid.angle.z, "XYZ"));


        const rad = grid.ballRadius;
        const nballs = grid.nBalls;
        const sp = (grid.width - rad * 2) / nballs;

        grid.balls = [];
        
        for(let bx = 0; bx < nballs; bx++) {
            for(let bz = 0; bz < nballs; bz++){
                grid.balls.push({center : {x:(bx * sp + rad ) * grid.cell_size.x, y:rad, z:(bz * sp + rad ) * grid.cell_size.z}, radius : rad * grid.cell_size.x, weight : grid.ballWeight});
            }
        }



        const sw = grid.width * grid.cell_size.x;
        const sh = grid.height * grid.cell_size.y;
        const sd = grid.depth * grid.cell_size.z;
  
        const bSz = 0.1;

        const sizes = [ [bSz , sh , sd],
                        [bSz , sh , sd], 
                        [sw  , bSz, sd],
                        [sw  , bSz, sd], 
                        [sw  , sh , bSz],
                        [sw  , sh , bSz]];

        const w2 = sw/2;
        const h2 = sh/2;
        const d2 = sd/2;

        const poses = [ [grid.pos.x-bSz      , grid.pos.y+h2        , grid.pos.z + d2],
                        [grid.pos.x+sw +bSz  , grid.pos.y+h2        , grid.pos.z + d2], 
                        [grid.pos.x+w2       , grid.pos.y-bSz       , grid.pos.z + d2],
                        [grid.pos.x+w2       , grid.pos.y+sh+bSz    , grid.pos.z + d2], 
                        [grid.pos.x+w2       , grid.pos.y+h2        , grid.pos.z -bSz],
                        [grid.pos.x+w2       , grid.pos.y+h2        , grid.pos.z + sd + bSz], 
                                    ]

        grid.borderInfos = [];

        for(let n=0;n<6;n++){
            grid.borderInfos.push({ size : {x: sizes[n][0], y : sizes[n][1], z: sizes[n][2]}, 
                                    pos:  new THREE.Vector3(poses[n][0], poses[n][1],  poses[n][2])});
        }
    }

    computeDrone(drone)
    {
        const tpts = this.trackPoints[drone.ptIdx];

        const qa = new THREE.Quaternion().setFromEuler(new THREE.Euler(drone.angle.x, drone.angle.y, drone.angle.z, "XYZ"));
        const myq = tpts.rot.clone().multiply(qa);

        const eul = new THREE.Euler(0, 0, 0, "XYZ").setFromQuaternion(tpts.rot);
        const nangles = new THREE.Euler(eul.x + drone.angle.x, eul.y + drone.angle.y, eul.z + drone.angle.z, "XYZ");
        const q2 = new THREE.Quaternion().setFromEuler(nangles);

        drone.pos = new THREE.Vector3(tpts.pos.x + drone.offset.x, tpts.pos.y + drone.offset.y, tpts.pos.z + drone.offset.z);
        drone.rot = myq;
        drone.rot2 = q2;
        drone.angles = { x: nangles.x, y: nangles.y, z: nangles.z };
    }

    addGrid(ptsIdx, offset, angle, cell_size, width, height, depth, isolevel, nBalls, radius, weight, hasBorder = false, hasBall = false)  {

        const grid = {
            id: this.lastId++,
            offset: { x: offset.x, y: offset.y, z: offset.z },
            cell_size: { x: cell_size.x, y: cell_size.y, z: cell_size.z },
            angle : { x: angle.x, y: angle.y, z: angle.z },
            hasBorder : hasBorder, 
            hasBall : hasBall, 
            lastvIdx : 0,
            width : width,
            height: height,
            depth: depth, 
            isolevel: isolevel, 
            nBalls: nBalls, 
            ballRadius: radius, 
            ptIdx: ptsIdx,
            ballWeight: weight
        };

        this.computeGrid(grid);

        this.grids.push(grid);

        return grid;
    }

    addDrone(ptsIdx, offset,caroffset, angle, size, model, activation, deactivation, speed,  weight, weapons, speedPale1, speedPale2, upLift , pales, object )  {


        const drone = {
            id: this.lastId++,
            offset: { x: offset.x, y: offset.y, z: offset.z },
            caroffset : { x: caroffset.x, y: caroffset.y, z: caroffset.z },
            size:  new THREE.Vector3(size.x, size.y, size.z),
            angle : { x: angle.x, y: angle.y, z: angle.z },
            model:model,
            speedPale1 :speedPale1,
            speedPale2 :speedPale2, 
            upLift:upLift,
            speed: speed,
            activation: activation, 
            deactivation: deactivation,
            ptIdx: ptsIdx,
            weight: weight ,
            weapons: weapons,
            shots: [],
            samples:[],
            wings: [],
            pales: [],
            object : object,
            oPales: pales
        };


        this.computeDrone(drone);

        this.drones.push(drone);

        return drone;
    }

    computeTurret(turret)
    {
        const tpts = this.trackPoints[turret.ptIdx];
        const eul = new THREE.Euler(turret.angles.x, turret.angles.y, turret.angles.z, "XYZ");

        turret.pos = { x: tpts.pos.x + turret.offset.x, y: tpts.pos.y + turret.offset.y, z: tpts.pos.z + turret.offset.z };
        turret.angles =  { x: eul.x, y: eul.y, z: eul.z };
        turret.rot =  new THREE.Quaternion().setFromEuler(eul);
    }


    computeSpider(spider)
    {
        const tpts = this.trackPoints[spider.ptIdx];
        const eul = new THREE.Euler(spider.angles.x, spider.angles.y, spider.angles.z, "XYZ");

        spider.torqueValue = 0;
        spider.pos = { x: tpts.pos.x + spider.offset.x, y: tpts.pos.y + spider.offset.y, z: tpts.pos.z + spider.offset.z };
        spider.angles =  { x: eul.x, y: eul.y, z: eul.z };
        spider.rot =  new THREE.Quaternion().setFromEuler(eul);


        spider.lastDist=0;
        spider.stuckTime = 0;
        spider.stuckMode = false;
        spider.backMode = false;
        spider.backTime = 0;
        spider.dir = 1;
    }


    

    addTurret(ptsIdx, model, shotmodel, activation, offset, angle, size, projPts, projSize, projMass, projSpeed, projAngle, projAngle2, projDelay, projTTL, projSND, projLL, moveAngle, projRoll, projPart, life = 10) {
        const tpts = this.trackPoints[ptsIdx];
        const eul = new THREE.Euler(angle.x, angle.y, angle.z, "XYZ");
        const newTurret = {
            id: this.lastId++,
            model: model,
            shotModel: shotmodel,
            projRoll : projRoll,
            projPart :projPart,
            activation: activation,
            offset: { x: offset.x, y: offset.y, z: offset.z },
            pos: { x: tpts.pos.x + offset.x, y: tpts.pos.y + offset.y, z: tpts.pos.z + offset.z },
            angles: { x: eul.x, y: eul.y, z: eul.z },
            rot: new THREE.Quaternion().setFromEuler(eul),
            size: { x: size.x, y: size.y, z: size.z },
            projPts: { x: projPts.x, y: projPts.y, z: projPts.z },
            projSize: projSize,
            projSND: projSND,
            projMass: projMass,
            projSpeed: projSpeed,
            projLL :projLL, 
            moveAngle: moveAngle,
            headAngle: projAngle,
            oHeadAngle: projAngle,
            projAngle: projAngle,
            projAngle2: projAngle2,
            canonAngle : projAngle2,
            projDelay: projDelay,
            projTTL: projTTL,
            samples : [],
            life : life,
            total_life : life,
            ptIdx: ptsIdx, shots: [], object: null
        };

        this.turrets.push(newTurret);
        return newTurret;
    }

    
    addSpider(ptsIdx, offset, angle, size, model, shotmodel, projSize, projMass, projSpeed, projDelay, activation){


        const tpts = this.trackPoints[ptsIdx];
        const eul = new THREE.Euler(angle.x, angle.y, angle.z, "XYZ");
        const newSpider = {
            id: this.lastId++,
            model: model,
            shotModel: shotmodel,
            projSize: projSize, 
            projMass : projMass, 
            projSpeed : projSpeed, 
            torqueValue : 0,
            projDelay : projDelay,
            activation: activation,
            offset: { x: offset.x, y: offset.y, z: offset.z },
            pos: { x: tpts.pos.x + offset.x, y: tpts.pos.y + offset.y, z: tpts.pos.z + offset.z },
            angles: { x: eul.x, y: eul.y, z: eul.z },
            rot: new THREE.Quaternion().setFromEuler(eul),
            size: { x: size.x, y: size.y, z: size.z },
            ptIdx: ptsIdx, 
            shots: [],
            samples : [],
            sounds : [{file : "spider-bodyhit"}, {file : "spider-leghit"}, {file : "spider-legbreak"}, {file : "spider-die"}, {file : "spider-shot"}, {file : "spider-walk"}],
            object: null
        };

      
        this.spiders.push(newSpider);
        return newSpider;
        
    }


    computeCharacter(char){

        const tpts = this.trackPoints[char.ptIdx].pos;
        const eul = new THREE.Euler(char.angle.x, char.angle.y, char.angle.z, "XYZ");

        char.pos = { x: tpts.x + char.offset.x, y: tpts.y + char.offset.y, z: tpts.z + char.offset.z };
        char.angles =  { x: eul.x, y: eul.y, z: eul.z };
        char.rot =  new THREE.Quaternion().setFromEuler(eul);

    }

    computeNPC(char){

        if(char.nInstances>1){
            let ptIdx = -1;
            do  {
                ptIdx  = Math.floor(Math.random() * (this.navmeshs.length -1));
                char.pos = new THREE.Vector3((Math.random() - 0.5) * 50,  2, (Math.random() - 0.5) * 50).add(this.navmeshs[ptIdx].pos);
                char.pathStartPts = ptIdx;
            }while((this.navmeshs[ptIdx].type & char.nodeType)==0)
        }else{
            const tpts = this.trackPoints.length > char.ptIdx ? this.trackPoints[char.ptIdx].pos : new THREE.Vector3();
            char.pos = new THREE.Vector3(tpts.x + char.offset.x, tpts.y + char.offset.y, tpts.z + char.offset.z );
        }

        
        const eul = new THREE.Euler(char.angles.x, char.angles.y, char.angles.z, "XYZ");
        char.rot = new THREE.Quaternion().setFromEuler(eul);
        char.quat = char.rot.clone();
        char.angle = char.angles.y;
    }


    /*
    async addNPCInstances(charDef, pathName, num){ //            const path = track.pathes['mainroad'];

        const path = this.pathes[pathName];
  
        const chars = new Array(num);
        for(let i=0;i<num;i++){

            const ptIdx  = parseInt(Math.random() * (path.length-2));
            const ptIdx2 = (ptIdx + 1);

            const delta = new THREE.Vector3().subVectors(path[ptIdx2].pos, path[ptIdx].pos);
            const dist = Math.random() * delta.length();
            delta.normalize().multiplyScalar(dist);

            const pts = new THREE.Vector3().addVectors(path[ptIdx].pos, delta).sub(this.trackPoints[0].pos);
            
            const char = await this.addNPC(charDef.ptIdx, pts, charDef.angle, charDef.name, charDef.subsystemsDef, charDef.skelScale);
            char.pathStartPts = ptIdx;

            chars[i]=char;
        }

        return chars;
    }
    async addNPCInstancesNavMesh(charDef, num){


        const chars = new Array(num);
        for(let i=0;i<num;i++){

            const ptIdx  = Math.floor(Math.random() * (this.navmeshs.length -1));
            const p = new THREE.Vector3((Math.random() - 0.5) * 5,  (Math.random() - 0.5) * 5, (Math.random() - 0.5) * 5).add(this.navmeshs[ptIdx].pos);

            const char = await this.addNPC(charDef.ptIdx, p, charDef.angle, charDef.name, charDef.subsystemsDef, charDef.skelScale);
            char.pathStartPts = ptIdx;
            chars[i]=char;
        }

        return chars;
    }
    */

    async loadAnim(name){
        const url =this.assetBase +'/assets/anim/'+name+'.json';
        const res = await fetch(url);
        const data = await res.json();
        const anim = new SkelAnimation();
        anim.load(data);

        return anim;
    }
    
    
    async addNPC(ptsIdx, offset, angle, name, subsystemsDef = null, size = 1, nInstances = 0, instancesData = []){

        const url =this.assetBase +'/assets/chars/'+name+'.json';
        const res = await fetch(url);
        const charDef = await res.json();

        if(charDef.attackOffset){
            charDef.attackOffset= new THREE.Vector3(charDef.attackOffset.x, charDef.attackOffset.y, charDef.attackOffset.z);
        }


        let scriptData, dialog;


        if(charDef.scriptFile){
            const res = await fetch(this.assetBase +'/assets/chars/scripts/'+charDef.scriptFile+'.script');
            scriptData  = await res.text();
            scriptData = scriptData.replace('\r','');
            scriptData = scriptData.split('\n');
        }
        if(charDef.dialogFile){
            const res = await fetch(this.assetBase +'/assets/chars/scripts/'+charDef.dialogFile+'.json');
            dialog  = await res.json();
        }

        let idleAnim = null,walkAnim = null,waveAnim = null, talkAnim= null, shrugAnim = null;

        //if(charDef.ragdoll !== true) 
        {

            if(charDef.idleAnim)
                idleAnim = await this.loadAnim(charDef.idleAnim);

            if(charDef.walkAnim)
                walkAnim = await this.loadAnim(charDef.walkAnim);

            if(charDef.waveAnim)
                waveAnim = await this.loadAnim(charDef.waveAnim);

            if(charDef.talkAnim)
                talkAnim = await this.loadAnim(charDef.talkAnim);

            if(charDef.shrugAnim)
                shrugAnim = await this.loadAnim(charDef.shrugAnim);
        }
        
        let firstNPCId = -1;
        const nLoops= Math.max(1, nInstances);
        const nData = instancesData.length;

        for(let id of instancesData){

            if(id.script){
                const res = await fetch(this.assetBase+ '/assets/chars/scripts/'+id.script+'.script');
                id.scriptData  = await res.text();
                id.scriptData = id.scriptData.replace('\r','');
                id.scriptData = id.scriptData.split('\n');
            }
        }
        
        for(let i=0;i<nLoops;i++){

            const newChar = new Character(  this.lastId++, charDef);
            newChar.pathFinder = new PathFinder(this.navmeshs.length);
            newChar.name = name;
            newChar.nInstances = nInstances;
            newChar.mass = parseFloat(charDef.mass);
            newChar.currentTarget = null;

            newChar.nodeType = charDef.nodeType !== undefined ? charDef.nodeType : 1;
            newChar.attackForce = charDef.attackForce?charDef.attackForce:40080;
            newChar.staticroot = charDef.staticroot === true ? true: false;

            if(nData < 1) {
                newChar.script = scriptData;
                newChar.script_o = scriptData;
                newChar.skelScale = size;
            } else {

                const dataId = Math.floor(Math.random() * nData);
                newChar.skelScale =  instancesData[dataId].size ? instancesData[dataId].size : size;
                newChar.script = instancesData[dataId].scriptData ? instancesData[dataId].scriptData : scriptData;;
            }

            if(!charDef.ragdoll)
                newChar.worldOffset.y = -charDef.height * newChar.skelScale / 2;

            newChar.dialogOptions = null;
            newChar.scriptInstance = {state : '' , prevState : '', time : 0, line : 0,  nLoops: 0};
            newChar.dialog  = dialog;
            newChar.selectedAnswer =0;
            newChar.currentDialogLine = 0;
            newChar.dialogInstance= {state : '' , time : 0, line : 0};

            newChar.anims = [];

            if(idleAnim)
                newChar.anims[charDef.idleAnim] = idleAnim;

            if(walkAnim)
                newChar.anims[charDef.walkAnim] = walkAnim;

            if(waveAnim)
                newChar.anims[charDef.waveAnim] = waveAnim;

            if(talkAnim)
                newChar.anims[charDef.talkAnim] = talkAnim;

            if(shrugAnim)
                newChar.anims[charDef.shrugAnim] = shrugAnim;

            if(newChar.nInstances>1){
                newChar.instanceID = i;
                newChar.offset = { x: 0, y: 0, z: 0 };
            }else{
                newChar.offset = { x: offset.x, y: offset.y, z: offset.z };
                newChar.instanceID = 0;
            }

            newChar.pathStartPts = 0;
            newChar.angle = angle;
            newChar.angles = new THREE.Euler( 0 , angle, 0);
            newChar.ptIdx = ptsIdx;
            newChar.id = this.lastId++;
          
            newChar.lastAttack = 0;
            newChar.subsystemsDef = subsystemsDef !== null ? subsystemsDef : [];

            newChar.tmpEUL = new THREE.Euler();
            newChar.tmpQ = new THREE.Quaternion();
            newChar.tmpQ2 = new THREE.Quaternion();
            newChar.tmpP = new THREE.Vector3();

            this.computeNPC(newChar);

            if(firstNPCId < 0){
                firstNPCId = this.npcs.length;
                newChar.instanceOf = -1;
                newChar.instancesData = instancesData;
            }else
                newChar.instanceOf = firstNPCId;

            this.npcs.push(newChar);
        }

        return this.npcs[firstNPCId];
    }

    computeSpring(spring){

        const tpts = this.trackPoints[spring.ptIdx];
        spring.anchor.pos = { x: tpts.pos.x + spring.offset.x, y: tpts.pos.y + spring.offset.y, z: tpts.pos.z + spring.offset.z }

        spring.obj.pos = { x: spring.anchor.pos.x + spring.eqPts.x, y: spring.anchor.pos.y + spring.eqPts.y, z: spring.anchor.pos.z + spring.eqPts.z };
        spring.obj.rot = { x: spring.initA.x, y: spring.initA.y, z: spring.initA.z, w: spring.initA.w };
        spring.obj.angles = new THREE.Euler("ZYX").setFromQuaternion(new THREE.Quaternion(spring.obj.rot.x, spring.obj.rot.y, spring.obj.rot.z, spring.obj.rot.w));
    }

    addSpring(ptsIdx, offset, eqPts, eqA, mass, size, stiffness, damping, initPts, initA, limit, limitA, shape, mode, model) {
        const tpts = this.trackPoints[ptsIdx];
        const spring = {
            id: this.lastId++,
            offset: { x: offset.x, y: offset.y, z: offset.z },
            obj: { 
                pos: { x: 0, y: 0, z: 0 }, rot: { x: 0, y: 0, z: 0, w: 1 }, 
                shape: shape, 
                mass: mass, 
                size: new THREE.Vector3(1, 1, 1 ), 
            },
            size: new THREE.Vector3(size.x, size.y, size.z ), 
            anchor: { 
                pos: { x: tpts.pos.x + offset.x, y: tpts.pos.y + offset.y, z: tpts.pos.z + offset.z }, 
                rot: { x: 0, y: 0, z: 0, w: 1 } 
            },
            eqPts: { x: eqPts.x, y: eqPts.y, z: eqPts.z },
            mode: mode,
            initPts: { x: initPts.x, y: initPts.y, z: initPts.z },
            initA: { x: initA.x, y: initA.y, z: initA.z, w: initA.w },
            eqA: { x: eqA.x, y: eqA.y, z: eqA.z },
            limit: { x: limit.x, y: limit.y, z: limit.z },
            limitA: { x: limitA.x, y: limitA.y, z: limitA.z },
            stiffness: stiffness,
            damping: damping,
            shape: shape,
            model: model,
            ptIdx: ptsIdx
        };

        spring.obj.pos = { x: spring.anchor.pos.x + spring.eqPts.x, y: spring.anchor.pos.y + spring.eqPts.y, z: spring.anchor.pos.z + spring.eqPts.z };
        spring.obj.rot = { x: spring.initA.x, y: spring.initA.y, z: spring.initA.z, w: spring.initA.w };
        spring.obj.angles = new THREE.Euler("ZYX").setFromQuaternion(new THREE.Quaternion(spring.obj.rot.x, spring.obj.rot.y, spring.obj.rot.z, spring.obj.rot.w));


        this.springs.push(spring);

        return spring;
    }

    computeRope(rope) {

        
        if((rope.anchorObj.length>0)&&(this.movingObjects[rope.anchorObj])) {

            const mo = this.movingObjects[rope.anchorObj];

            //const axis = new THREE.Vector3().subVectors(mo.axis, mo.oPos);
            

            const aPos = new THREE.Vector3().addVectors(mo.axis, mo.deltaAnchor );

            mo.rot = new THREE.Quaternion({ x: 0, y: 0, z: 0, w: 1.0 });
            
            rope.anchor.pos.x = aPos.x + rope.offset.x + this.terrain.offset.x;
            rope.anchor.pos.y = aPos.y + rope.offset.y + this.terrain.offset.y;
            rope.anchor.pos.z = aPos.z + rope.offset.z + this.terrain.offset.z;

        } else if(rope.ptIdx>=0){
            const tpts = this.trackPoints[rope.ptIdx];

            rope.anchor.pos.x = tpts.pos.x + rope.offset.x;
            rope.anchor.pos.y = tpts.pos.y + rope.offset.y;
            rope.anchor.pos.z = tpts.pos.z + rope.offset.z;
        }
        
        rope.pos = rope.anchor.pos;

        rope.obj.pos = { x: rope.anchor.pos.x - rope.initPts.x, y: rope.anchor.pos.y - rope.initPts.y, z: rope.anchor.pos.z - rope.initPts.z };
        rope.obj.rot = { x: rope.initA.x, y: rope.initA.y, z: rope.initA.z, w: rope.initA.w };
        rope.obj.angles = new THREE.Euler("ZYX").setFromQuaternion(new THREE.Quaternion(rope.obj.rot.x, rope.obj.rot.y, rope.obj.rot.z, rope.obj.rot.w));


    }


    addRope(ptsIdx, offset, eqPts, eqA, mass, size, softness, damping, motorforce, bounce, initPts, initA, limit, limitA, shape, anchorObj, model) {
        
        const rope = {
            id: this.lastId++,
            anchorObj:anchorObj, 
            model: model,
            offset: { x: offset.x, y: offset.y, z: offset.z },
            obj: { 
                pos: { x: 0, y: 0, z: 0 }, 
                rot: { x: 0, y: 0, z: 0, w: 1 }, 
                shape: shape, 
                mass: mass, 
                size: { x: size.x, y: size.y, z: size.z } 
            },
            anchor: { 
                pos: { x: 0.0, y: 0.0, z: 0.0 }, 
                rot: { x: 0, y: 0, z: 0, w: 1 } 
            },

            eqPts: { x: eqPts.x, y: eqPts.y, z: eqPts.z },
            initPts: { x: initPts.x, y: initPts.y, z: initPts.z },
            initA: { x: initA.x, y: initA.y, z: initA.z, w: initA.w },
            eqA: { x: eqA.x, y: eqA.y, z: eqA.z },
            limit: { x: limit.x, y: limit.y, z: limit.z },
            limitA: { x: limitA.x, y: limitA.y, z: limitA.z },
            softness: softness,
            damping: damping,
            motorforce: motorforce,
            bounce: bounce,
            shape: shape,
            ptIdx: ptsIdx
        };

        this.ropes.push(rope);

        return rope;
    }

    computeBonus(bonus){
        const tpts = this.trackPoints[bonus.ptIdx];

        bonus.pos.x = tpts.pos.x + bonus.offset.x;
        bonus.pos.y = tpts.pos.y + bonus.offset.y;
        bonus.pos.z = tpts.pos.z + bonus.offset.z;
    }

    addBonus(ptsIdx, type, amount, offset, size) {
        
        const newBonus = {
            id: this.lastId++,
            offset: { x: offset.x, y: offset.y, z: offset.z },
            pos: { x: 0, y: 0, z: 0 },
            rot : new THREE.Quaternion(),
            angles: type == 0 ? { x: 0, y: 0, z: 35 } : { x: 0, y: 0, z: 0 },
            size: size,
            scale:  { x: size, y: size, z: size},
            ptIdx: ptsIdx, 
            type: type, 
            amount: amount, 
            taken: 0, 
            size: size, 
            enabled: true, 
            object: null
        };

        this.computeBonus(newBonus);

        this.bonuses.push(newBonus);

        return newBonus;
    }

    setTexture(tex, norm = null, spec = null, emm = null, rought = null, height = null, scale = null) {
        this.roadTex = tex;
        this.roadNorm = norm;
        this.roadSpec = spec;
        this.roadRought = rought;
        this.roadEmm = emm;
        this.roadHeight = height;

        this.roadTexScale = scale ? { x: scale.x, y: scale.y } : { x: 2, y: 4 };
    }

    getSpiderSkelBoneSave(bone){

        const newBone = {   name:  bone.name,
                            pos : {x: bone.pos.x, y: bone.pos.y, z: bone.pos.z }, 
                            rot : {x: bone.rot.x, y: bone.rot.y, z: bone.rot.z, w: bone.rot.w },
                            size : bone.size, 
                            children : []
                        };
        
        for(let child of bone.children){
            const newChild = this.getSpiderSkelBoneSave(child);
            newBone.children.push(newChild);
        }

        return newBone;
            

    }

    getSpiderSkelSave(skel){

        const root = skel.root;
        const newSkel = {   name:  "root",
                            pos : {x: root.pos.x, y: root.pos.y, z: root.pos.z }, 
                            rot : {x: root.rot.x, y: root.rot.y, z: root.rot.z, w: root.rot.w },
                            size : root.size,
                            children : []
                        }

        for(let child of root.children){
            const newChild = this.getSpiderSkelBoneSave(child);
            newSkel.children.push(newChild);
        }

        return newSkel;
                        

    }


    getRagdollBoneSave(bone){

        const newBone = {   name:  bone.name,
                            rot : {x: bone.quat.x, y: bone.quat.y, z: bone.quat.z, w: bone.quat.w },
                            children : []
                        };
        
        for(let child of bone.children){
            const newChild = this.getRagdollBoneSave(child);
            newBone.children.push(newChild);
        }

        return newBone;
            

    }

    getRagdollSave(skel){

        const root = skel.root;
        const newSkel = {   name:  root.name,
                            pos : {x : root.pos.x, y : root.pos.y, z : root.pos.z},
                            rot : {x: root.quat.x, y: root.quat.y, z: root.quat.z, w: root.quat.w },
                            children : []
                        }

        for(let child of root.children){
            const newChild = this.getRagdollBoneSave(child);
            newSkel.children.push(newChild);
        }

        return newSkel;
    }


    async saveTrack(name) {
        
        var mytrack = { nPts: this.NPoints, tensionL : this.tensionL, tensionR : this.tensionR, tensionC : this.tensionC, wallSpace : this.wallSpace, prize: this.prize, gravity: this.gravity, music: this.music, skyBoxImg: this.skyBoxImg, restitution: this.restitution, friction: this.friction, class: this.class, difficulty: this.difficulty, driftFlags: this.driftFlags, 
                        tubecolor : {r : this.tubecolor.r, g : this.tubecolor.g, b : this.tubecolor.b},
                        curveType:this.curveType,
                        roadMat: 
                        { 
                            t: this.roadTex, 
                            st: this.roadTex2, 
                            sn: this.roadNorm2, 
                            f : this.fxMapTex, 
                            a : this.roadAlpha,  
                            n: this.roadNorm, 
                            s: this.roadSpec, 
                            e: this.roadEmm, 
                            r: this.roadRought, 
                            h: this.roadHeight, 
                            scale: { 
                                x: this.roadTexScale.x, 
                                y: this.roadTexScale.y 
                            },
                            params : {
                                reflectivity: this.roadParams.reflectivity,
                                metalness: this.roadParams.metalness,
                                roughness: this.roadParams.roughness,
                                envMapIntensity: this.roadParams.envMapIntensity
                            }
                        }, 
                        lapTime: this.lapTime, 
                        wall: { name: this.wallName }, 
                        bloom: this.bloom,
                        fogIntensity :  this.fogIntensity,
                        gscale :this.gscale,
                        roadGrasses : this.roadGrasses,
                        borderWidth : this.borderWidth,
                        borderHeight : this.borderHeight,

                        
                        terrain: { name: this.terrain.name,  lightmap : this.terrain.lightMap , minimap: this.terrain.minimap , fxmap: this.terrain.fxmap} , pts: [], woods: [], bonuses: [], jumpers: [], loopings: [], worms: [], tubes: [], turrets: [], springs: [], ropes: [], waves: [], interestPoints: [], drones: [], movingObjects: [], cyls : [], cubes : [], colcyls: [] , colcubes : [], characters : [], spiders: [], triggers: [], grids : [], xmeshes : [], meshInstances: [], navmeshs:[]
                    };



        if(this.carStartPos !== null){

            mytrack.carStartPos = {
                                        pos: { x: this.carStartPos.pos.x, y: this.carStartPos.pos.y, z: this.carStartPos.pos.z }, 
                                        rot: { x: this.carStartPos.rot.x, y: this.carStartPos.rot.y, z: this.carStartPos.rot.z, w: this.carStartPos.rot.w }, 
                                  };

        }
        
        for(let i of this.meshInstances){
            mytrack.meshInstances.push(i.key);
        }

        for (let node of this.navmeshs) {

            mytrack.navmeshs.push({
                pos : node.pos,
                type : node.type,
                links: node.links,
            });
        }

        for (let m in this.movingObjects) {

            const Da = this.movingObjects[m].deltaAnchor ? this.movingObjects[m].deltaAnchor : {x:0, y:0, z:0};
            mytrack.movingObjects.push( {   name: m,
                                            axis: {x: this.movingObjects[m].axis.x, y:this.movingObjects[m].axis.y, z:this.movingObjects[m].axis.z}, 
                                            deltaAnchor: {x: Da.x, y: Da.y, z: Da.z}} );
        }

        for (let n = 0; n < this.trackPoints.length; n++) {

            const p = this.trackPoints[n].opos ? this.trackPoints[n].opos : this.trackPoints[n].pos;
            p.sub(this.terrain.offset);

            mytrack.pts.push({ pos: {   x: p.x, 
                                        y: p.y, 
                                        z: p.z }, 
                                width: this.trackPoints[n].width, noWalls: this.trackPoints[n].noWalls ? true : false });
        }


        


        for (let n = 0; n < this.npcs.length; n++) {

            if(this.npcs[n].instanceOf>=0)
                continue;

            const idata = [];

            for(let it of this.npcs[n].instancesData){
                const itt = {};
                
                if(it.script)
                    itt.script = it.script;

                if(it.speed)
                    itt.speed = it.speed;             
                
                if(it.size)
                    itt.size = it.size;                   

                idata.push(itt);
            }

            mytrack.characters.push({ ptIdx : this.npcs[n].ptIdx, instancesData :idata, nInstances : this.npcs[n].nInstances, offset : this.npcs[n].offset, angle :this.npcs[n].angle, name: this.npcs[n].name, skelScale: this.npcs[n].skelScale, subsystemsDef: this.npcs[n].subsystemsDef });
        }

        for (let n = 0; n < this.cyls.length; n++) {
            mytrack.cyls.push({name: this.cyls[n].name,radiusX : this.cyls[n].radiusX, radiusZ : this.cyls[n].radiusZ, height: this.cyls[n].height, pos: this.cyls[n].pos, rot: {x: this.cyls[n].rot.x, y: this.cyls[n].rot.y, z: this.cyls[n].rot.z, w: this.cyls[n].rot.w}, mass: this.cyls[n].mass, stiffness: this.cyls[n].stiffness, damping: this.cyls[n].damping, anchorPos: this.cyls[n].anchorPos, deltaPhys: this.cyls[n].deltaPhys, heightOffset : this.cyls[n].heightOffset });
        }

        for (let n = 0; n < this.colcyls.length; n++) {
            mytrack.colcyls.push({name: this.colcyls[n].name, radiusX : this.colcyls[n].radiusX, radiusZ : this.colcyls[n].radiusZ, height: this.colcyls[n].height, pos: this.colcyls[n].pos, rot: {x: this.colcyls[n].rot.x, y: this.colcyls[n].rot.y, z: this.colcyls[n].rot.z, w: this.colcyls[n].rot.w}  });
        }

        for (let n = 0; n < this.colcubes.length; n++) {
            mytrack.colcubes.push({name : this.colcubes[n].name, size : this.colcubes[n].size, pos : this.colcubes[n].pos, rot :  {x: this.colcubes[n].rot.x, y: this.colcubes[n].rot.y, z: this.colcubes[n].rot.z, w: this.colcubes[n].rot.w}});
        }

        for (let n = 0; n < this.cubes.length; n++) {
            mytrack.cubes.push({name : this.cubes[n].name, size : this.cubes[n].size, pos : this.cubes[n].pos, rot : {x: this.cubes[n].rot.x, y: this.cubes[n].rot.y, z: this.cubes[n].rot.z, w: this.cubes[n].rot.w} , mass : this.cubes[n].mass, stiffness: this.cubes[n].stiffness, damping: this.cubes[n].damping, anchorPos: this.cubes[n].anchorPos });
        }

        for (let n = 0; n < this.xmeshes.length; n++) {
            mytrack.xmeshes.push({name : this.xmeshes[n].name, size : this.xmeshes[n].size, pos : this.xmeshes[n].pos, rot : {x: this.xmeshes[n].rot.x, y: this.xmeshes[n].rot.y, z: this.xmeshes[n].rot.z, w: this.xmeshes[n].rot.w} , mass : this.xmeshes[n].mass, meshData : this.xmeshes[n].meshData});
        }
        
        

        for (let n = 0; n < this.triggers.length; n++) {

            const t = { type: this.triggers[n].type, 
                        size : this.triggers[n].size, 
                        pos : this.triggers[n].pos, 
                        rot :  {x: this.triggers[n].rot.x, y: this.triggers[n].rot.y, z: this.triggers[n].rot.z, w: this.triggers[n].rot.w}
                      };

            if(this.triggers[n].action) {
                t.action = this.triggers[n].action;
                t.data = this.triggers[n].data;
            }

            mytrack.triggers.push( t);
        }


        for (let n = 0; n < this.woods.length; n++) {
            mytrack.woods.push({ ptIdx: this.woods[n].ptIdx, offset: { x: this.woods[n].offset.x, y: this.woods[n].offset.y, z: this.woods[n].offset.z }, width: this.woods[n].width, num: this.woods[n].num, radius: this.woods[n].radius, mass: this.woods[n].mass });
        }

        for (let n = 0; n < this.bonuses.length; n++) {
            mytrack.bonuses.push({ ptIdx: this.bonuses[n].ptIdx, offset: { x: this.bonuses[n].offset.x, y: this.bonuses[n].offset.y, z: this.bonuses[n].offset.z }, type: this.bonuses[n].type, amount: this.bonuses[n].amount, size: this.bonuses[n].size });
        }
        for (let n = 0; n < this.jumpers.length; n++) {
            mytrack.jumpers.push({ ptIdx: this.jumpers[n].ptIdx, offset: { x: this.jumpers[n].offset.x, y: this.jumpers[n].offset.y, z: this.jumpers[n].offset.z }, size: { x: this.jumpers[n].size.x, y: this.jumpers[n].size.y, z: this.jumpers[n].size.z }, angle: { x: this.jumpers[n].angle.x, y: this.jumpers[n].angle.y, z: this.jumpers[n].angle.z } });
        }

        for (let n = 0; n < this.loopings.length; n++) {
            mytrack.loopings.push({ ptIdx: this.loopings[n].idx, height: this.loopings[n].height, dir: this.loopings[n].dir, hide: this.loopings[n].hide, npts: this.loopings[n].npts });
        }

        for (let n = 0; n < this.worms.length; n++) {
            mytrack.worms.push({ ptIdx: this.worms[n].idx, height: this.worms[n].height, dir: this.worms[n].dir, npts: this.worms[n].npts });
        }

        for (let n = 0; n < this.tubes.length; n++) {
            mytrack.tubes.push({ ptIdx: this.tubes[n].idx, height: this.tubes[n].height, width: this.tubes[n].width, dir: this.tubes[n].dir, npts: this.tubes[n].npts });
        }

        for (let n = 0; n < this.waves.length; n++) {
            mytrack.waves.push({ ptIdx: this.waves[n].idx, amplitude: this.waves[n].amplitude, frequency: this.waves[n].frequency, phase: this.waves[n].phase, npts: this.waves[n].npts });
        }

        for (let n = 0; n < this.turrets.length; n++) {
            mytrack.turrets.push(
            {  
                ptIdx: this.turrets[n].ptIdx, 
                model: this.turrets[n].model, 
                shotModel: this.turrets[n].shotModel, 
                activation: this.turrets[n].activation, 
                offset: { x: this.turrets[n].offset.x, y: this.turrets[n].offset.y, z: this.turrets[n].offset.z }, 
                size: { x: this.turrets[n].size.x, y: this.turrets[n].size.y, z: this.turrets[n].size.z }, 
                angle: { x: this.turrets[n].angles.x, y: this.turrets[n].angles.y, z: this.turrets[n].angles.z }, 
                projPts: { x: this.turrets[n].projPts.x, y: this.turrets[n].projPts.y, z: this.turrets[n].projPts.z }, 
                projSize: this.turrets[n].projSize, 
                projMass: this.turrets[n].projMass, 
                projSpeed: this.turrets[n].projSpeed, 
                projAngle: this.turrets[n].projAngle, 
                projAngle2: this.turrets[n].projAngle2, 
                projDelay: this.turrets[n].projDelay, 
                projRoll: this.turrets[n].projRoll, 
                projPart: this.turrets[n].projPart, 
                projTTL: this.turrets[n].projTTL, 
                projLL:  this.turrets[n].projLL, 
                bodyPos: {x : this.turrets[n].bodyPos.x, y : this.turrets[n].bodyPos.y, z : this.turrets[n].bodyPos.z},
                bodyCenter: {x : this.turrets[n].bodyCenter.x, y : this.turrets[n].bodyCenter.y, z : this.turrets[n].bodyCenter.z},
                headPos: {x : this.turrets[n].headPos.x, y : this.turrets[n].headPos.y, z : this.turrets[n].headPos.z},
                headCenter: {x : this.turrets[n].headCenter.x, y : this.turrets[n].headCenter.y, z : this.turrets[n].headCenter.z},
                cannonPos : {x : this.turrets[n].cannonPos.x, y : this.turrets[n].cannonPos.y, z : this.turrets[n].cannonPos.z},
                canonCenter: {x : this.turrets[n].canonCenter.x, y : this.turrets[n].canonCenter.y, z : this.turrets[n].canonCenter.z},
                bodyRadius:this.turrets[n].bodyRadius,
                bodyHeight:this.turrets[n].bodyHeight,
                headRadius:this.turrets[n].headRadius,
                headHeight :this.turrets[n].headHeight,
                cannonRadius :this.turrets[n].cannonRadius,
                cannonHeight :this.turrets[n].cannonHeight,
                life :this.turrets[n].life,
                moveAngle :  this.turrets[n].moveAngle,
                projSND: this.turrets[n].projSND 
            });
        }

        for (let n = 0; n < this.drones.length; n++) {
            
            const pales = [];
            for(let pale of this.drones[n].pales){
                pales.push({name : pale.name, pos : pale.rpos, radiusX: pale.radiusX, height: pale.height, radiusZ: pale.radiusZ, life: pale.life});
            }

            const weapons = [];

            for(let w of this.drones[n].weapons){

                weapons.push({
                    projPts: new THREE.Vector3(w.projPts.x, w.projPts.y, w.projPts.z), 
                    projSpeed: w.projSpeed, 
                    projMass: w.projMass, 
                    projModel: w.projModel ? w.projModel : null, 
                    projBlastRadius: w.projBlastRadius ? w.projBlastRadius : 0,  
                    projBlastForce: w.projBlastForce ? w.projBlastForce : 0,  
                    projBlastImpact: w.projBlastImpact ? w.projBlastImpact : 0, 
                    projLL : w.projLL ? w.projLL: 3, 
                    projSize: w.projSize, 
                    projPart: w.projPart,
                    projHoming: w.projHoming, 
                    projDelay: w.projDelay ? w.projDelay : 300, 
                    projTTL: w.projTTL ? w.projTTL : 0
                });
            }

            mytrack.drones.push(
                {   ptIdx: this.drones[n].ptIdx, 
                    model: this.drones[n].model, 
                    weight: this.drones[n].weight,
                
                    activation: this.drones[n].activation, 
                    deactivation: this.drones[n].deactivation, 
                    speed: this.drones[n].speed, 
                    offset: { x: this.drones[n].offset.x, y: this.drones[n].offset.y, z: this.drones[n].offset.z }, 
                    caroffset: this.drones[n].caroffset ? { x: this.drones[n].caroffset.x, y: this.drones[n].caroffset.y, z: this.drones[n].caroffset.z } : null, 
                    size: { x: this.drones[n].size.x, y: this.drones[n].size.y, z: this.drones[n].size.z }, 
                    droneSize: { x: this.drones[n].droneSize.x, y: this.drones[n].droneSize.y, z: this.drones[n].droneSize.z }, 
                    angle: { x: this.drones[n].angles.x, y: this.drones[n].angles.y, z: this.drones[n].angles.z }, 
                  
                    angleMove : this.drones[n].angleMove, 

                    speedPale1: this.drones[n].speedPale1, 
                    speedPale2: this.drones[n].speedPale2, 
                    upLift : this.drones[n].upLift, 
                    weapons : weapons,
                    pales : pales });
        }




        for (let n = 0; n < this.interestPoints.length; n++) {
            mytrack.interestPoints.push({   ptIdx: this.interestPoints[n].ptIdx, 
                                            offset: { x: this.interestPoints[n].offset.x, y: this.interestPoints[n].offset.y, z: this.interestPoints[n].offset.z }, 
                                            size: { x: this.interestPoints[n].size.x, y: this.interestPoints[n].size.y, z: this.interestPoints[n].size.z }, 
                                            angle: { x: this.interestPoints[n].angle.x, y: this.interestPoints[n].angle.y, z: this.interestPoints[n].angle.z },
                                            lobject: this.interestPoints[n].lobject , 
                                            loffset: { x: this.interestPoints[n].loffset.x, y: this.interestPoints[n].loffset.y, z: this.interestPoints[n].loffset.z},
                                            lsize: this.interestPoints[n].lsize, 
                                            lweight: this.interestPoints[n].lweight,
                                            nBonus: this.interestPoints[n].nBonus,
                                            targetNode: this.interestPoints[n].targetNode,
                                            mainObject: "" });
        }

        for (let n = 0; n < this.springs.length; n++) {
            mytrack.springs.push({
                ptIdx: this.springs[n].ptIdx,
                offset: { x: this.springs[n].offset.x, y: this.springs[n].offset.y, z: this.springs[n].offset.z },
                size: { x: this.springs[n].size.x, y: this.springs[n].size.y, z: this.springs[n].size.z },
                eqPts: { x: this.springs[n].eqPts.x, y: this.springs[n].eqPts.y, z: this.springs[n].eqPts.z },
                eqA: { x: this.springs[n].eqA.x, y: this.springs[n].eqA.y, z: this.springs[n].eqA.z },
                initPts: { x: this.springs[n].initPts.x, y: this.springs[n].initPts.y, z: this.springs[n].initPts.z },
                initA: { x: this.springs[n].initA.x, y: this.springs[n].initA.y, z: this.springs[n].initA.z, w: this.springs[n].initA.w },
                limit: { x: this.springs[n].limit.x, y: this.springs[n].limit.y, z: this.springs[n].limit.z },
                limitA: { x: this.springs[n].limitA.x, y: this.springs[n].limitA.y, z: this.springs[n].limitA.z },
                shape: this.springs[n].obj.shape,
                mass: this.springs[n].obj.mass,
                mode: this.springs[n].mode,
                model: this.springs[n].model,
                stiffness: this.springs[n].stiffness,
                damping: this.springs[n].damping
            });
        }


        for (let n = 0; n < this.ropes.length; n++) {
            mytrack.ropes.push({
                ptIdx: this.ropes[n].ptIdx,
                anchorObj: this.ropes[n].anchorObj,
                model: this.ropes[n].model,
                offset: { x: this.ropes[n].offset.x, y: this.ropes[n].offset.y, z: this.ropes[n].offset.z },
                size: { x: this.ropes[n].obj.size.x, y: this.ropes[n].obj.size.y, z: this.ropes[n].obj.size.z },
                eqPts: { x: this.ropes[n].eqPts.x, y: this.ropes[n].eqPts.y, z: this.ropes[n].eqPts.z },
                eqA: { x: this.ropes[n].eqA.x, y: this.ropes[n].eqA.y, z: this.ropes[n].eqA.z },
                initPts: { x: this.ropes[n].initPts.x, y: this.ropes[n].initPts.y, z: this.ropes[n].initPts.z },
                initA: { x: this.ropes[n].initA.x, y: this.ropes[n].initA.y, z: this.ropes[n].initA.z, w: this.ropes[n].initA.w },
                limit: { x: this.ropes[n].limit.x, y: this.ropes[n].limit.y, z: this.ropes[n].limit.z },
                limitA: { x: this.ropes[n].limitA.x, y: this.ropes[n].limitA.y, z: this.ropes[n].limitA.z },
                shape: this.ropes[n].obj.shape,
                mass: this.ropes[n].obj.mass,
                softness: this.ropes[n].softness,
                damping: this.ropes[n].damping,
                motorforce: this.ropes[n].motorforce,
                bounce: this.ropes[n].bounce
            });
        }

        for (let n = 0; n < this.spiders.length; n++) {

            const skel = this.getSpiderSkelSave(this.spiders[n].skel);
            
            mytrack.spiders.push(   {   ptIdx: this.spiders[n].ptIdx, 
                                        model: this.spiders[n].model, 
                                        shotModel: this.spiders[n].shotModel, 
                                        activation: this.spiders[n].activation, 
                                        offset: { x: this.spiders[n].offset.x, y: this.spiders[n].offset.y, z: this.spiders[n].offset.z }, 
                                        size: { x: this.spiders[n].size.x, y: this.spiders[n].size.y, z: this.spiders[n].size.z }, 
                                        angle: { x: this.spiders[n].angles.x, y: this.spiders[n].angles.y, z: this.spiders[n].angles.z }, 
                                        projSize: this.spiders[n].projSize, 
                                        projMass: this.spiders[n].projMass, 
                                        projSpeed: this.spiders[n].projSpeed, 
                                        projDelay: this.spiders[n].projDelay, 
                                        projTTL: this.spiders[n].projTTL, 
                                        skel : skel,
                                        projSND: this.spiders[n].projSND });
        }

        
        for (let n = 0; n < this.grids.length; n++) {
            mytrack.grids.push({ ptIdx: this.grids[n].ptIdx, offset : {x: this.grids[n].offset.x, y: this.grids[n].offset.y, z: this.grids[n].offset.z }  , angle : {x: this.grids[n].angle.x, y: this.grids[n].angle.y, z: this.grids[n].angle.z }, cell_size : {x: this.grids[n].cell_size.x, y: this.grids[n].cell_size.y, z: this.grids[n].cell_size.z }, width: this.grids[n].width, height : this.grids[n].height, depth : this.grids[n].depth, isolevel: this.grids[n].isolevel, nBalls: this.grids[n].nBalls, ballRadius: this.grids[n].ballRadius, ballWeight : this.grids[n]. ballWeight});
        }

        if (this.HM) {
            mytrack.terrain.hm = { file: this.HM.file, scale: { x: this.HM.scale.x, y: this.HM.scale.y, z: this.HM.scale.z }, pos: { x: this.HM.pos.x, y: this.HM.pos.y, z: this.HM.pos.z } }
        }



        /*
        const dataArray = this.terrain.ground.geometry.attributes.position.array;
        const chars = new Uint8Array(dataArray.buffer);
        const chunk = 100 * 1024;
        const strbuf = String.fromCharCode.apply( null, chars);
        const enc  = btoa( strbuf );

        $.ajax({
            type: "POST",
            url: '/saveMeshChunk?trackName=' + name+'&chunkID='+0,
            data: { data: enc },
            dataType: 'json',
            success: function (result) {

                if (result.result === true)
                    return true;
                else
                    return false;
            }
        });
        */

        /*
        for(let i=0;i<chars.length;i+=chunk){
            const enc  = btoa( String.fromCharCode.apply( null, chars.subarray(i, i+chunk )) );    
            $.ajax({
                type: "POST",
                url: '/saveMeshChunk?trackName=' + name+'&chunkID='+i,
                data: { data: enc },
                dataType: 'json',
                success: function (result) {
    
                    if (result.result === true)
                        return true;
                    else
                        return false;
                }
            });
        }*/
        

        let groundMesh = null;
        if(this.terrain.ground){

            const groundGeo = this.terrain.ground.geometry.clone().toNonIndexed();
            groundGeo.applyMatrix4(this.terrain.ground.matrix);

            const chars = new Uint8Array(groundGeo.attributes.position.array.buffer);
            let txt = '';

            for(let i=0;i<chars.length;i++){
                txt += String.fromCharCode(chars[i])
            }
            groundMesh = btoa(txt);
        }

        const levelData = JSON.stringify(mytrack);

        $.ajax({
            type: "POST",
            url: '/api/saveTrack?trackName=' + name,
            data: { track: levelData, groundMesh : groundMesh },
            dataType: 'json',
            success: function (result) {

                if (result.result === true)
                    return true;
                else
                    return false;
            }
        });
    }

    roadObj;
    trackPoints;
    walls;
}


const nulltire = { id: "0", tire:'', "class" : '',template_mint : "-1", type :-1, claim:false, force: 0, friction: 0, stiffness: 0, damping: 0.0, compression: 0.6, tire: "", name: "" , width: 0.0, radius: 0.0}
const nullmotor = { id: "0", motor:'', "class" : '',template_mint : "-1", type :-1, claim:false, maxEngineForce: 0, maxBreakingForce: 0 , name: "", nitro: 0, a:0, b:0, c:0, "a" : 0, "b" :0, "c" : 0}
const tires = [{ id: "201", tire:'', "class" : '', template_mint : "-1", type :-1, claim:false, force: 6000, friction: 200, stiffness: 20, damping: 0.2, compression: 0.6, tire: "tire", name: "free tire" , width: 0.2, radius: 0.3}];
const motors = [{ id: "101", motor:'', "class" : '', template_mint :"-1", type :-1, claim:false, maxEngineForce: 300, maxBreakingForce: 30 , name: "free motor", "motor": "engine", "nitro" : 1.0, "a" : -0.0000043, "b" : 0.033, "c" : 125}];
const cars = [{ id: "1", claim:false, template_mint: '?', type :-1, isfree: true, name: "free car", claim: false, DMG : null, mdata : null ,isDemo : false, class: "", weapon : null, radar : null, battery : null, maxdmg : 0, chassis: 'car2', massVehicle: 350, steeringClamp: 0.4, steeringIncrement: .04, suspensionRestLength: 0.60, motorid: 101, tireid: 201,  motor: nullmotor, suspension: nulltire }];


//var scale = chroma.scale(['blue', 'green', 'red']).domain([0, 50]);

class PathFinder {

    visited;
    distance;
    predecessors;
    numNodes;

    constructor(numNodes) {

        this.numNodes = numNodes;
        this.visited = new Uint8Array(this.numNodes);
        this.distance = new Float32Array(this.numNodes);
        this.predecessors = new Uint8Array(this.numNodes);
    }

    reset(){

        this.predecessors = [];

        this.visited.fill(0);
        this.distance.fill(Infinity);
        this.predecessors.fill(255);


    }
}

class CircuitRace {


    constructor() {


        this.startTime = -1;
        this.track = null;
        this.myCar = null;
        this.myChar = null;
        this.carId = 1;
        this.lastCarData = null;
        this.lastBufferTime = null;
        this.terrain = {blinks : [], grasses: [], cyls: [], cubes: [], movingTerrain : []}
        this.deltaTime = null;
        this.lastScreech = 0;
        this.cars = [];
        this.characters = [];
        this.states = {};
        this.eventItems = [];
        this.triggerObject = null;
    }

  

    

    getCarTarget(car, targetID, targetSubsystemId){

        if(!car.ChassisMesh)
            return null;

        const carPos = car.ChassisMesh.position;
        const carQuat = car.ChassisMesh.quaternion;
        const track = this.track;

        const targets = [];
        const fv = new THREE.Vector3(0,0,1).applyQuaternion(carQuat);
        const angleX = Math.asin(fv.y);
        const angleY = Math.atan2(fv.x, fv.z);
        const c  = Math.cos(angleX);
        const s  = Math.sin(angleX);
  
        const maxDist = 40;
        const maxAngle = 0.2;
  
        const d = new THREE.Vector3();

        for(let n=0;n<track.npcs.length;n++){

            if(!track.npcs[n].target)
                continue;

            if(targetID !== track.npcs[n].target.id)
                continue;            
  
            d.subVectors(track.npcs[n].avatarMesh.position, carPos);
            const l = d.length();
            if(l < maxDist){
                d.normalize();
                if(d.dot(fv)> maxAngle){
                    return this.track.getNPCTarget(track.npcs[n], targetSubsystemId);
                }
            }
        }

        for(let n=0;n<track.drones.length;n++){
            const drone = track.drones[n];
  
            d.subVectors(drone.target.pos, carPos);
            const l = d.length();
            if(l < maxDist){
                d.normalize();
                if(d.dot(fv)> maxAngle){

                    if(targetID === drone.target.id){

                        const retTarget = { id :drone.target.id, 
                                            subsystem : null,
                                            name : drone.target.name, 
                                            txt : drone.target.txt, 
                                            pos: {x : drone.target.pos.x, y : drone.target.pos.y, z : drone.target.pos.z}
                                          };

                        if(targetSubsystemId === 0)
                            return retTarget;
                        
                        for(let p = 0; p< drone.pales.length; p++){

                            const mss = drone.target.subsystems[p];
                            const pale = drone.pales[p];
                                
                            if(mss.id === targetSubsystemId){
                                retTarget.subsystem =  { id : mss.id, 
                                                         name : mss.name, 
                                                         txt : mss.txt, 
                                                         pos: {x : pale.mesh.position.x, y : pale.mesh.position.y, z : pale.mesh.position.z},
                                                       }
                                break;
                            }
                        }

                        return retTarget;
                    }
                }
            }
        }

        for(let n=0;n<track.turrets.length;n++){
            const turret = track.turrets[n];
  
            d.subVectors(turret.target.pos, carPos);
            const l = d.length();
            if(l < maxDist){
                d.normalize();
                if(d.dot(fv)> maxAngle){

                    if(targetID === turret.target.id){

                        const retTarget = { id :turret.target.id, 
                                            subsystem : null,
                                            name : turret.target.name, 
                                            txt : turret.target.txt, 
                                            pos: {x : turret.target.pos.x, y : turret.target.pos.y, z : turret.target.pos.z}
                                          };

                        return retTarget;
                    }
                }
            }
        }
  
          for(let n=0;n<track.spiders.length;n++){
  
            d.subVectors(track.spiders[n].skel.root.obj.position, carPos);
            const l = d.length();
            if(l < maxDist){
                d.normalize();
                if(d.dot(fv)> maxAngle){

                    if(targetID === track.spiders[n].target.id){

                        const retTarget = { id :track.spiders[n].target.id, 
                                            name : track.spiders[n].target.name, 
                                            txt : track.spiders[n].target.txt, 
                                            pos: {  x : track.spiders[n].skel.root.obj.position.x, 
                                                    y : track.spiders[n].skel.root.obj.position.y, 
                                                    z : track.spiders[n].skel.root.obj.position.z}, 
                                            subsystem : null
                                          };
    
                        if(targetSubsystemId === 0)
                            return retTarget;

                        for(let ss of track.spiders[n].target.subsystems){

                            if(ss.id == targetSubsystemId){

                                const bone = this.track.findSpiderBone(track.spiders[n].skel.root, ss.name);

                                retTarget.subsystem = { id :ss.id, 
                                                        name : ss.name, 
                                                        txt : ss.txt, 
                                                        pos: {x : bone.obj.position.x, y : bone.obj.position.y, z : bone.obj.position.z}
                                                    };
                                break;
                            }

                        }

                        return retTarget;
                    }
                }
            }
        }


        for(let n=0;n<this.cars.length;n++){

            if(this.cars[n] .id == car.id)
                continue;
  
            d.subVectors(this.cars[n].ChassisMesh.position, carPos);
            const l = d.length();
            if(l < maxDist) 
            {
              d.normalize();
              if(d.dot(fv)> maxAngle) {

                const retTarget = { id :this.cars[n].target.id, 
                                    name : this.cars[n].target.name, 
                                    txt : this.cars[n].target.txt, 
                                    pos: {  x : this.cars[n].ChassisMesh.position.x, 
                                            y : this.cars[n].ChassisMesh.position.y, 
                                            z : this.cars[n].ChassisMesh.position.z}, 
                                    subsystem : null
                                };                                
  
                return retTarget;
  
              }
            }
        }

        return null;
      }


      computeCarPos(){
        const carPositions = [  [{x:0.0, z: 0.0}], 
                                [{x:-3.0, z: 0.0}, {x: 3.0, z: 0.0}] , 
                                [{x:-3.0, z: 0.0}, {x: 3.0, z: 0.0}, {x: 0.0, z: 8.0}],
                                [{x:-3.0, z: 0.0}, {x: 3.0, z: 0.0}, {x:-3.0, z: 8.0}, {x: 3.0, z: 8.0}]]

        const nCars = this.cars.length;

        const startPt = this.track.carStartPos ? this.track.carStartPos : this.track.trackPoints[this.track.startPts];

        const forward = new THREE.Vector3(0,0,1);

        /*
        const t = this.track.curveC.getTangent(0.1);
        t.y = 0;
        t.normalize();
        const bn = new THREE.Vector3(0,1,0).cross(t);
        */

        //const t = new THREE.Vector3().subVectors(this.track.trackPoints[this.track.startPts + 1].pos, this.track.trackPoints[this.track.startPts].pos).normalize();
        //
        //const q = new THREE.Quaternion().setFromUnitVectors(forward, t);


        const q = new THREE.Quaternion().setFromEuler(new THREE.Euler(0, 3.14 / 2, 0, "XYZ"));
        const carQuat =startPt.rot.clone().multiply(q);

        const t = new THREE.Vector3(0,0,1).applyQuaternion(carQuat);
        const bn = new THREE.Vector3(0,1,0).cross(t);


        const positions = carPositions[nCars-1];

        for(let n=0;n<nCars;n++){

            const ptX = new THREE.Vector3(bn.x, 0, bn.z).multiplyScalar(positions[n].x);
            const ptY = new THREE.Vector3(-t.x, 0, -t.z).multiplyScalar(positions[n].z);

            const pt = new THREE.Vector3().addVectors(ptX, ptY).add(startPt.pos);

            //pt.set(this.track.springs[0].anchor.pos.x, this.track.springs[0].anchor.pos.y, this.track.springs[0].anchor.pos.z);

            this.cars[n].pos.set(pt.x, pt.y + 1.6, pt.z);
            this.cars[n].quat.set(carQuat.x, carQuat.y, carQuat.z, carQuat.w);

            this.cars[n].center.set(this.cars[n].pos.x, this.cars[n].pos.y, this.cars[n].pos.z);


            this.cars[n].ChassisMesh.position.set(this.cars[n].pos.x, this.cars[n].pos.y, this.cars[n].pos.z);
            this.cars[n].ChassisMesh.quaternion.set(this.cars[n].quat.x, this.cars[n].quat.y, this.cars[n].quat.z, this.cars[n].quat.w);

            this.cars[n].updateWheels();

            for(let w=0;w<this.cars[n].wheels.length;w++){

                this.cars[n].wheels[w].mesh.position.set(this.cars[n].wheels[w].pos.x, this.cars[n].wheels[w].pos.y, this.cars[n].wheels[w].pos.z)
                this.cars[n].wheels[w].mesh.quaternion.set(this.cars[n].wheels[w].quat.x, this.cars[n].wheels[w].quat.y, this.cars[n].wheels[w].quat.z, this.cars[n].wheels[w].quat.w)

            }
        }
      }

      initCarData(car, buffer, ibuff, curOfs, flags){
        //this.lastCarData.cars[n]

        const my_car = {   
            nshots : 0,
            wheels: [], 
            contacts: new Array(100), 
            contactsDMG: new Float32Array(100), 
            ncontacts : 0,
            curLapTime : 0,
            shots : [] 
        }

        for(let c=0;c<100;c++){
            my_car.contacts[c] = new THREE.Vector3();
            my_car.contactsDMG[c] = 0;
        }

        my_car.id = ibuff[curOfs];
        car.servId = my_car.id;
        my_car.lerper = new TransformationLerp(1, buffer, curOfs, this.lastCarData.serverTime);
        curOfs+=8;
        my_car.curLapTime= buffer[curOfs++];
        //my_car.remainingTime = 
        my_car.speed = buffer[curOfs++];
        my_car.RPM = buffer[curOfs++];

        const dmg = ibuff[curOfs++];

        my_car.damage = dmg >> 16;
        my_car.power = dmg & 0xFFFF;
        my_car.curSeg = buffer[curOfs++];
        my_car.nLaps = buffer[curOfs++];
        my_car.triggerIDX = ibuff[curOfs++] - 1;
        my_car.blueprints = ibuff[curOfs++];
        my_car.targetNode = buffer[curOfs++];
        
        const i = parseInt( buffer[curOfs++]);
        my_car.targetID = i & 0x7F;
        my_car.targetSID = (i>>7) & 0x7F;

        if(car.weapon){
            const i = parseInt( buffer[curOfs++]);
            my_car.weapon = {headAngle : ((i>>14) & 0x1FF), cannonAngle : ((i>>23) & 0x1FF)};
        }
        
        my_car.newAttachedObjects = buffer[curOfs++];
        my_car.nitros = buffer[curOfs++];
        my_car.nextNitro = buffer[curOfs++];
        my_car.multiplier = buffer[curOfs++];

        my_car.nbonuses = buffer[curOfs++];
        my_car.ntechs = buffer[curOfs++];
        my_car.ncontacts = buffer[curOfs++];
        curOfs += my_car.ncontacts * 4;

        if(flags & 4) {
            my_car.nshots = buffer[curOfs++];
            my_car.shotLerper  = new ShotLerp(1000, buffer, curOfs, my_car.nshots, this.lastCarData.serverTime);
            curOfs += my_car.nshots * 4;
        }

        my_car.newbonus = new Array(16);
        my_car.nnewBonuses = buffer[curOfs++];
        curOfs += my_car.nnewBonuses;

        my_car.newbonus = new Array(16);
        my_car.nnewTech = buffer[curOfs++];
        curOfs += my_car.nnewTech;

        my_car.newtech = new Array(16);

        my_car.wheelsLerper = new TransformationLerpRaw(4, buffer, curOfs, this.lastCarData.serverTime, 8);
        for (let i = 0; i < 4; i++) {
            my_car.wheels[i] = {  skidding: buffer[curOfs+7], inContact: false, contactPoint: new THREE.Vector3(), lastSkid : 0 };
            curOfs += 12;
        }

        return {car: my_car, newOfs: curOfs}
      }

    initData(buffer, ibuff, myTime) {
        let curOfs = 0;
        if (this.lastCarData !== null)
            return;

        const flags = buffer[curOfs++];
        const dataTime = buffer[curOfs++];

        this.lastCarData = { time : myTime, serverTime : dataTime, serverFrame:0, serverDelta : dataTime - myTime, flags:flags, nBlastImpacts:0, triggerEvents:[], blastImpacts : [], blastImpacts : [], cars: [], woods: [], bonuses: [], segs: [], turrets: [], springs: [], ropes: [], ips: [], drones: [], movingObjects: [], cubes : [], cyls : [], characters: [], npcs : [], spiders : [], splits : [] , xmeshes : []};

        this.lastCarData.nBlastImpacts = buffer[curOfs++];
        for(let n=0;n<16;n++){
            if(n<this.lastCarData.nBlastImpacts){
                curOfs += 4;
                this.lastCarData.blastImpacts[n] = {type : buffer[curOfs], pos :{x: buffer[curOfs+1], y: buffer[curOfs+2], z: buffer[curOfs+3]}};
            }
            else
                this.lastCarData.blastImpacts[n] = {type : 0, pos :{x: 0, y: 0, z: 0}};
        }


        this.lastCarData.nTriggerEvents = buffer[curOfs++];
        for(let n=0;n<16;n++){
            if(n<this.lastCarData.nTriggerEvents){
                const e = ibuff[curOfs++];
                this.lastCarData.triggerEvents[n] = {triggerIDX : e&0xFFFF, state: (e>>16)};
            }
            else
                this.lastCarData.triggerEvents[n] = {triggerIDX : -1, state: -1};
        }

        const ncars = buffer[curOfs++];
        for (let n = 0; n < ncars; n++) {

            const {car, newOfs} = this.initCarData(this.cars[n], buffer, ibuff, curOfs, flags);
            this.lastCarData.cars[n] = car;
            curOfs = newOfs;

            /*
            this.lastCarData.cars[n] = {   
                nshots : 0,
                wheels: [], 
                contacts: new Array(100), 
                contactsDMG: new Float32Array(100), 
                ncontacts : 0,
                shots : [] 
            }

            for(let c=0;c<100;c++){
                this.lastCarData.cars[n].contacts[c] = new THREE.Vector3();
                this.lastCarData.cars[n].contactsDMG[c] = 0;
            }

            this.lastCarData.cars[n].id = ibuff[curOfs];
            this.cars[n].servId = this.lastCarData.cars[n].id;
            this.lastCarData.cars[n].lerper = new TransformationLerp(1, buffer, curOfs, this.lastCarData.serverTime);
            curOfs+=8;
            this.lastCarData.cars[n].remainingTime = buffer[curOfs++];
            this.lastCarData.cars[n].speed = buffer[curOfs++];
            this.lastCarData.cars[n].RPM = buffer[curOfs++];

            const dmg = ibuff[curOfs++];

            this.lastCarData.cars[n].damage = dmg >> 16;
            this.lastCarData.cars[n].power = dmg & 0xFFFF;
            this.lastCarData.cars[n].curSeg = buffer[curOfs++];
            this.lastCarData.cars[n].nLaps = buffer[curOfs++];
            this.lastCarData.cars[n].triggerIDX = ibuff[curOfs++] - 1;
            this.lastCarData.cars[n].blueprints = ibuff[curOfs++];
            this.lastCarData.cars[n].targetNode = buffer[curOfs++];

            if(this.cars[n].weapon){
                const i = parseInt( buffer[curOfs++]);
                this.lastCarData.cars[n].targetID = i & 0x7F;
                this.lastCarData.cars[n].targetSID = (i>>7) & 0x7F;
                this.lastCarData.cars[n].weapon = {headAngle : ((i>>14) & 0x1FF), cannonAngle : ((i>>23) & 0x1FF)};
            }
            
            this.lastCarData.cars[n].newAttachedObjects = buffer[curOfs++];
            this.lastCarData.cars[n].nitros = buffer[curOfs++];
            this.lastCarData.cars[n].nextNitro = buffer[curOfs++];
            this.lastCarData.cars[n].multiplier = buffer[curOfs++];

            this.lastCarData.cars[n].nbonuses = buffer[curOfs++];
            this.lastCarData.cars[n].ntechs = buffer[curOfs++];
            this.lastCarData.cars[n].ncontacts = buffer[curOfs++];
            curOfs += this.lastCarData.cars[n].ncontacts * 4;

            if(flags & 4) {
                this.lastCarData.cars[n].nshots = buffer[curOfs++];
                this.lastCarData.cars[n].shotLerper  = new ShotLerp(1000, buffer, curOfs, this.lastCarData.cars[n].nshots, this.lastCarData.serverTime);
                curOfs += this.lastCarData.cars[n].nshots * 4;
            }

            this.lastCarData.cars[n].newbonus = new Array(16);
            this.lastCarData.cars[n].nnewBonuses = buffer[curOfs++];
            curOfs += this.lastCarData.cars[n].nnewBonuses;

            this.lastCarData.cars[n].newbonus = new Array(16);
            this.lastCarData.cars[n].nnewTech = buffer[curOfs++];
            curOfs += this.lastCarData.cars[n].nnewTech;

            this.lastCarData.cars[n].newtech = new Array(16);

            this.lastCarData.cars[n].wheelsLerper = new TransformationLerpRaw(4, buffer, curOfs, this.lastCarData.serverTime, 8);
            for (let i = 0; i < 4; i++) {
                this.lastCarData.cars[n].wheels[i] = {  skidding: buffer[curOfs+7], lastSkid : 0 };
                curOfs += 8;
            }
            */
        }

        const nnpcs = buffer[curOfs++];

        this.lastCarData.numNPCs = nnpcs;

        for (let nn = 0; nn < nnpcs; nn++) {
            /*
            this.lastCarData.npcs[n] = { id: 'npc-'+n, pos: { x: 0.0, y: 0.0, z: 0.0 }, quat: { x: 0.0, y: 0.0, z: 0.0, w: 1.0 } }
            this.dataDelta.npcs[n] = { pos: { x: 0.0, y: 0.0, z: 0.0 }, quat: { x: 0.0, y: 0.0, z: 0.0, w: 1.0 } };
            */
             this.lastCarData.npcs[nn] = { id: 'npc-'+nn , active : true}
             this.lastCarData.npcs[nn].lerper= new TransformationLerp(1, buffer, curOfs, this.lastCarData.serverTime);
             curOfs += 8;

            if(this.track.npcs[nn].avatarDef.ragdoll){

                //this.lastCarData.npcs[n].skeleton = this.track.getRagdollBoneSave(this.track.npcs[n].skeleton.root);
                const nbones = parseInt(buffer[curOfs++]);
                curOfs+=2;
                if(flags&1){
                    this.lastCarData.npcs[nn].ragdollLerper = new BoneLerp(nbones, buffer, curOfs, this.lastCarData.serverTime);

                    if(buffer[curOfs + 5] == 0 )
                        curOfs += nbones * 9;
                    else
                        curOfs += nbones * 6;
                }

            }else{
                const nanims = buffer[curOfs++];
                this.lastCarData.npcs[nn].anims = new Array(8);
                for(let a = 0;a<nanims;a++){
                    const aa = buffer[curOfs+0];
                    const t = buffer[curOfs+1];
                    this.lastCarData.npcs[nn].anims[a] ={a : aa, t: t };
                    curOfs+=2;
                }
                curOfs+=2;
            }
        }

        const nchars = buffer[curOfs++];
        for (let n = 0; n < nchars; n++) {
            this.lastCarData.characters[n] = { id: parseInt(buffer[curOfs + 0]) , servId : parseInt(buffer[curOfs + 0])};
            this.lastCarData.characters[n].pos = { x: buffer[curOfs+1], y: buffer[curOfs+2], z: buffer[curOfs+3] };
            this.lastCarData.characters[n].quat =  { x: buffer[curOfs+4], y: buffer[curOfs+5], z: buffer[curOfs+6], w: buffer[curOfs+7] };
            this.lastCarData.characters[n].anims = {a:buffer[curOfs+8], t:buffer[curOfs+9]};
            curOfs += 10;
        }

        const nwoods = buffer[curOfs++];
        this.lastCarData.woods = {lerper: new TransformationLerp(nwoods, buffer, curOfs, this.lastCarData.serverTime)};
        curOfs += nwoods * 8;

        const nips = buffer[curOfs++];
        this.lastCarData.ips = {lerper : new TransformationLerp(nips, buffer, curOfs, this.lastCarData.serverTime) };
        curOfs += nips * 8;

        const nbonuses = buffer[curOfs++];
        for (let n = 0; n < nbonuses; n++) {
            this.lastCarData.bonuses[n] = { 
                taken:  buffer[curOfs+0],
                scale: {x:buffer[curOfs+1], y:buffer[curOfs+1], z:buffer[curOfs+1]} 
            };
            curOfs += 2;
        }

        for (let n = 0; n < this.track.loopings.length * 7; n++) {
            this.lastCarData.bonuses.push({ taken: false, scale: {x:1.0, y:1.0, z:1.0} });
        }

        const nturrets = buffer[curOfs++];
        for (let n = 0; n < nturrets; n++) {
            this.lastCarData.turrets[n] = { lerper: new TransformationLerpRaw(1, buffer, curOfs, this.lastCarData.serverTime, 8), nshots : 0};
            this.lastCarData.turrets[n].life = buffer[curOfs + 7];
            curOfs+=8;

            if(flags & 4) {
                this.lastCarData.turrets[n].nshots = buffer[curOfs++];
                this.lastCarData.turrets[n].shotLerper  = new ShotLerp(1000, buffer, curOfs, this.lastCarData.turrets[n].nshots, this.lastCarData.serverTime);
                curOfs += this.lastCarData.turrets[n].nshots * 4;
            }
        }

        const ndrones = buffer[curOfs++];
        for (let n = 0; n < ndrones; n++) {
            const id = parseInt(buffer[curOfs]);
            this.lastCarData.drones[n] = {idx : id & 0xFF, id : id >>8 , pales : []};
            this.lastCarData.drones[n].lerper = new TransformationLerp(1, buffer, curOfs, this.lastCarData.serverTime);
            curOfs += 8;

            for(let p=0;p<this.track.drones[n].pales.length;p++){
                this.lastCarData.drones[n].pales[p] = { life : buffer[curOfs + p * 8 + 7] };
            }
            
            this.lastCarData.drones[n].palesLerper =  new TransformationLerpRaw(this.lastCarData.drones[n].pales.length, buffer, curOfs, 8, this.lastCarData.serverTime);
            curOfs += this.track.drones[n].pales.length * 8;

            if(flags & 4){
                const nshots = buffer[curOfs++];
                this.lastCarData.drones[n].shotLerper =  new ShotLerp(1000, buffer, curOfs, nshots, this.lastCarData.serverTime);
                curOfs += nshots * 4;
            }
        }

        const nsprings = buffer[curOfs++];
        this.lastCarData.springs = {lerper : new TransformationLerp(nsprings, buffer, curOfs, this.lastCarData.serverTime)};
        curOfs += nsprings * 8;

        const nropes = buffer[curOfs++];
        this.lastCarData.ropes = {lerper : new TransformationLerp(nropes, buffer, curOfs, this.lastCarData.serverTime)};
        curOfs += nropes * 8;        

        const nspiders = buffer[curOfs++];
        for (let ns = 0; ns < nspiders; ns++) {
            const val = buffer[curOfs++];
            const n = val & 0xFF;
            if(flags&1){
                this.lastCarData.spiders[n] = {lerper: new TransformationLerp(this.track.spiders[n].nBones, buffer, curOfs, this.lastCarData.serverTime)};
                curOfs += this.track.spiders[n].nBones * 8;
            }

            this.lastCarData.spiders[n].sndBits = parseInt(buffer[curOfs++]);

            if(flags & 4){
                const nshots =  buffer[curOfs++];
                this.lastCarData.spiders[n].shotLerper  = new ShotLerp(100, buffer, curOfs, nshots, this.lastCarData.serverTime);
                curOfs += nshots * 4;
            }
        }

        const nSegs = buffer[curOfs++];
        for (let n = 0; n < nSegs; n++) {
            this.lastCarData.segs[n] = { center: { x: buffer[curOfs+0], y: buffer[curOfs+1], z: buffer[curOfs+2] }, 
                                         halfSize: { x: buffer[curOfs+3], y: buffer[curOfs+4], z: buffer[curOfs+5] } };
            curOfs += 6;
        }

        const nMO = buffer[curOfs++];
        for (let n = 0; n < nMO; n++) {
            this.lastCarData.movingObjects[n] = { quat : new THREE.Quaternion(buffer[curOfs+0], buffer[curOfs+1], buffer[curOfs+2], buffer[curOfs+3])};
            curOfs += 4;
        }
        const ncyls = buffer[curOfs++];
        this.lastCarData.cyls = {lerper: new TransformationLerp(ncyls, buffer, curOfs, this.lastCarData.serverTime)};
        curOfs += 8 * ncyls;

        const ncubes = buffer[curOfs++];
        this.lastCarData.cubes = {lerper: new TransformationLerp(ncubes, buffer, curOfs, this.lastCarData.serverTime)};
        curOfs += 8 * ncubes;

        const nsplits = buffer[curOfs++];
        for(let n=0;n<nsplits;n++){
            this.lastCarData.splits[n * 5 + 0]=buffer[curOfs++];
            this.lastCarData.splits[n * 5 + 1]=buffer[curOfs++];
            this.lastCarData.splits[n * 5 + 2]=buffer[curOfs++];
            this.lastCarData.splits[n * 5 + 3]=buffer[curOfs++];
            this.lastCarData.splits[n * 5 + 4]=buffer[curOfs++];
        }
 
        const nxmeshes = buffer[curOfs++];
        for(let n=0;n<nxmeshes;n++){
            this.lastCarData.xmeshes[n] = {idx : n};
            this.lastCarData.xmeshes[n].lerper = new TransformationLerp(1, buffer, curOfs, this.lastCarData.serverTime);
            curOfs += 8;
        }


    }   


    setBoneData(bone, array, offset){

        bone.pos.x = array[offset + 0];
        bone.pos.y = array[offset + 1];
        bone.pos.z = array[offset + 2];
    
        bone.rot.x = array[offset + 3];
        bone.rot.y = array[offset + 4];
        bone.rot.z = array[offset + 5];
        bone.rot.w = array[offset + 6];
        offset+=7;
    
        for(let child of bone.children){
          offset = this.setBoneData(child, array, offset);
        }

        return offset;
    
      }
      setRagdollBoneData(bone, array, offset){

        bone.rot.x = array[offset + 0];
        bone.rot.y = array[offset + 1];
        bone.rot.z = array[offset + 2];
        bone.rot.w = array[offset + 3];
        offset+=4;
    
        for(let child of bone.children){
          offset = this.setRagdollBoneData(child, array, offset);
        }

        return offset;
    
      }

    bin2cars(buffer, intBuffer, now) {

        let curOfs = 0;


        const flags = buffer[curOfs++];
        this.lastCarData.flags = flags;
        
        this.lastCarData.deltatime = now - this.lastCarData.time;
        this.lastCarData.time = now;
        
        const newServTime = buffer[curOfs++]
        this.lastCarData.serverFrame = newServTime - this.lastCarData.serverTime;
        this.lastCarData.serverTime = newServTime;
        
        
        
        this.lastCarData.nBlastImpacts = buffer[curOfs++];
        for(let n=0;n<this.lastCarData.nBlastImpacts;n++){
            this.lastCarData.blastImpacts[n].type = buffer[curOfs++];
            this.lastCarData.blastImpacts[n].pos.x = buffer[curOfs++];
            this.lastCarData.blastImpacts[n].pos.y = buffer[curOfs++];
            this.lastCarData.blastImpacts[n].pos.z = buffer[curOfs++];
        }

        this.lastCarData.nTriggerEvents = buffer[curOfs++];
        for(let n=0;n<this.lastCarData.nTriggerEvents;n++){
            const e = intBuffer[curOfs++];
            this.lastCarData.triggerEvents[n].triggerIDX = e & 0xFFFF;
            this.lastCarData.triggerEvents[n].state = e >> 16;
        }

        const ncars = buffer[curOfs++];
        if (ncars < this.lastCarData.cars.length) {
            if (this.lastCarData.cars[0].id == buffer[curOfs]) {
                this.lastCarData.cars.shift();
            }
            else {
                this.lastCarData.cars.pop();
            }
        }



      
        for (let n = 0; n < ncars; n++) {

            if(this.lastCarData.cars.length<=n){
                const {car, newOfs} = this.initCarData(this.cars[n], buffer,  intBuffer, curOfs, flags);
                this.lastCarData.cars[n] = car;
                curOfs = newOfs;
                continue;
            }

            this.lastCarData.cars[n].id = intBuffer[curOfs];
            
            curOfs = this.lastCarData.cars[n].lerper.computeDelta(buffer, curOfs, 1, this.lastCarData.serverTime, 1);

            this.lastCarData.cars[n].curLapTime = buffer[curOfs++];
            this.lastCarData.cars[n].speed = buffer[curOfs++];
            this.lastCarData.cars[n].RPM = buffer[curOfs++];

            const dmgs = intBuffer[curOfs++];

            this.lastCarData.cars[n].damage = dmgs >> 16;
            this.lastCarData.cars[n].power = dmgs & 0xFFFF;

            this.lastCarData.cars[n].curSeg = buffer[curOfs++];
            this.lastCarData.cars[n].nLaps = buffer[curOfs++];

            this.lastCarData.cars[n].triggerIDX = intBuffer[curOfs++] - 1;
            this.lastCarData.cars[n].blueprints = intBuffer[curOfs++];
            this.lastCarData.cars[n].targetNode = buffer[curOfs++];
            
            const i = intBuffer[curOfs++];
            this.lastCarData.cars[n].targetID = i & 0x7F;
            this.lastCarData.cars[n].targetSID = (i>>7) & 0x7F;

            if(this.cars[n].weapon){
                const i = intBuffer[curOfs++];
                this.lastCarData.cars[n].weapon.headAngle = (((i>>14) & 0x1FF) * Math.PI * 2) / 512;
                this.lastCarData.cars[n].weapon.cannonAngle = (((i>>23) & 0x1FF)* Math.PI * 2) / 512;
            }

            this.lastCarData.cars[n].newAttachedObjects = buffer[curOfs++];

            this.lastCarData.cars[n].nitros = buffer[curOfs++];
            this.lastCarData.cars[n].nextNitro = buffer[curOfs++];

            this.lastCarData.cars[n].multiplier = buffer[curOfs++];
            this.lastCarData.cars[n].nbonuses = buffer[curOfs++];
            this.lastCarData.cars[n].ntechs = buffer[curOfs++];

            this.lastCarData.cars[n].ncontacts = buffer[curOfs++];
            //curOfs += 4 * this.lastCarData.cars[n].ncontacts;

            /*
            this.lastCarData.cars[n].contacts = new Array(this.lastCarData.cars[n].ncontacts);
            this.lastCarData.cars[n].contactsDMG = new Array(this.lastCarData.cars[n].ncontacts);
            */

            for (let i = 0; i < this.lastCarData.cars[n].ncontacts; i++) {

                if(i<100){
                    this.lastCarData.cars[n].contacts[i].set(buffer[curOfs] + Math.random() * 0.1 - 0.05, buffer[curOfs + 1]+ Math.random() * 0.1 - 0.05, buffer[curOfs + 2]+ Math.random() * 0.1 - 0.05);
                    this.lastCarData.cars[n].contactsDMG[i] = buffer[curOfs + 3];
                }
                curOfs += 4;
            }

            if(flags & 4) {
                this.lastCarData.cars[n].nshots = buffer[curOfs++];
                curOfs = this.lastCarData.cars[n].shotLerper.computeDelta(buffer, curOfs,  this.lastCarData.cars[n].nshots, this.lastCarData.serverTime);
            }

            this.lastCarData.cars[n].nnewBonuses = buffer[curOfs++];
            for (let i = 0; i < this.lastCarData.cars[n].nnewBonuses; i++) {
                this.lastCarData.cars[n].newbonus[i] = buffer[curOfs++];
            }

            this.lastCarData.cars[n].nnewTech = buffer[curOfs++];
            for (let i = 0; i < this.lastCarData.cars[n].nnewTech; i++) {
                this.lastCarData.cars[n].newtech[i] = buffer[curOfs++];
            }

            this.lastCarData.cars[n].wheelsLerper.computeDelta(buffer, curOfs, 12, this.lastCarData.serverTime);

            for (let i = 0; i < 4; i++) {
                curOfs += 7;
                this.lastCarData.cars[n].wheels[i].skidding = buffer[curOfs++];
                this.lastCarData.cars[n].wheels[i].inContact = buffer[curOfs++];
                this.lastCarData.cars[n].wheels[i].contactPoint.x = buffer[curOfs++];
                this.lastCarData.cars[n].wheels[i].contactPoint.y = buffer[curOfs++];
                this.lastCarData.cars[n].wheels[i].contactPoint.z = buffer[curOfs++];
                
            }
        }

        const nnpcs = buffer[curOfs++];

        if(flags & 1){
            for(let nn=0;nn<this.lastCarData.npcs.length;nn++){
                this.lastCarData.npcs[nn].active = false;
            }
        }

        for (let nn = 0; nn < nnpcs; nn++) {

            const n =  buffer[curOfs];
            curOfs = this.lastCarData.npcs[n].lerper.computeDelta(buffer, curOfs, 1, this.lastCarData.serverTime, 1);
            this.lastCarData.npcs[n].active = true;

            if(this.track.npcs[n].avatarDef.ragdoll === true){
                const nbones = parseInt(buffer[curOfs++]);
                this.lastCarData.npcs[n].dialogLine = parseInt(buffer[curOfs++]);
                this.lastCarData.npcs[n].dialogSubLine = parseInt(buffer[curOfs++]);

                if(flags&1){
                    curOfs = this.lastCarData.npcs[n].ragdollLerper.computeDelta(buffer, curOfs, nbones, this.lastCarData.serverTime);
                }
                //curOfs = this.setRagdollBoneData(this.lastCarData.npcs[n].skeleton, buffer, curOfs);
            }else{
                const nanims = buffer[curOfs++];
                //this.lastCarData.npcs[n].anims = new Array(nanims);
            
                
                for(let a = 0;a<nanims;a++){
                    const aa = buffer[curOfs++];
                    const t = buffer[curOfs++];
                    this.lastCarData.npcs[n].anims[a] ={a : aa, t: t};
                }
                
                for(let a = nanims;a<8;a++){
                    this.lastCarData.npcs[n].anims[a] = null;
                }
                this.lastCarData.npcs[n].dialogLine = parseInt(buffer[curOfs++]);
                this.lastCarData.npcs[n].dialogSubLine = parseInt(buffer[curOfs++]);
            }
        }

        for (let n = 0; n < this.lastCarData.characters.length; n++) {
            this.lastCarData.characters[n].active = false;
        }

        const ncharacters = buffer[curOfs++];

        for (let n = 0; n < ncharacters; n++) {

            const netID = parseInt(buffer[curOfs++]);

            let mychar = null;

            for (let c = 0; c < this.lastCarData.characters.length; c++) {

                if(this.lastCarData.characters[c].netID == netID){
                    mychar = this.lastCarData.characters[c];
                    mychar.active = true;                    
                    break;
                }
            }

            if(mychar === null){
                mychar = {netID : netID, pos : {x:0.0, y:0.0, z:0.0}, quat : {x:0.0, y:0.0, z:0.0, w:1.0}, active : true};
                this.lastCarData.characters.push(mychar);
            }

            mychar.pos.x = buffer[curOfs++];
            mychar.pos.y = buffer[curOfs++];
            mychar.pos.z = buffer[curOfs++];
            mychar.quat.x = buffer[curOfs++];
            mychar.quat.y = buffer[curOfs++];
            mychar.quat.z = buffer[curOfs++];
            mychar.quat.w = buffer[curOfs++];

            mychar.animId = buffer[curOfs++];
            mychar.animTime = buffer[curOfs++];
        }

        const nwoods = buffer[curOfs++];
        curOfs = this.lastCarData.woods.lerper.computeDelta(buffer, curOfs, nwoods, this.lastCarData.serverTime);
     
        const nips = buffer[curOfs++];
        curOfs = this.lastCarData.ips.lerper.computeDelta(buffer, curOfs, nips, this.lastCarData.serverTime);

        const nbonuses = buffer[curOfs++];
        for (let n = 0; n < nbonuses; n++) {
            this.lastCarData.bonuses[n].taken = buffer[curOfs++];
            this.lastCarData.bonuses[n].size = buffer[curOfs++];
        }

        const nTurrets = buffer[curOfs++];

        for (let n = 0; n < nTurrets; n++) {

            //this.lastCarData.turrets[n].headAngle = buffer[curOfs++];
            this.lastCarData.turrets[n].life=buffer[curOfs + 7];

            curOfs = this.lastCarData.turrets[n].lerper.computeDelta(buffer, curOfs, 8, this.lastCarData.serverTime);
           
            if(flags & 4) {
                this.lastCarData.turrets[n].nshots = buffer[curOfs++];
                curOfs = this.lastCarData.turrets[n].shotLerper.computeDelta(buffer, curOfs,  this.lastCarData.turrets[n].nshots, this.lastCarData.serverTime);
            }
        }

        const ndrones = buffer[curOfs++];
        for(let nd=0;nd<ndrones;nd++){
            const n = parseInt(buffer[curOfs]) & 0xFF;
            const id = parseInt(buffer[curOfs]) >> 8; 

            curOfs = this.lastCarData.drones[n].lerper.computeDelta(buffer, curOfs, 1, this.lastCarData.serverTime, 1);

            for(let p =0;p<this.lastCarData.drones[n].pales.length;p++){
                this.lastCarData.drones[n].pales[p].life = buffer[curOfs + p * 8 + 7];
            }

            curOfs = this.lastCarData.drones[n].palesLerper.computeDelta(buffer, curOfs, 8, this.lastCarData.serverTime);

            if(flags & 4) {
                this.lastCarData.drones[n].nshots = buffer[curOfs++];
                curOfs = this.lastCarData.drones[n].shotLerper.computeDelta(buffer, curOfs,  this.lastCarData.drones[n].nshots, this.lastCarData.serverTime);
            }
        }

        const nsprings = buffer[curOfs++];
        curOfs = this.lastCarData.springs.lerper.computeDelta(buffer, curOfs, nsprings, this.lastCarData.serverTime);

        const nropes = buffer[curOfs++];
        curOfs = this.lastCarData.ropes.lerper.computeDelta(buffer, curOfs, nropes, this.lastCarData.serverTime);

        const nspiders = buffer[curOfs++];
        for (let ns = 0; ns < nspiders; ns++) {
            const val = parseInt(buffer[curOfs++]);
            const n =  val & 0xFF;
            const nbones =  val >> 8;
            if(flags & 1)
                curOfs = this.lastCarData.spiders[n].lerper.computeDelta(buffer, curOfs, nbones, this.lastCarData.serverTime);

            this.lastCarData.spiders[n].sndBits = parseInt(buffer[curOfs++]);

            if(flags & 4) {
                this.lastCarData.spiders[n].nshots = buffer[curOfs++];
                curOfs = this.lastCarData.spiders[n].shotLerper.computeDelta(buffer, curOfs,  this.lastCarData.spiders[n].nshots, this.lastCarData.serverTime);
            }
        }

        const nSegs = buffer[curOfs++];
        for (let n = 0; n < nSegs; n++) {
            this.lastCarData.segs[n].center.x = buffer[curOfs++];
            this.lastCarData.segs[n].center.y = buffer[curOfs++];
            this.lastCarData.segs[n].center.z = buffer[curOfs++];

            this.lastCarData.segs[n].halfSize.x = buffer[curOfs++];
            this.lastCarData.segs[n].halfSize.y = buffer[curOfs++];
            this.lastCarData.segs[n].halfSize.z = buffer[curOfs++];
        }

        const nMO = buffer[curOfs++];
        for (let n = 0; n < nMO; n++) {

            this.lastCarData.movingObjects[n].quat.x = buffer[curOfs++];
            this.lastCarData.movingObjects[n].quat.y = buffer[curOfs++];
            this.lastCarData.movingObjects[n].quat.z = buffer[curOfs++];
            this.lastCarData.movingObjects[n].quat.w = buffer[curOfs++];
        }


        if(flags & 2){
            const ncyls = buffer[curOfs++];
            curOfs = this.lastCarData.cyls.lerper.computeDelta(buffer, curOfs, ncyls, this.lastCarData.serverTime);

            const nucbes = buffer[curOfs++];
            curOfs = this.lastCarData.cubes.lerper.computeDelta(buffer, curOfs, nucbes, this.lastCarData.serverTime);

            
            const nsplits = buffer[curOfs++];
            //this.lastCarData.splits = new Array(nsplits * 5);

            if(nsplits>0)
                console.log('split '+nsplits);

            for(let s =0;s<nsplits;s++){
                const id =buffer[curOfs++];
                const a =buffer[curOfs++];
                const b =buffer[curOfs++];                    
                const c =buffer[curOfs++];
                const d =buffer[curOfs++];

                this.track.splits.push({id:id, a:a, b:b, c:c, d:d});
            }

            const nxmeshes = buffer[curOfs++];
            for(let n =0;n<nxmeshes;n++){

                if(this.lastCarData.xmeshes[n]){
                    this.lastCarData.xmeshes[n].idx = buffer[curOfs];
                    curOfs = this.lastCarData.xmeshes[n].lerper.computeDelta(buffer, curOfs, 1, this.lastCarData.serverTime, 1);
                }
                else{
                    this.lastCarData.xmeshes[n] = {idx : buffer[curOfs]};
                    this.lastCarData.xmeshes[n].lerper = new TransformationLerp(1, buffer, curOfs, this.lastCarData.serverTime);
                    curOfs += 8;
                }
            }

        }
        
    }

    
      /*

    async setHM(name, rgba, scale, pos) {
        if ((this.track.HM !== null) && (this.track.HM.mesh !== null)) {
            this.engine.scene.remove(this.track.HM.mesh);
            this.track.HM.geom.dispose();
            this.track.HM.mesh = null;
        }
        this.track.HM = { file: name, data: rgba, scale: scale, pos: pos, mesh: null, geom: null };

        this.createGeometryFromMap();

        this.engine.scene.add(this.track.HM.mesh);


    }

    getHighPoint(geometry, face) {

        var v1 = geometry.vertices[face.a].y;
        var v2 = geometry.vertices[face.b].y;
        var v3 = geometry.vertices[face.c].y;

        return Math.max(v1, v2, v3);
    }


    createGeometryFromMap() {

        if (this.track.HM === null)
            return;

        var depth = 512;
        var width = 512;

        var spacingX = this.track.HM.scale.x;
        var spacingZ = this.track.HM.scale.z;


        var geom = new THREE.BufferGeometry();
        var vertices = [];
        var faces = [];
        var output = [];
        for (var x = 0; x < depth; x++) {
            for (var z = 0; z < width; z++) {
                // get pixel
                // since we're grayscale, we only need one element



                var yValue = this.track.HM.data[z * 4 + (depth * x * 4)] * this.track.HM.scale.y;
                var vertex = new THREE.Vector3(x * spacingX + this.track.HM.pos.x, yValue + this.track.HM.pos.y, z * spacingZ + this.track.HM.pos.z);

                //console.log(this.track.HM.data[z * 4 + (depth * x * 4)]);
                //console.log(vertex);

                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }

        // we create a rectangle between four vertices, and we do
        // that as two triangles.
        for (var z = 0; z < depth - 1; z++) {
            for (var x = 0; x < width - 1; x++) {
                // we need to point to the position in the array
                // a - - b
                // |  x  |
                // c - - d
                var a = x + z * width;
                var b = (x + 1) + (z * width);
                var c = x + ((z + 1) * width);
                var d = (x + 1) + ((z + 1) * width);

                
                //var face1 = new THREE.Face3(a, b, d);
                //var face2 = new THREE.Face3(d, c, a);

                //face1.color = new THREE.Color(scale(this.getHighPoint(geom, face1)).hex());
                //face2.color = new THREE.Color(scale(this.getHighPoint(geom, face2)).hex())
                

                faces.push(a, b, d);
                faces.push(d, c, a);
            }
        }

        geom.setIndex(faces);
        geom.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));

        geom.computeVertexNormals(true);
        //geom.computeFaceNormals();
        geom.computeBoundingBox();

        var zMax = geom.boundingBox.max.z;
        var xMax = geom.boundingBox.max.x;

        const material = new THREE.MeshPhongMaterial({ color: 0x00ff00 });

        material.side = THREE.DoubleSide;

        var mesh = new THREE.Mesh(geom, material);
        mesh.translateX(-xMax / 2);
        mesh.translateZ(-zMax / 2);
        mesh.name = 'ground';

        this.track.HM.mesh = mesh;
        this.track.HM.geom = geom;
    }
    */


    allCarsLoaded() {

        if ((this.cars.length == 0) && (this.myCar != null) && (this.myCar.ChassisMesh !== null))
            return true;

        for (let car of this.cars) {
            if (!car.ChassisMesh)
                return false;
        }

        return true;
    }

  


    async loadTrack(name, site = '') {

        const response = await fetch(site + '/api/getTrack?trackName=' + name, {credentials:'include'});
        const data = await response.json();

        

        this.track = new Track(data.nPts, site);

        try{
            const res = await fetch(site + '/api/getAI?trackName=' + name, {credentials:'include'});
            this.track.AITable =  await res.json();

            this.track.AITable.sort(function(a,b){
                if(a.dist < b.dist)
                    return 1;

                if(a.dist > b.dist)
                    return -1;
                return 0;

            })      
            
            for(let rec of  this.track.AITable){
                rec.speed =  Math.abs(rec.speed) * 0.9;
            }

            /*
            for(let rec of  this.track.AITable){
                rec.speed =  Math.abs(rec.speed) * 1.3;
            }
            */
            console.log(JSON.stringify(this.track.AITable));
        }
        catch(e){
            this.track.AITable = null;
        }

        this.track.name = name;
        this.track.gscale = data.gscale ? data.gscale : 1.0;
        this.track.trackHeight = data.trackHeight ? data.trackHeight : 1.0;

        this.track.meshInstances = [];

        if(data.meshInstances){
            for(let n of data.meshInstances){
                this.track.meshInstances.push({key : n , name : n, nInstances : 0, nFilled : 0});
            }
        }

        for (let n = 0; n < data.pts.length; n++) {
            this.track.trackPoints.push({ pos: new THREE.Vector3(data.pts[n].pos.x, data.pts[n].pos.y, data.pts[n].pos.z ), width: parseFloat(data.pts[n].width), noWalls : data.pts[n].noWalls ? true: false  });
        }
        /*
        for (let n = 0; n < this.track.trackPoints.length; n++) {
            this.track.trackPoints[n].pos.z -= 40.0;
        }
        */
        this.track.woodDefs = [];
        this.track.bonusDefs = [];
        this.track.jumpersDefs = [];
        this.track.turretsDefs = [];
        this.track.springDefs = [];
        this.track.ropeDefs = [];
        this.track.spiderDefs = [];
        this.track.interestPointsDefs = [];
        this.track.droneDefs = [];
        this.track.charDefs = [];
        this.track.levelMovingObjects = [];
        this.track.gridDefs = [];
        this.track.navmeshs = [];

        this.track.bloom = data.bloom ?  data.bloom : {"strength" : 0.8,  "radius" : 0.2, "thresold" : 0.75};

        this.track.startPts = data.startPts ? data.startPts : 0;
        this.track.lapTime = data.lapTime ? data.lapTime : 60;
        this.track.driftFlags = data.driftFlags ? data.driftFlags : 0;

        this.track.fogIntensity =  data.fogIntensity ? data.fogIntensity : 0.006;
   
        this.track.borderWidth = data.borderWidth!== undefined  ? data.borderWidth : 12;
        this.track.borderHeight = data.borderHeight!== undefined  ? data.borderHeight : 3;

        this.track.class = data.class !== undefined ? data.class : 0;
        this.track.difficulty = data.difficulty !== undefined ? data.difficulty : 0;

        this.track.curveType = data.curveType? data.curveType: 'centripetal';
        this.track.friction = data.friction !== undefined ? data.friction : 0.4;
        this.track.restitution = data.restitution !== undefined ? data.restitution : 0.8;

        this.track.skyBoxImg = data.skyBoxImg !== undefined ? data.skyBoxImg : 'city.jpg';
        this.track.music = data.music !== undefined ? data.music : 'music1.ogg';
        this.track.gravity = data.gravity !== undefined ? parseFloat(data.gravity) : 10;

        this.track.tubecolor = data.tubecolor ? new THREE.Color().setRGB(data.tubecolor.r, data.tubecolor.g, data.tubecolor.b) : new THREE.Color().setRGB(0,1,1);
        this.track.wallSpace = data.wallSpace ? data.wallSpace : 1.0;





        if(data.carStartPos){

            this.track.carStartPos = {
                pos: new THREE.Vector3(data.carStartPos.pos.x, data.carStartPos.pos.y, data.carStartPos.pos.z),
                rot: new THREE.Quaternion(data.carStartPos.rot.x, data.carStartPos.rot.y, data.carStartPos.rot.z, data.carStartPos.rot.w)
          };
        }

          if(data.navmeshs){
                for(let n of data.navmeshs){
                    this.track.navmeshs.push({pos : new THREE.Vector3(n.pos.x, n.pos.y, n.pos.z), type: n.type, links : n.links});
                }
        }



        if(data.movingObjects) {
            for (let n = 0; n < data.movingObjects.length; n++) {
                this.track.levelMovingObjects[n] =  data.movingObjects[n].name;
            }
          }
          
        if (data.woods) {
            for (let n = 0; n < data.woods.length; n++) {
                this.track.woodDefs.push({ ptIdx: data.woods[n].ptIdx, offset: { x: data.woods[n].offset.x, y: data.woods[n].offset.y, z: data.woods[n].offset.z }, width: data.woods[n].width, num: data.woods[n].num, radius: data.woods[n].radius, mass: data.woods[n].mass, spacing: data.woods[n].spacing });
            }
        }

        
        if(data.roadGrasses){
            
            for (let n = 0; n < data.roadGrasses.length; n++) {
                this.track.roadGrasses.push(
                    { 
                        img: data.roadGrasses[n].img, 
                        width: data.roadGrasses[n].width,
                        offset: data.roadGrasses[n].offset,
                        size: {x : data.roadGrasses[n].size.x, y : data.roadGrasses[n].size.y},
                        num: data.roadGrasses[n].num, 
                    }
                );
            }
        }

        if (data.grids) {
            for (let n = 0; n < data.grids.length; n++) {


                this.track.gridDefs.push({  ptIdx: data.grids[n].ptIdx, 
                                            offset : {x: data.grids[n].offset.x, y: data.grids[n].offset.y, z: data.grids[n].offset.z }, 
                                            angle : {x: data.grids[n].angle.x, y: data.grids[n].angle.y, z: data.grids[n].angle.z }, 
                                            cell_size : {x: data.grids[n].cell_size.x, y: data.grids[n].cell_size.y, z: data.grids[n].cell_size.z }, 
                                            width: data.grids[n].width, height : data.grids[n].height, depth : data.grids[n].depth, 
                                            isolevel: data.grids[n].isolevel, nBalls: data.grids[n].nBalls, ballRadius: data.grids[n].ballRadius, ballWeight : data.grids[n]. ballWeight});
            }
        }

        if (data.bonuses) {
            for (let n = 0; n < data.bonuses.length; n++) {
                this.track.bonusDefs.push({ ptIdx: data.bonuses[n].ptIdx, offset: { x: data.bonuses[n].offset.x, y: data.bonuses[n].offset.y, z: data.bonuses[n].offset.z }, type: data.bonuses[n].type, amount: data.bonuses[n].amount, size: data.bonuses[n].size ? data.bonuses[n].size : 1 });
            }
        }


        if (data.drones) {
            for (let n = 0; n < data.drones.length; n++) {

                const newDrone = { ptIdx: data.drones[n].ptIdx, 
                    model: data.drones[n].model, 
                    shotModel: data.drones[n].shotModel, 
                    speed: data.drones[n].speed ? data.drones[n].speed : 10.0, 
                    activation: data.drones[n].activation, 
                    deactivation: data.drones[n].deactivation, 
                    offset: { x: data.drones[n].offset.x, y: data.drones[n].offset.y, z: data.drones[n].offset.z }, 
                    caroffset: data.drones[n].caroffset ? { x: data.drones[n].caroffset.x, y: data.drones[n].caroffset.y, z: data.drones[n].caroffset.z } : { x: data.drones[n].offset.x, y: data.drones[n].offset.y, z: data.drones[n].offset.z }, 
                    angle: { x: data.drones[n].angle.x, y: data.drones[n].angle.y, z: data.drones[n].angle.z }, 
                    size: { x: data.drones[n].size.x, y: data.drones[n].size.y, z: data.drones[n].size.z }, 
                    weight : data.drones[n].weight ? data.drones[n].weight : 0, 
                    speedPale1: data.drones[n].speedPale1 ? data.drones[n].speedPale1 : 110,
                    speedPale2 : data.drones[n].speedPale2 ? data.drones[n].speedPale2 : 500,
                    upLift :  data.drones[n].upLift ? data.drones[n].upLift : 800,
                    
                    pales : []
                };

                if(data.drones[n].pales){
                    for(let p =0; p<data.drones[n].pales.length; p++){
                        newDrone.pales[p] = { life : data.drones[n].pales[p].life ? data.drones[n].pales[p].life : 30 };
                    }
                }

                if(data.drones[n].weapons){
                    newDrone.weapons = [];
                    for(let w of data.drones[n].weapons){
                        const nw = {
                            projPts: new THREE.Vector3(w.projPts.x, w.projPts.y, w.projPts.z), 
                            projSpeed: w.projSpeed, 
                            projMass: w.projMass, 
                            projModel: w.projModel ? w.projModel : null, 
                            projBlastRadius: w.projBlastRadius ? w.projBlastRadius : 0,  
                            projBlastForce: w.projBlastForce ? w.projBlastForce : 0,  
                            projBlastImpact: w.projBlastImpact ? w.projBlastImpact : 0, 
                            projLL : w.projLL ? w.projLL: 3, 
                            projSize: w.projSize, 
                            projPart: w.projPart ? w.projPart : null, 
                            projHoming: w.projHoming > 0 ? w.projHoming: 0.0, 
                            projDelay: w.projDelay ? w.projDelay : 300, 
                            projTTL: w.projTTL ? w.projTTL : 0
                        }
                        newDrone.weapons.push(nw);
                    }

                    
                }else{

                    newDrone.weapons=[{
                        projPts: new THREE.Vector3(data.drones[n].projPts.x, data.drones[n].projPts.y, data.drones[n].projPts.z), 
                        projSpeed: data.drones[n].projSpeed, 
                        projMass: data.drones[n].projMass, 
                        projModel: data.drones[n].projModel ? data.drones[n].projModel : null, 
                        projBlastRadius: data.drones[n].projBlastRadius ? data.drones[n].projBlastRadius : 0,  
                        projBlastForce: data.drones[n].projBlastForce ? data.drones[n].projBlastForce : 0,  
                        projBlastImpact: data.drones[n].projBlastImpact ? data.drones[n].projBlastImpact : 0, 
                        projLL : data.drones[n].projLL ? data.drones[n].projLL: 3, 
                        projSize: data.drones[n].projSize, 
                        projHoming: data.drones[n].projHoming, 
                        projPart: data.drones[n].projPart ? data.drones[n].projPart : null, 
                        projDelay: data.drones[n].projDelay ? data.drones[n].projDelay : 300, 
                        projTTL: data.drones[n].projTTL ? data.drones[n].projTTL : 0
                    }];
                }

                this.track.droneDefs.push(newDrone);
            }
        }

        if (data.characters) {
            for (let n = 0; n < data.characters.length; n++) {
                this.track.charDefs.push(
                    {
                        ptIdx :  data.characters[n].ptIdx,
                        offset : data.characters[n].offset, 
                        angles : new THREE.Euler(data.characters[n].angle.x, data.characters[n].angle.y, data.characters[n].angle.z),
                        angle : data.characters[n].angle.y,
                        skelScale: data.characters[n].skelScale,
                        name: data.characters[n].name,
                        instancesData : data.characters[n].instancesData? data.characters[n].instancesData : [],
                        nInstances: data.characters[n].nInstances,
                        subsystemsDef : data.characters[n].subsystemsDef?data.characters[n].subsystemsDef : [] ,
                     }

                );
            }
        }
        
        if (data.jumpers) {
            for (let n = 0; n < data.jumpers.length; n++) {
                this.track.jumpersDefs.push({ ptIdx: data.jumpers[n].ptIdx, offset: { x: data.jumpers[n].offset.x, y: data.jumpers[n].offset.y, z: data.jumpers[n].offset.z }, angle: { x: data.jumpers[n].angle.x, y: data.jumpers[n].angle.y, z: data.jumpers[n].angle.z }, size: { x: data.jumpers[n].size.x, y: data.jumpers[n].size.y, z: data.jumpers[n].size.z } });
            }
        }

        if (data.loopings) {
            for (let n = 0; n < data.loopings.length; n++) {
                this.track.loopings.push({ idx: data.loopings[n].ptIdx, height: data.loopings[n].height, dir: data.loopings[n].dir, hide: data.loopings[n].hide, npts: data.loopings[n].npts });
            }
        }

        if (data.worms) {
            for (let n = 0; n < data.worms.length; n++) {
                this.track.worms.push({ idx: data.worms[n].ptIdx, height: data.worms[n].height, dir: data.worms[n].dir, npts: data.worms[n].npts });
            }
        }

        if (data.tubes) {
            for (let n = 0; n < data.tubes.length; n++) {
                this.track.tubes.push({ idx: data.tubes[n].ptIdx, height: data.tubes[n].height, width: data.tubes[n].width, dir: data.tubes[n].dir, npts: data.tubes[n].npts });
            }
        }

        if (data.waves) {
            for (let n = 0; n < data.waves.length; n++) {
                this.track.waves.push({ idx: data.waves[n].ptIdx, amplitude: data.waves[n].amplitude, frequency: data.waves[n].frequency, phase: data.waves[n].phase, npts: data.waves[n].npts });
            }
        }

        if (data.cyls) {
            for (let n = 0; n < data.cyls.length; n++) {
                this.track.cyls.push({radiusX : data.cyls[n].radiusX, radiusZ : data.cyls[n].radiusZ, height: data.cyls[n].height, pos: data.cyls[n].pos, opos : {x: data.cyls[n].pos.x, y: data.cyls[n].pos.y, z: data.cyls[n].pos.z}, orot: data.cyls[n].rot ? data.cyls[n].rot : new THREE.Quaternion(), rot: data.cyls[n].rot ? data.cyls[n].rot : new THREE.Quaternion() , mass : data.cyls[n].mass  , stiffness : data.cyls[n].stiffness, damping : data.cyls[n].damping , anchorPos : data.cyls[n].anchorPos, deltaPhys: data.cyls[n].deltaPhys ? data.cyls[n].deltaPhys : new THREE.Vector3(), heightOffset : data.cyls[n].heightOffset ? data.cyls[n].heightOffset : 0});
            }
        }

        if (data.colcyls) {
            for (let n = 0; n < data.colcyls.length; n++) {
                this.track.colcyls.push({radiusX : data.colcyls[n].radiusX, radiusZ : data.colcyls[n].radiusZ, height: data.colcyls[n].height, pos: data.colcyls[n].pos, rot: data.colcyls[n].rot ? data.colcyls[n].rot : new THREE.Quaternion(), mass :0 });
            }
        }

        if (data.colcubes) {
            for (let n = 0; n < data.colcubes.length; n++) {
                this.track.colcubes.push({id : n, name : data.colcubes[n].name, size : data.colcubes[n].size, pos : data.colcubes[n].pos, rot: data.colcubes[n].rot ? data.colcubes[n].rot : new THREE.Quaternion(), mass : 0});
            }
        }

        if (data.cubes) {
            for (let n = 0; n < data.cubes.length; n++) {
                this.track.cubes.push({id : n,  name : data.cubes[n].name, size : data.cubes[n].size, pos : data.cubes[n].pos, opos : {x: data.cubes[n].pos.x, y: data.cubes[n].pos.y, z: data.cubes[n].pos.z}, rot: data.cubes[n].rot ? data.cubes[n].rot : new THREE.Quaternion(), orot : {x:data.cubes[n].rot.x, y:data.cubes[n].rot.y, z:data.cubes[n].rot.z, w:data.cubes[n].rot.w}, mass : data.cubes[n].mass, stiffness : data.cubes[n].stiffness, damping : data.cubes[n].damping, anchorPos : data.cubes[n].anchorPos});
            }
        }


        if (data.triggers) {


            for (let n = 0; n < data.triggers.length; n++) {

                const t = { id : n, 
                            type: data.triggers[n].type, 
                            size :new THREE.Vector3(data.triggers[n].size.x, data.triggers[n].size.y, data.triggers[n].size.z), 
                            pos : new THREE.Vector3(data.triggers[n].pos.x, data.triggers[n].pos.y, data.triggers[n].pos.z),
                            rot: new THREE.Quaternion(data.triggers[n].rot.x, data.triggers[n].rot.y, data.triggers[n].rot.z, data.triggers[n].rot.w)
                          };

                
                if(data.triggers[n].action) {
                    t.action = data.triggers[n].action;
                    t.data = data.triggers[n].data;

                }

                this.track.triggers.push(t);
            }


        }

        if (data.turrets) {
            for (let n = 0; n < data.turrets.length; n++) {
                this.track.turretsDefs.push({   ptIdx: data.turrets[n].ptIdx, 
                                                model: data.turrets[n].model, 
                                                shotModel: data.turrets[n].shotModel, 
                                                activation: data.turrets[n].activation, 
                                                offset: { x: data.turrets[n].offset.x, y: data.turrets[n].offset.y, z: data.turrets[n].offset.z }, 
                                                angle: { x: data.turrets[n].angle.x, y: data.turrets[n].angle.y, z: data.turrets[n].angle.z }, 
                                                size: { x: data.turrets[n].size.x, y: data.turrets[n].size.y, z: data.turrets[n].size.z }, 
                                                projPts: { x: data.turrets[n].projPts.x, y: data.turrets[n].projPts.y, z: data.turrets[n].projPts.z }, 
                                                projSpeed: data.turrets[n].projSpeed, 
                                                projMass: data.turrets[n].projMass, 
                                                projSize: data.turrets[n].projSize, 
                                                projPart: data.turrets[n].projPart,
                                                life: data.turrets[n].life ? data.turrets[n].life : 10,
                                                projRoll: data.turrets[n].projRoll !== undefined ? data.turrets[n].projRoll: false, 
                                                projAngle: data.turrets[n].projAngle ? data.turrets[n].projAngle : 0, 
                                                projLL: data.turrets[n].projLL ? data.turrets[n].projLL : 3, 
                                                moveAngle : data.turrets[n].moveAngle !== undefined ? data.turrets[n].moveAngle : 1, 
                                                projAngle2: data.turrets[n].projAngle2 ? data.turrets[n].projAngle2 : 0, 
                                                projDelay: data.turrets[n].projDelay ? data.turrets[n].projDelay : 300, 
                                                projTTL: data.turrets[n].projTTL ? data.turrets[n].projTTL : 0 , 
                                                projSND: data.turrets[n].projSND ? data.turrets[n].projSND : 'cannon.wav' });
            }
        }

        if (data.interestPoints) {
            for (let n = 0; n < data.interestPoints.length; n++) {
                this.track.interestPointsDefs.push({    ptIdx: data.interestPoints[n].ptIdx, 
                                                        offset: { x: data.interestPoints[n].offset.x, y: data.interestPoints[n].offset.y, z: data.interestPoints[n].offset.z }, 
                                                        angle: { x: data.interestPoints[n].angle.x, y: data.interestPoints[n].angle.y, z: data.interestPoints[n].angle.z }, 
                                                        size: { x: data.interestPoints[n].size.x, y: data.interestPoints[n].size.y, z: data.interestPoints[n].size.z } ,
                                                        loffset: { x: data.interestPoints[n].loffset.x, y: data.interestPoints[n].loffset.y, z: data.interestPoints[n].loffset.z }, 
                                                        lobject: data.interestPoints[n].lobject ,
                                                        lsize: data.interestPoints[n].lsize, 
                                                        targetNode: data.interestPoints[n].targetNode, 
                                                        lweight: data.interestPoints[n].lweight ? data.interestPoints[n].lweight : 100,
                                                        nBonus: data.interestPoints[n].nBonus?data.interestPoints[n].nBonus : 5
                                                    });
            }
        }

        if (data.springs) {
            for (let n = 0; n < data.springs.length; n++) {

                this.track.springDefs.push({
                    ptIdx: data.springs[n].ptIdx,
                    offset: { x: data.springs[n].offset.x, y: data.springs[n].offset.y, z: data.springs[n].offset.z },
                    size: { x: data.springs[n].size.x , y: data.springs[n].size.y , z: data.springs[n].size.z},
                    eqA: { x: data.springs[n].eqA.x, y: data.springs[n].eqA.y, z: data.springs[n].eqA.z },
                    eqPts: { x: data.springs[n].eqPts.x, y: data.springs[n].eqPts.y, z: data.springs[n].eqPts.z },
                    initPts: { x: data.springs[n].initPts.x, y: data.springs[n].initPts.y, z: data.springs[n].initPts.z },
                    initA: { x: data.springs[n].initA.x, y: data.springs[n].initA.y, z: data.springs[n].initA.z, w: data.springs[n].initA.w },
                    limit: { x: data.springs[n].limit.x, y: data.springs[n].limit.y, z: data.springs[n].limit.z },
                    limitA: { x: data.springs[n].limitA.x, y: data.springs[n].limitA.y, z: data.springs[n].limitA.z },
                    mass: data.springs[n].mass,
                    model: data.springs[n].model ? data.springs[n].model : "",
                    shape: data.springs[n].shape ? data.springs[n].shape : 0,
                    stiffness: data.springs[n].stiffness,
                    mode: data.springs[n].mode ? data.springs[n].mode : 0,
                    damping: data.springs[n].damping
                });
            }
        }


        if (data.ropes) {
            for (let n = 0; n < data.ropes.length; n++) {

                this.track.ropeDefs.push({
                    ptIdx: data.ropes[n].ptIdx,
                    anchorObj: data.ropes[n].anchorObj ? data.ropes[n].anchorObj: '',
                    model: data.ropes[n].model ? data.ropes[n].model: '',
                    offset: { x: data.ropes[n].offset.x, y: data.ropes[n].offset.y, z: data.ropes[n].offset.z },
                    size: { x: data.ropes[n].size.x, y: data.ropes[n].size.y, z: data.ropes[n].size.z },
                    eqA: { x: data.ropes[n].eqA.x, y: data.ropes[n].eqA.y, z: data.ropes[n].eqA.z },
                    eqPts: { x: data.ropes[n].eqPts.x, y: data.ropes[n].eqPts.y, z: data.ropes[n].eqPts.z },
                    initPts: { x: data.ropes[n].initPts.x, y: data.ropes[n].initPts.y, z: data.ropes[n].initPts.z },
                    initA: { x: data.ropes[n].initA.x, y: data.ropes[n].initA.y, z: data.ropes[n].initA.z, w: data.ropes[n].initA.w },
                    limit: { x: data.ropes[n].limit.x, y: data.ropes[n].limit.y, z: data.ropes[n].limit.z },
                    limitA: { x: data.ropes[n].limitA.x, y: data.ropes[n].limitA.y, z: data.ropes[n].limitA.z },
                    mass: data.ropes[n].mass,
                    shape: data.ropes[n].shape ? data.ropes[n].shape : 0,
                    softness: data.ropes[n].softness,
                    damping: data.ropes[n].damping,
                    motorforce: data.ropes[n].motorforce,
                    bounce: data.ropes[n].bounce
                });
            }
        }

        if(data.spiders){

            for (let n = 0; n < data.spiders.length; n++) {
                
                this.track.spiderDefs.push({   ptIdx: data.spiders[n].ptIdx, 
                                            model: data.spiders[n].model, 
                                            shotModel: data.spiders[n].shotModel, 
                                            activation: data.spiders[n].activation, 
                                            offset: { x: data.spiders[n].offset.x, y: data.spiders[n].offset.y, z: data.spiders[n].offset.z }, 
                                            size: { x: data.spiders[n].size.x, y: data.spiders[n].size.y, z: data.spiders[n].size.z }, 
                                            angle: { x: data.spiders[n].angle.x, y: data.spiders[n].angle.y, z: data.spiders[n].angle.z }, 
                                            projSize: data.spiders[n].projSize, 
                                            projMass: data.spiders[n].projMass, 
                                            projSpeed: data.spiders[n].projSpeed, 
                                            projDelay: data.spiders[n].projDelay, 
                                            skel : data.skel,
                                            projSND: data.spiders[n].projSND });
            }

        }




        if (data.terrain.hm) {
            this.track.HM = { file: data.terrain.hm.file, scale: { x: data.terrain.hm.scale.x, y: data.terrain.hm.scale.y, z: data.terrain.hm.scale.z }, pos: { x: data.terrain.hm.pos.x, y: data.terrain.hm.pos.y, z: data.terrain.hm.pos.z } };
        }

        if (data.roadMat) {

            this.track.roadTex2 = data.roadMat.st;
            this.track.roadNorm2 = data.roadMat.sn;
            this.track.fxMapTex = data.roadMat.f && data.roadMat.f.length >0 ?data.roadMat.f : null ;

            this.track.roadTex = data.roadMat.t;
            this.track.roadAlpha = data.roadMat.a ? data.roadMat.a : null;
            this.track.roadNorm = data.roadMat.n;
            this.track.roadDisp = data.roadMat.d;
            this.track.roadSpec = data.roadMat.s;
            this.track.roadEmm = data.roadMat.e;
            this.track.roadRought = data.roadMat.r;
            this.track.roadHeight = data.roadMat.h;
            this.track.roadTexScale = { x: data.roadMat.scale.x, y: data.roadMat.scale.y };

            if(data.roadMat.params){
                this.track.roadParams.reflectivity= data.roadMat.params.reflectivity;
                this.track.roadParams.metalness= data.roadMat.params.metalness;
                this.track.roadParams.roughness= data.roadMat.params.roughness;
                this.track.roadParams.envMapIntensity= data.roadMat.params.envMapIntensity;
            }else{
                this.track.roadParams.reflectivity= 0.1;
                this.track.roadParams.metalness= 0.1;
                this.track.roadParams.roughness= 0.4;
                this.track.roadParams.envMapIntensity= 0.45;
            }

        }
        else {

            this.track.roadTex2 = null;
            this.track.fxMapTex = null;
            this.track.roadNorm2 = null;
            this.track.roadAlpha = null;
            this.track.roadTex = 'mud.jpg';
            this.track.roadNorm = 'mud_n.png';
            this.track.roadSpec = 'mud_s.png';
            this.track.roadEmm = '';
            this.track.roadRought = '';
            this.track.roadHeight = '';
            this.track.roadTexScale = { x: 2, y: 4 };

            this.track.roadParams.reflectivity= 0.1;
            this.track.roadParams.metalness= 0.1;
            this.track.roadParams.roughness= 0.4;
            this.track.roadParams.envMapIntensity= 0.45;
        }

        this.track.terrain = { name: data.terrain.name, fxmap: data.terrain.fxmap ? data.terrain.fxmap : null , lightMap: data.lightmap, minimap: data.terrain.minimap?data.terrain.minimap : null, offset:{x:0,y:0,z:0} };
        this.track.terrain.waterFlows = [];
        this.track.terrain.grasses = [];
        this.track.terrain.cyls = [];
        this.track.terrain.cubes = [];
        this.track.terrain.spheres = [];
        this.track.terrain.movingTerrain = [];
        this.track.terrain.blinks = [];
        this.track.terrain.lights = [];
        

        this.track.doCenter();

        for (let n = 0; n <this.track.trackPoints.length; n++) {
            this.track.trackPoints[n].pos.x = (this.track.trackPoints[n].pos.x) * this.track.gscale;
            this.track.trackPoints[n].pos.y = (this.track.trackPoints[n].pos.y) * this.track.gscale;
            this.track.trackPoints[n].pos.z = (this.track.trackPoints[n].pos.z) * this.track.gscale;
        }

        for (let n = 0; n < this.track.colcubes.length; n++) {
            this.track.colcubes[n].pos.x += this.track.terrain.offset.x;
            this.track.colcubes[n].pos.y += this.track.terrain.offset.y;
            this.track.colcubes[n].pos.z += this.track.terrain.offset.z;
        }
        /*
        for(let n of this.track.navmeshs){
            n.pos.x += this.track.terrain.offset.x;
            n.pos.y += this.track.terrain.offset.y;
            n.pos.z += this.track.terrain.offset.z;
        }
            */
        //this.track.NPoints = 100;

        if (data.wall)
            this.track.wallName = data.wall.name;
        else
            this.track.wallName = 'Crystal';




        this.track.createTrackMesh(new THREE.Vector2(0, 0), new THREE.Vector2(1, 1));
        
        this.track.createTrackWalls();
    }

    
    createChar(charDef) {

        return new Character(0, charDef);
    }

    carId;
    cars;
    track;
}




async function getChassisExtents(engine) {
           
    let extents = {};

    for (let chassisName in meshsInfos) {

        

        const object = await engine.objLoader.loadAsync(engine.assetBase +"/assets/mesh/" + chassisName + ".obj");
        object.traverse((child) => {

            if (child.type == 'Mesh') {

                child.geometry.computeBoundingBox();

                meshsInfos[chassisName].size = new THREE.Vector3();
                meshsInfos[chassisName].center = new THREE.Vector3();

                child.geometry.boundingBox.getSize(meshsInfos[chassisName].size);
                child.geometry.boundingBox.getCenter(meshsInfos[chassisName].center);

                extents[chassisName] = { extents: { size: meshsInfos[chassisName].size, center: meshsInfos[chassisName].center } };
            }
        });
    }

    console.log(JSON.stringify(extents));
}

function getGeoBuffer(o){

    const g = o.geometry.toNonIndexed();
    g.translate(o.position.x, o.position.y, o.position.z);

    const buffer = new Float32Array(g.attributes.position.array.length);
    for(let n=0;n<g.attributes.position.count;n++){

        buffer[n* 3 + 0] =g.attributes.position.array[n * 3 + 0];
        buffer[n* 3 + 1] =g.attributes.position.array[n * 3 + 1];
        buffer[n* 3 + 2] =g.attributes.position.array[n * 3 + 2];
    }
    const chars = new Uint8Array(buffer.buffer);
    console.log(buffer);
    console.log(btoa( String.fromCharCode.apply( null, chars ) ));

}

async function getObjBuffer(engine, objs){

    for(let obj of objs){
        const object = await engine.objLoader.loadAsync(engine.assetBase +"/assets/mesh/" + obj + ".obj");

        object.traverse(child => {
    
            if(!child.isMesh)
                return;

            console.log(child.name);
            getGeoBuffer(child);
        });
    
    }
}


async function buildGround(engine, file){

    const world = new CircuitRace();
    await world.loadTrack(file, engine.assetBase);
    const track = world.track;

    const self = this;
    if(track.terrain.name.endsWith('.glb')){
        const arr = track.terrain.name.split('.');
        const manager = new THREE.LoadingManager();
        const gltf = await engine.loadGLTF(arr[0], manager, null);
        track.terrain.mesh = engine.deGroupGLB(gltf);
    }
    else
        track.terrain.mesh = await engine.objLoader.loadAsync(engine.assetBase +"/assets/mesh/" +  track.terrain.name + ".obj");
    
    track.terrain.mesh.traverse(child => {

        if(!child.isMesh)
            return;

        if (child.name === 'Plane'){
            

            console.log('buffer for ' + file);
            getGeoBuffer(child);
        }
    });
}

async function buildGrounds(engine, grounds){

    for(let g of grounds){
        buildGround(engine, g);
    }

}


/*


    function getAssetImage(item: any, type:string) {
        if (type == 'cars') {

            if (item.chassis == 'car1')
                return 'car1.png';

            if (item.chassis == 'car2')
                return 'car2.png';

        

            if (item.chassis == 'car3'){

                let fileName = item.chassis;

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }

            
            if (item.chassis == 'wuf'){

                let fileName = item.chassis;

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }
        
            if (item.chassis == 'car4'){

                let fileName = item.chassis;

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }

            if (item.chassis == 'buggy'){
                let fileName = item.chassis;

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }

            if (item.chassis == 'davinci'){

                let fileName = item.chassis;

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }

            if (item.chassis == 'car5')
                return 'car4.gif';



            if (item.chassis == 'buggyB'){

                let fileName = item.chassis;

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }

            if (item.chassis == 'lambo'){

                let fileName = item.chassis;

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }

            if (item.chassis == 'toradyne'){

                let fileName = 'toradyne';

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }
            return null;
        }

        
        if (type == 'weapons') {
            if (item === null)
                return null;

            if (item.model == 'car_cannon')
                return 'car_cannon.gif';    
        }


        if (type == 'batteries') {
            if (item === null)
                return null;

            if (item.model == 'battery1')
                return 'battery1.gif';    
        }

        if (type == 'radars') {
            if (item === null)
                return null;

            if (item.model == 'radar1')
                return 'radar1.gif';    
        }

        if (type == 'tires') {

            if (item === null)
                return null;
            if (item .tire=== null)
                return null;
            if (item.tire == 'tire')
                return 'tire.gif';                

            if (item.tire == 'tire1')
                return 'tire1.gif';

            if (item.tire == 'tire2')
                return 'tire2.gif';

            if (item.tire == 'tire3')
                return 'tire3.gif';

            if (item.tire == 'tire4')
                return 'tire4.gif';

            if (item.tire == 'tire5')
                return 'tire5.gif';                

            if (item.tire == 'tire6')
                return 'tire6.gif';

            if (item.tire == 'tirew')
                return 'tirew.gif';                
            return null;
        }

        if (type == 'motors') {

            if (item === null)
                return null;
            if (item .motor=== null)
                return null;
            if (item.motor == 'motor1')
                return 'motor1.gif';

            if (item.motor == 'motor2')
                return 'motor2.gif';

            return 'motor1.gif';
        }
    }

*/

    
  function  getCarImageName(item) {

        const cars = ['nop','nop','car3', 'car4', 'buggy', 'davinci', 'wuf', 'viper', 'cocc']
        const tires = ['tire','tire1','tire2','tire3','tire4','tire5','tire6','tirew','tiredrift','tirerally','tirebuggy']
        const motors = ['motor1'];
        const batteries = ['battery1'];
        const radars = ['radar1'];
        const weapons = ['cannon'];

        const cidx = cars.indexOf(item.chassis);
        let tidx = item.suspension ? tires.indexOf(item.suspension.tire): 0;
        let midx = item.motor ? motors.indexOf(item.motor.motor): 0;
        let bidx = item.battery ? batteries.indexOf(item.battery.model):0;
        let ridx = item.radar ? radars.indexOf(item.radar.model):0;
        let widx = item.weapon ? weapons.indexOf(item.weapon.model):0;

        if((cidx<0)||(tidx<0)||(midx<0)||(bidx<0)||(ridx<0)||(widx<0))
            return null;

        if(item.suspension)
            tidx++;

        if(item.motor)
            midx++;

        if(item.battery)
            bidx++;

        if(item.radar)
            ridx++;

        if(item.weapon)  
            widx++;        
        
        return 'c'+cidx+'t'+tidx+'m'+midx+'b'+bidx+'r'+ridx+'w'+widx;
    }

  function  getAssetImage(item, type) {
        if (type == 'cars') {

            const iname = getCarImageName(item);

            if(iname !== null)
                return 'new/'+iname+'.gif';

            if (item.chassis == 'car1')
                return 'car1.png';

            if (item.chassis == 'car2')
                return 'car2.png';

            if (item.chassis == 'buggyB'){

                let fileName = item.chassis;

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }

            if (item.chassis == 'lambo'){

                let fileName = item.chassis;

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }

            if (item.chassis == 'toradyne'){

                let fileName = 'toradyne';

                if(item.motor)
                    fileName += '_'+item.motor.motor;

                if(item.suspension)
                    fileName += '_'+item.suspension.tire;

                return fileName+'.gif';
            }
            return null;
        }

        
        if (type == 'weapons') {
            if (item === null)
                return null;

            if (item.model == 'cannon')
                return 'car_cannon.gif';    
        }


        if (type == 'batteries') {
            if (item === null)
                return null;

            if (item.model == 'battery1')
                return 'battery1.gif';    
        }

        if (type == 'radars') {
            if (item === null)
                return null;

            if (item.model == 'radar1')
                return 'radar1.gif';    
        }

        if (type == 'tires') {

            if (item === null)
                return null;

            if (item.tire == 'tire')
                return 'tire.gif';                

            if (item.tire == 'tire1')
                return 'tire1.gif';

            if (item.tire == 'tire2')
                return 'tire2.gif';

            if (item.tire == 'tire3')
                return 'tire3.gif';

            if (item.tire == 'tire4')
                return 'tire4.gif';

            if (item.tire == 'tire5')
                return 'tire5.gif';                

            if (item.tire == 'tire6')
                return 'tire6.gif';

            if (item.tire == 'tirew')
                return 'tirew.gif';                

            if (item.tire == 'tiredrift')
                return 'tiredrift.gif';                

            if (item.tire == 'tirerally')
                return 'tirerally.gif';                

            return null;
        }

        if (type == 'motors') {

            if (item === null)
                return null;

            if (item.motor == 'motor1')
                return 'motor1.gif';

            if (item.motor == 'motor2')
                return 'motor2.gif';

            return 'motor1.gif';
        }
    }


export { CircuitRace, SkelAnimation, Track, PathFinder, Car, Character, keysActions, getAssetImage , getCarImageName, getChassisExtents,buildGrounds, buildGround, getObjBuffer, cars,freecars,  getTimeTxt , sleep, demo_cars_wax, ai_cars_wax};